webpackJsonp([1],{

/***/ 10:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var serialijse_1 = __webpack_require__(250);
var models_1 = __webpack_require__(55);
var FormatConfig = (function () {
    function FormatConfig() {
    }
    return FormatConfig;
}());
exports.FormatConfig = FormatConfig;
var ConfigService = (function () {
    function ConfigService(router) {
        this.router = router;
        this.dpiMin = 60; // prima era 72dpi
        this.inchToCm = 2.54;
        this.RappRisoluzMin = this.dpiMin / this.inchToCm; // 28.346; // = 72dpi/2.54
        this.isModeZodio = false;
        this.imageMap = [];
        this.topAffixOffset = 42;
        this.campionarioPrice = 20;
        // Parametri da passare come pre-filtri al cambio di prodotto
        this.paramsToSaveKeys = [
            'FormatoGruppo',
            'Formato',
            'FormatoOrientamento',
            // 'ListaFormati', // no perchè cambia il prezzo tra un prodotto e l'altro
            'Cornice',
            'SistemaFissaggio'
        ];
        this.debug = "build" !== 'build';
        // this.debug = false;
        this.urlHost = this.debug
            ? 'http://localhost:57136/' // ? 'http://www.topcolor.it/'
            : 'https://shop.topcolor.it/';
        // URLS
        var apiHost = this.debug
            ? 'http://localhost:64571/' // ? 'http://api.ctopcolor.coriweb.it/'
            : 'https://api.topcolor.it/';
        var filesHost = this.debug
            ? 'http://localhost:57136/files/' // ? 'http://www.topcolor.it/files/'
            : 'https://shop.topcolor.it/files/';
        this.outputBaseUrl = this.debug
            ? this.urlHost + '{lang}/configurator-output'
            : '/{lang}/configurator-output';
        this.apiUrl = apiHost + "api";
        this.imagesUrl = this.urlHost + "Content/images/configurator";
        this.partialsUrl = filesHost + "app/partials";
        this.pdfUrl = filesHost + "pdf";
        this.i18nUrl = filesHost + "i18n";
        this.braintreeTokenUrl = this.urlHost + "/generate-braintree-token.axd";
        // PaymentOption
        this.paymentOptions = [
            { key: models_1.PaymentType.Braintree, name: 'Paypal o carta di credito' },
            { key: models_1.PaymentType.Bank, name: 'Bonifico bancario' }
        ];
        // PaymentOption Campionario
        this.paymentOptionsCampionario = [
            { key: models_1.PaymentType.Braintree, name: 'Paypal o carta di credito' },
            { key: models_1.PaymentType.Bank, name: 'Bonifico bancario' }
        ];
        // DeliveryOption
        this.deliveryOptions = [
            { id: 1, name: 'Corriere Espresso' },
            { id: 2, name: 'Ritiro in Sede' }
        ];
        // DeliveryPrice BARTOLINI ITALIA
        this.deliveryPricesItaly = [
            { rangeMinKg: 0, rangeMaxKg: 3, price: 6.9 },
            { rangeMinKg: 3, rangeMaxKg: 10, price: 9.3 },
            { rangeMinKg: 10, rangeMaxKg: 20, price: 11.7 },
            { rangeMinKg: 20, rangeMaxKg: 30, price: 14.4 },
            { rangeMinKg: 30, rangeMaxKg: 999, price: 16.5 }
        ];
        // DeliveryPrice BARTOLINI ESTERO
        // this.deliveryPricesEXT = deliveryPricesEXTJS;
        this.deliveryPricesEXT = [
            { nation: 'Germania', range_0_5kg: 10.35, range_5_15kg: 12.65, range_15_31_5kg: 16.70, oltre_31_5kg_alKG: 0.36 },
            { nation: 'Austria', range_0_5kg: 10.35, range_5_15kg: 13.85, range_15_31_5kg: 16.65, oltre_31_5kg_alKG: 0.40 },
            { nation: 'Olanda', range_0_5kg: 11.40, range_5_15kg: 16.25, range_15_31_5kg: 19.65, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Belgio', range_0_5kg: 10.35, range_5_15kg: 15.50, range_15_31_5kg: 18.60, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Lussemburgo', range_0_5kg: 10.35, range_5_15kg: 15.50, range_15_31_5kg: 18.60, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Bosnia and Herz.- Croazia', range_0_5kg: 14.05, range_5_15kg: 19.30, range_15_31_5kg: 26.20, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Ungheria', range_0_5kg: 12.60, range_5_15kg: 19.30, range_15_31_5kg: 23.40, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Montenegro', range_0_5kg: 14.25, range_5_15kg: 20.00, range_15_31_5kg: 27.70, oltre_31_5kg_alKG: 0.48 },
            { nation: 'Serbia', range_0_5kg: 14.05, range_5_15kg: 19.30, range_15_31_5kg: 26.20, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Slovacchia', range_0_5kg: 14.05, range_5_15kg: 18.65, range_15_31_5kg: 21.60, oltre_31_5kg_alKG: 0.44 },
            { nation: 'Slovenia', range_0_5kg: 13.70, range_5_15kg: 19.20, range_15_31_5kg: 25.30, oltre_31_5kg_alKG: 0.48 },
            { nation: 'Gran Bretagna-Isole Channel', range_0_5kg: 11.35, range_5_15kg: 16.60, range_15_31_5kg: 19.65, oltre_31_5kg_alKG: 0.50 },
            { nation: 'Spagna', range_0_5kg: 11.40, range_5_15kg: 16.60, range_15_31_5kg: 19.65, oltre_31_5kg_alKG: 0.40 },
            { nation: 'Francia(con P. di Monaco)', range_0_5kg: 11.40, range_5_15kg: 15.05, range_15_31_5kg: 19.25, oltre_31_5kg_alKG: 0.36 },
            { nation: 'Portogallo - Isole Baleari', range_0_5kg: 18.60, range_5_15kg: 24.00, range_15_31_5kg: 28.25, oltre_31_5kg_alKG: 0.51 },
            { nation: 'Irlanda, Rep.', range_0_5kg: 31.75, range_5_15kg: 35.80, range_15_31_5kg: 41.50, oltre_31_5kg_alKG: 0.52 },
            { nation: 'Irlanda del Nord', range_0_5kg: 31.75, range_5_15kg: 35.80, range_15_31_5kg: 41.50, oltre_31_5kg_alKG: 0.65 },
            { nation: 'Svizzera - Liechtenstein', range_0_5kg: 15.15, range_5_15kg: 22.45, range_15_31_5kg: 49.45, oltre_31_5kg_alKG: 1.23 },
            { nation: 'Polonia', range_0_5kg: 13.70, range_5_15kg: 19.20, range_15_31_5kg: 28.15, oltre_31_5kg_alKG: 0.60 },
            { nation: 'Danimarca', range_0_5kg: 18.15, range_5_15kg: 21.65, range_15_31_5kg: 26.65, oltre_31_5kg_alKG: 0.35 },
            { nation: 'Estonia', range_0_5kg: 28.05, range_5_15kg: 32.55, range_15_31_5kg: 38.45, oltre_31_5kg_alKG: 0.35 },
            { nation: 'Lettonia - Lituania', range_0_5kg: 28.05, range_5_15kg: 32.55, range_15_31_5kg: 38.45, oltre_31_5kg_alKG: 0.35 },
            { nation: 'Svezia', range_0_5kg: 19.65, range_5_15kg: 23.30, range_15_31_5kg: 27.45, oltre_31_5kg_alKG: 0.35 },
            { nation: 'Finlandia', range_0_5kg: 21.25, range_5_15kg: 26.60, range_15_31_5kg: 30.75, oltre_31_5kg_alKG: 0.35 },
            { nation: 'Norvegia', range_0_5kg: 41.85, range_5_15kg: 46.45, range_15_31_5kg: 52.20, oltre_31_5kg_alKG: 0.35 },
            { nation: 'Rep.Ceca', range_0_5kg: 11.45, range_5_15kg: 18.65, range_15_31_5kg: 21.95, oltre_31_5kg_alKG: 0.55 },
            { nation: 'Corsica', range_0_5kg: 49.70, range_5_15kg: 53.15, range_15_31_5kg: 57.50, oltre_31_5kg_alKG: 0.96 },
            { nation: 'Azzorre - Madeira', range_0_5kg: 41.40, range_5_15kg: 48.10, range_15_31_5kg: 52.45, oltre_31_5kg_alKG: 2.29 },
            {
                nation: 'Andorra - Isole Canarie Ceuta- Melilla', range_0_5kg: 67.75, range_5_15kg: 72.15, range_15_31_5kg: 76.95,
                oltre_31_5kg_alKG: 2.29
            }
        ];
        this.deliveryFissi = ['Fine-art', 'Carta cotone stampa', 'Carta fotografica stampa'];
        // CICLO LE ROTTE per creare i pulsanti laterali
        this.btnToggles = [];
        for (var i = 1; i < this.router.config.length; i++) {
            var routerId = null;
            var routerSort = null;
            var routerUrl = this.router.config[i].path;
            var routerTitle = null;
            var routerIsMenu = false;
            var isActive = true;
            if (this.router.config[i].data !== undefined) {
                routerId = this.router.config[i].data['id'];
                routerSort = this.router.config[i].data['sort'];
                routerTitle = this.router.config[i].data['title'];
                routerIsMenu = this.router.config[i].data['isMenu'];
                // isActive = this.GetIsActiveMenu(routerUrl);
                isActive = true;
            }
            var newBtn = {
                id: routerId,
                sort: routerSort,
                url: routerUrl,
                text: routerTitle,
                isMenu: routerIsMenu,
                isParameter: false,
                isActive: true
            };
            if (newBtn !== undefined) {
                this.btnToggles.push(newBtn);
            }
        }
        this.btnToggles = this.btnToggles.filter(function (r) { return r.isMenu === true; }); // .sort(r => r.sort * -1);
        this.btnToggles = this.btnToggles.sort(function (a, b) {
            if (a.sort < b.sort) {
                return -1;
            }
            else if (a.sort > b.sort) {
                return 1;
            }
            else {
                return 0;
            }
        });
        // Categories
        this.models = [
            { id: 6, url: 'acrilico', name: 'Acrilico', resx: '', hasPackage: false },
            { id: 5, url: 'alluminio', name: 'Alluminio', resx: '', hasPackage: false },
            { id: 8, url: 'legno', name: 'Legno', resx: '', hasPackage: false },
            { id: 7, url: 'tela', name: 'Tela', resx: '', hasPackage: false },
            { id: 10, url: 'forex', name: 'Forex', resx: '', hasPackage: false },
            { id: 4, url: 'carte-e-supporti', name: 'Carte e Supporti', resx: '', hasPackage: false },
            { id: 9, url: 'zodio', name: 'Zodio', resx: '', hasPackage: false },
        ];
        // Products
        this.products = [
            {
                id: 33, idModel: 6, url: 'acrilico-1', resx: '', hasPackage: false,
                name: 'Stampa su vetro acrilico 5 mm con bianco',
                xml: 'acrilico'
            },
            {
                id: 27, idModel: 6, url: 'acrilico-2', resx: '', hasPackage: false,
                name: 'Stampa Topsec ® 3/5 mm',
                xml: 'topsec'
            },
            {
                id: 25, idModel: 5, url: 'alluminio-2', resx: '', hasPackage: false,
                name: 'Stampa diretta su alluminio Dibond bianco 3 mm',
                xml: 'dibond'
            },
            {
                id: 26, idModel: 5, url: 'alluminio-1', resx: '', hasPackage: false,
                name: 'Stampa diretta su alluminio Dibond grigio spazzolato 3 mm',
                xml: 'dibond_spazzolato'
            },
            {
                id: 24, idModel: 5, url: 'alluminio-3', resx: '', hasPackage: false,
                name: 'Stampa diretta su lamina di alluminio bianco 1 mm',
                xml: 'lamina_alluminio'
            },
            {
                id: 34, idModel: 5, url: 'alluminio-4', resx: '', hasPackage: false,
                name: 'Accoppiamento carta fotografica/cotone su alluminio Dibond 3 mm',
                xml: 'carta_accoppiata',
                preFilters: [
                    {
                        key: 'AccoppiamentoPannello',
                        values: ['Dibond'],
                        selectedValue: 'Dibond',
                        showOnlyThis: true
                    },
                    {
                        key: 'AccoppiamentoCarta',
                        values: ['Fotografica', 'Cotone'],
                        selectedValue: 'Fotografica'
                    }
                ]
            },
            {
                id: 31, idModel: 8, url: 'legno-2', resx: '', hasPackage: false,
                name: 'Stampa diretta su legno 14 mm',
                xml: 'legno'
            },
            {
                id: 32, idModel: 8, url: 'legno-1', resx: '', hasPackage: false,
                name: 'Accoppiamento carta fotografica/cotone su legno 14 mm',
                xml: 'carta_accoppiata',
                preFilters: [
                    {
                        key: 'AccoppiamentoPannello',
                        values: ['Legno'],
                        selectedValue: 'Legno',
                        showOnlyThis: true
                    },
                    {
                        key: 'AccoppiamentoCarta',
                        values: ['Fotografica', 'Cotone'],
                        selectedValue: 'Fotografica'
                    }
                ]
            },
            {
                id: 29, idModel: 7, url: 'tela-1', resx: '', hasPackage: false,
                name: 'Stampa su tela pittorica con telaio',
                xml: 'tela_pittorica_telaio'
            },
            {
                id: 28, idModel: 7, url: 'tela-2', resx: '', hasPackage: false,
                name: 'Stampa su tela pittorica',
                xml: 'tela_pittorica'
            },
            { id: 22, idModel: 4, url: 'carta-fotografica', resx: '', hasPackage: false, name: 'Carta fotografica', xml: 'carta_fotografica' },
            { id: 23, idModel: 4, url: 'carta-cotone', resx: '', hasPackage: false, name: 'Carta cotone', xml: 'carta_cotone' },
            {
                id: 30, idModel: 4, url: 'possibili-accoppiamenti', resx: '', hasPackage: false,
                name: 'Possibili accoppiamenti ',
                xml: 'carta_accoppiata',
                preFilters: [
                    {
                        key: 'AccoppiamentoPannello',
                        values: ['Dibond', 'Forex', 'Simona', 'Legno'],
                        selectedValue: 'Dibond'
                    }
                ]
            },
            {
                id: 35, idModel: 10, url: 'forex', resx: '', hasPackage: false,
                name: 'Stampa diretta su Forex 5 mm',
                xml: 'forex'
            },
            // ZODIO PRODUCTS:
            //
            // PLEXI 3MM
            // DIBOND 3MM
            // CART FOT + FOREX 5
            // CART FOT + SIMO 10
            // CART FOT + SIMO 20
            // LEGNO MASSELLO DIRET.
            // TELA PITTORICA CON
            {
                id: 90, idModel: 9, url: 'zodio_plexi', resx: '', hasPackage: false,
                name: 'PLEXI 3MM',
                xml: 'zodio_plexi'
            },
            {
                id: 91, idModel: 9, url: 'zodio_dibond', resx: '', hasPackage: false,
                name: 'DIBOND 3MM',
                xml: 'zodio_dibond'
            },
            {
                id: 92, idModel: 9, url: 'zodio_carta_accoppiata', resx: '', hasPackage: false,
                name: 'CART FOTOGRAFICA ACCOPPIATA',
                xml: 'zodio_carta_accoppiata'
            },
            {
                id: 93, idModel: 9, url: 'zodio_legno', resx: '', hasPackage: false,
                name: 'LEGNO MASSELLO',
                xml: 'zodio_legno'
            },
            {
                id: 94, idModel: 9, url: 'zodio_tela_pittorica_telaio', resx: '', hasPackage: false,
                name: 'TELA PITTORICA CON TELAIO',
                xml: 'zodio_tela_pittorica_telaio'
            },
        ];
        // Nazioni di Spedizione
        this.shipmentNations = [
            { id: 'AT', name: 'Austria' },
            { id: 'BE', name: 'Belgio' },
            { id: 'DK', name: 'Danimarca' },
            { id: 'EE', name: 'Estonia' },
            { id: 'FI', name: 'Finlandia' },
            { id: 'DE', name: 'Germania' },
            { id: 'GR', name: 'Grecia' },
            { id: 'IT', name: 'Italia' },
            { id: 'LV', name: 'Lettonia' },
            { id: 'LT', name: 'Lituania' },
            { id: 'LU', name: 'Lussemburgo' },
            { id: 'NL', name: 'Paesi Bassi' },
            { id: 'PL', name: 'Polonia' },
            { id: 'PT', name: 'Portogallo' },
            { id: 'CZ', name: 'Repubblica Ceca' },
            { id: 'SK', name: 'Slovacchia' },
            { id: 'SI', name: 'Slovenia' },
            { id: 'ES', name: 'Spagna' },
            { id: 'SE', name: 'Svezia' },
            { id: 'HU', name: 'Ungheria' },
        ];
    }
    ConfigService.prototype.setPersistable = function () {
        serialijse_1.declarePersistable(models_1.Cart);
        serialijse_1.declarePersistable(models_1.CartProduct);
        serialijse_1.declarePersistable(models_1.Address);
        serialijse_1.declarePersistable(models_1.Customer);
        serialijse_1.declarePersistable(models_1.ModelConfig);
        serialijse_1.declarePersistable(models_1.Param);
    };
    ConfigService.prototype.getProductConfigFromName = function (prodname) {
        return this.products.filter(function (x) { return x.name === prodname; })[0];
    };
    ConfigService.prototype.getProductConfigFromIdProduct = function (idProduct) {
        return this.products.filter(function (x) { return x.id === idProduct; })[0];
    };
    ConfigService.prototype.getProductFromIdCateg = function (idModel) {
        return this.products.filter(function (x) { return x.idModel === idModel; });
    };
    ConfigService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [router_1.Router])
    ], ConfigService);
    return ConfigService;
}());
exports.ConfigService = ConfigService;


/***/ },

/***/ 100:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__reactive_errors__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__form_group_directive__ = __webpack_require__(99);
/* unused harmony export formGroupNameProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroupName; });
/* unused harmony export formArrayNameProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormArrayName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var /** @type {?} */ formGroupNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 *  *
  * *
  * This directive can only be used with a parent {@link FormGroupDirective} (selector:
  * `[formGroup]`).
  * *
  * It accepts the string name of the nested {@link FormGroup} you want to link, and
  * will look for a {@link FormGroup} registered with that name in the parent
  * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
  * *
  * Nested form groups can come in handy when you want to validate a sub-group of a
  * form separately from the rest or when you'd like to group the values of certain
  * controls into their own nested object.
  * *
  * **Access the group**: You can access the associated {@link FormGroup} using the
  * {@link AbstractControl.get} method. Ex: `this.form.get('name')`.
  * *
  * You can also access individual controls within the group using dot syntax.
  * Ex: `this.form.get('name.first')`
  * *
  * **Get the value**: the `value` property is always synced and available on the
  * {@link FormGroup}. See a full list of available properties in {@link AbstractControl}.
  * *
  * **Set the value**: You can set an initial value for each child control when instantiating
  * the {@link FormGroup}, or you can set it programmatically later using
  * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
  * *
  * **Listen to value**: If you want to listen to changes in the value of the group, you can
  * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
  * {@link AbstractControl.statusChanges} to be notified when the validation status is
  * re-calculated.
  * *
  * ### Example
  * *
  * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * * **NgModule**: `ReactiveFormsModule`
  * *
 */
var FormGroupName = (function (_super) {
    __extends(FormGroupName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormGroupName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /**
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].groupParentException();
        }
    };
    FormGroupName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
    ];
    /** @nocollapse */
    FormGroupName.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    FormGroupName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroupName',] },],
    };
    return FormGroupName;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
function FormGroupName_tsickle_Closure_declarations() {
    /** @type {?} */
    FormGroupName.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormGroupName.ctorParameters;
    /** @type {?} */
    FormGroupName.propDecorators;
    /** @type {?} */
    FormGroupName.prototype.name;
}
var /** @type {?} */ formArrayNameProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 *  *
  * *
  * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
  * `[formGroup]`).
  * *
  * It accepts the string name of the nested {@link FormArray} you want to link, and
  * will look for a {@link FormArray} registered with that name in the parent
  * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
  * *
  * Nested form arrays can come in handy when you have a group of form controls but
  * you're not sure how many there will be. Form arrays allow you to create new
  * form controls dynamically.
  * *
  * **Access the array**: You can access the associated {@link FormArray} using the
  * {@link AbstractControl.get} method on the parent {@link FormGroup}.
  * Ex: `this.form.get('cities')`.
  * *
  * **Get the value**: the `value` property is always synced and available on the
  * {@link FormArray}. See a full list of available properties in {@link AbstractControl}.
  * *
  * **Set the value**: You can set an initial value for each child control when instantiating
  * the {@link FormArray}, or you can set the value programmatically later using the
  * {@link FormArray}'s {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}
  * methods.
  * *
  * **Listen to value**: If you want to listen to changes in the value of the array, you can
  * subscribe to the {@link FormArray}'s {@link AbstractControl.valueChanges} event.  You can also
  * listen to its {@link AbstractControl.statusChanges} event to be notified when the validation
  * status is re-calculated.
  * *
  * **Add new controls**: You can add new controls to the {@link FormArray} dynamically by
  * calling its {@link FormArray.push} method.
  * Ex: `this.form.get('cities').push(new FormControl());`
  * *
  * ### Example
  * *
  * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * * **NgModule**: `ReactiveFormsModule`
  * *
 */
var FormArrayName = (function (_super) {
    __extends(FormArrayName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormArrayName(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.formDirective.getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            __WEBPACK_IMPORTED_MODULE_4__reactive_errors__["a" /* ReactiveErrors */].arrayParentException();
        }
    };
    FormArrayName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
    ];
    /** @nocollapse */
    FormArrayName.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    FormArrayName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formArrayName',] },],
    };
    return FormArrayName;
}(__WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */]));
function FormArrayName_tsickle_Closure_declarations() {
    /** @type {?} */
    FormArrayName.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormArrayName.ctorParameters;
    /** @type {?} */
    FormArrayName.propDecorators;
    /** @type {?} */
    FormArrayName.prototype._parent;
    /** @type {?} */
    FormArrayName.prototype._validators;
    /** @type {?} */
    FormArrayName.prototype._asyncValidators;
    /** @type {?} */
    FormArrayName.prototype.name;
}
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof __WEBPACK_IMPORTED_MODULE_6__form_group_directive__["a" /* FormGroupDirective */]) &&
        !(parent instanceof FormArrayName);
}
//# sourceMappingURL=form_group_name.js.map

/***/ },

/***/ 13:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var ng2_webstorage_1 = __webpack_require__(115);
var models_1 = __webpack_require__(55);
var config_service_1 = __webpack_require__(10);
var serialijse_1 = __webpack_require__(250);
var CartService = (function () {
    function CartService(router, config, storage) {
        this.router = router;
        this.config = config;
        this.storage = storage;
        this.cartLoaded = new core_1.EventEmitter();
    }
    CartService.prototype.cloneProduct = function () {
        var _this = this;
        var row = new models_1.CartProduct();
        row.config = this.cart.currentCartProduct.config;
        row.params = this.cart.currentCartProduct.params;
        row.format = this.cart.currentCartProduct.format;
        row.price = 0;
        // row.productName = 'CLONE: ' +  this.cart.currentCartProduct.productName;
        row.rounded = this.cart.currentCartProduct.rounded;
        if (this.cart.cartProducts.length === 0) {
            row.idRow = 1;
        }
        else {
            row.idRow = Math.max.apply(Math, this.cart.cartProducts.map(function (r) { return r.idRow; })) + 1;
        }
        row.photoOriginal = null;
        row.photoResized = null;
        row.photoBounds = null;
        row.photoID = null;
        row.quantity = 1;
        row.idProduct = this.cart.currentCartProduct.idProduct;
        this.cart.cartProducts.push(row);
        this.saveCart();
        this.cart.idCartRow = row.idRow;
        //console.log('cloneProduct' + this.cart.idCartRow);
        /* Per evitare: Failed to execute 'setItem' on 'Storage': Setting the value of 'ng2-webstorage|cart' exceeded the quota.
           ANCHE photoResized DOVREBBE ESSERE CANCELLATO, DOPO 4-5 IMG IN HD LocalStorage SI RIEMPE */
        this.cart.cartProducts.forEach(function (r) {
            if (r.idRow !== _this.cart.currentCartProduct.idRow) {
                r.photoOriginal = null;
            }
        });
    };
    CartService.prototype.addProduct = function (productId, qty) {
        var _this = this;
        var row = new models_1.CartProduct();
        if (this.cart.cartProducts.length === 0) {
            row.idRow = 1;
        }
        else {
            row.idRow = Math.max.apply(Math, this.cart.cartProducts.map(function (r) { return r.idRow; })) + 1;
        }
        row.idProduct = productId;
        row.config = this.config.getProductConfigFromIdProduct(productId);
        row.quantity = qty;
        row.rounded = false;
        // row.productName = 'Seleziona prodotto'; // this.config.products.find(r => r.id === productId).name;
        row.price = 0;
        this.cart.cartProducts.push(row);
        this.saveCart();
        this.cart.idCartRow = row.idRow;
        ////console.log('addProduct' + this.cart.idCartRow + ' - productId:' + productId);
        /* Per evitare: Failed to execute 'setItem' on 'Storage': Setting the value of 'ng2-webstorage|cart' exceeded the quota.
           ANCHE photoResized DOVREBBE ESSERE CANCELLATO, DOPO 4-5 IMG IN HD LocalStorage SI RIEMPE */
        this.cart.cartProducts.forEach(function (r) {
            if (r.idRow !== _this.cart.currentCartProduct.idRow) {
                r.photoOriginal = null;
            }
        });
    };
    CartService.prototype.removeCartRow = function (idRow) {
        //console.log('removeCartRow' + idRow);
        this.cart.cartProducts = this.cart.cartProducts.filter(function (r) { return r.idRow !== idRow; });
        this.saveCart();
    };
    CartService.prototype.saveCart = function () {
        //console.log('saveCart');
        this.storage.store('cart', serialijse_1.serialize(this.cart));
    };
    CartService.prototype.refreshQuantity = function (idRow, quantity) {
        var currentRow = this.cart.cartProducts.filter(function (r) { return r.idRow === idRow; })[0];
        if (currentRow != null) {
            if (quantity < 1) {
                this.removeCartRow(idRow);
            }
            currentRow.quantity = quantity;
        }
        this.saveCart();
    };
    CartService.prototype.cartCheckProducts = function (redirectControl) {
        if (redirectControl === void 0) { redirectControl = true; }
        //console.log('cartCheckProducts');
        // Aggiornare solo all'occorrenza per forzare il reset del carrello
        var currentVersionDate = 20170919;
        if (!this.cart
            || (this.cart.version === null || this.cart.version !== currentVersionDate)) {
            this.cart = new models_1.Cart();
            this.cart.version = currentVersionDate;
            this.cart.checkoutStepIndex = 1;
            this.cart.shipmentNations = this.config.shipmentNations;
            this.cart.SelDeliveryOption = this.config.deliveryOptions[0];
            this.cart.deliveryPricesItaly = this.config.deliveryPricesItaly;
            this.cart.deliveryPricesEXT = this.config.deliveryPricesEXT;
            this.cart.deliveryFissi = this.config.deliveryFissi;
        }
        if (!this.cart.cartProducts) {
            this.cart.cartProducts = [];
        }
        if (!this.cart.customer) {
            this.cart.customer = new models_1.Customer();
        }
        if (!this.cart.billing) {
            this.cart.billing = new models_1.Customer();
        }
        if (!this.cart.shipmentAddress) {
            this.cart.shipmentAddress = new models_1.Address();
            this.cart.shipmentAddress.Country = 'IT';
        }
        if (!this.cart.billingAddress) {
            this.cart.billingAddress = new models_1.Address();
        }
        if (!this.cart.SelDeliveryOption) {
            this.cart.SelDeliveryOption = this.config.deliveryOptions[0];
        }
        //console.log(this.cart.SelDeliveryOption.id);
        if (this.cart.idCartRow === null) {
            this.cart.idCartRow = 1;
        }
        if (!this.cart.cartProducts || this.cart.cartProducts.length === 0 || !this.cart.currentCartProduct) {
            ////console.log('no cartProducts - redirect to upload-photo + addProduct() in upload-photo-component');
            this.addProduct(this.config.products[0].id, 1);
            if (redirectControl) {
                this.router.navigate(['/upload-photo']);
            }
        }
        else {
            if (this.cart.currentCartProduct.params != null) {
                if (this.cart.cartProducts.length === 0 || this.cart.currentCartProduct.params.length === 0) {
                    if (redirectControl) {
                        this.router.navigate(['/upload-photo']);
                    }
                }
                else if (!this.cart.currentCartProduct) {
                    this.cart.idCartRow = this.cart.cartProducts[this.cart.cartProducts.length - 1].idRow;
                }
            }
        }
    };
    CartService.prototype.cartCheckCROPPED = function () {
        if (this.cart.cartProducts.some(this.cropMissing)) {
            this.router.navigate(['/slide-parameter/Formato']);
            window.scrollTo(0, 0);
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        }
    };
    CartService.prototype.cropMissing = function (element, index, array) {
        return !element.photoResized;
    };
    CartService.prototype.setFormat = function (format) {
        // SE CAMBIO FORMATO CANCELLO IL RITAGLIO PERCHè NON PIù VALIDO
        this.cart.currentCartProduct.photoResized = null;
        //console.log('setFormat - cambio formato - currentCartProduct.photoResized = null');
        this.cart.formatoSelected = true;
        this.cart.currentCartProduct.format = format.split('|')[0] + '|' + format.split('|')[1];
        this.setPesoVolumITA(format);
        this.setPesoVolumEXT(format);
    };
    CartService.prototype.setPesoVolumITA = function (format) {
        var width = Number(format.split('|')[2]);
        var height = Number(format.split('|')[3]);
        this.cart.currentCartProduct.pesoVolumITA = 0;
        if (this.config.deliveryFissi.indexOf(this.cart.currentCartProduct.productName) === -1) {
            this.cart.currentCartProduct.pesoVolumITA = (width + 8) * (height + 8) * 8 / 3333;
        }
    };
    CartService.prototype.setPesoVolumEXT = function (format) {
        var width = Number(format.split('|')[2]);
        var height = Number(format.split('|')[3]);
        this.cart.currentCartProduct.pesoVolumEXT = (width) * (height) * 8 / 5000;
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], CartService.prototype, "cartLoaded", void 0);
    CartService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [router_1.Router, config_service_1.ConfigService, ng2_webstorage_1.LocalStorageService])
    ], CartService);
    return CartService;
}());
exports.CartService = CartService;


/***/ },

/***/ 139:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(30);
/* unused harmony export CHECKBOX_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return CheckboxControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ CHECKBOX_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 *  The accessor for writing a value and listening to changes on a checkbox input element.
  * *
  * ### Example
  * ```
  * <input type="checkbox" name="rememberLogin" ngModel>
  * ```
  * *
  * @stable
 */
var CheckboxControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    CheckboxControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                    host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                    providers: [CHECKBOX_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    CheckboxControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return CheckboxControlValueAccessor;
}());
function CheckboxControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    CheckboxControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    CheckboxControlValueAccessor.ctorParameters;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype.onChange;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype._renderer;
    /** @type {?} */
    CheckboxControlValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=checkbox_value_accessor.js.map

/***/ },

/***/ 140:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(30);
/* unused harmony export DEFAULT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return DefaultValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ DEFAULT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 *  The default accessor for writing a value and listening to changes that is used by the
  * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
  * *
  * ### Example
  * ```
  * <input type="text" name="searchQuery" ngModel>
  * ```
  * *
  * @stable
 */
var DefaultValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function DefaultValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    DefaultValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                    // TODO: vsavkin replace the above selector with the one below it once
                    // https://github.com/angular/angular/issues/3011 is implemented
                    // selector: '[ngControl],[ngModel],[ngFormControl]',
                    host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [DEFAULT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    DefaultValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return DefaultValueAccessor;
}());
function DefaultValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    DefaultValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    DefaultValueAccessor.ctorParameters;
    /** @type {?} */
    DefaultValueAccessor.prototype.onChange;
    /** @type {?} */
    DefaultValueAccessor.prototype.onTouched;
    /** @type {?} */
    DefaultValueAccessor.prototype._renderer;
    /** @type {?} */
    DefaultValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=default_value_accessor.js.map

/***/ },

/***/ 141:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__ = __webpack_require__(311);
/* unused harmony export modelGroupProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModelGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var /** @type {?} */ modelGroupProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 *  *
  * *
  * This directive can only be used as a child of {@link NgForm} (or in other words,
  * within `<form>` tags).
  * *
  * Use this directive if you'd like to create a sub-group within a form. This can
  * come in handy if you want to validate a sub-group of your form separately from
  * the rest of your form, or if some values in your domain model make more sense to
  * consume together in a nested object.
  * *
  * Pass in the name you'd like this sub-group to have and it will become the key
  * for the sub-group in the form's full value. You can also export the directive into
  * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
  * *
  * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * * **NgModule**: `FormsModule`
  * *
 */
var NgModelGroup = (function (_super) {
    __extends(NgModelGroup, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgModelGroup(parent, validators, asyncValidators) {
        _super.call(this);
        this._parent = parent;
        this._validators = validators;
        this._asyncValidators = asyncValidators;
    }
    /**
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__ng_form__["a" /* NgForm */])) {
            __WEBPACK_IMPORTED_MODULE_5__template_driven_errors__["a" /* TemplateDrivenErrors */].modelGroupParentException();
        }
    };
    NgModelGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
    ];
    /** @nocollapse */
    NgModelGroup.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_3__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    NgModelGroup.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelGroup',] },],
    };
    return NgModelGroup;
}(__WEBPACK_IMPORTED_MODULE_2__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]));
function NgModelGroup_tsickle_Closure_declarations() {
    /** @type {?} */
    NgModelGroup.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgModelGroup.ctorParameters;
    /** @type {?} */
    NgModelGroup.propDecorators;
    /** @type {?} */
    NgModelGroup.prototype.name;
}
//# sourceMappingURL=ng_model_group.js.map

/***/ },

/***/ 142:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(310);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ReactiveErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
//# sourceMappingURL=reactive_errors.js.map

/***/ },

/***/ 143:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(30);
/* unused harmony export SELECT_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SelectControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgSelectOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ SELECT_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 *  *
  * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
  * to keep the view synced with the {@link FormControl} model.
  * *
  * *
  * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
  * value accessor will be active on any select control that has a form directive. You do
  * **not** need to add a special selector to activate it.
  * *
  * ### How to use select controls with form directives
  * *
  * To use a select in a template-driven form, simply add an `ngModel` and a `name`
  * attribute to the main `<select>` tag.
  * *
  * If your option values are simple strings, you can bind to the normal `value` property
  * on the option.  If your option values happen to be objects (and you'd like to save the
  * selection in your form as an object), use `ngValue` instead:
  * *
  * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
  * *
  * In reactive forms, you'll also want to add your form directive (`formControlName` or
  * `formControl`) on the main `<select>` tag. Like in the former example, you have the
  * choice of binding to the  `value` or `ngValue` property on the select's options.
  * *
  * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
  * *
  * Note: We listen to the 'change' event because 'input' events aren't fired
  * for selects in Firefox and IE:
  * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
  * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
  * *
  * * **npm package**: `@angular/forms`
  * *
 */
var SelectControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var /** @type {?} */ valueString = _buildValueString(this._getOptionId(value), value);
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString;
            fn(_this._getOptionValue(valueString));
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["e" /* looseIdentical */])(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /**
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    SelectControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                    host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                    providers: [SELECT_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return SelectControlValueAccessor;
}());
function SelectControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    SelectControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SelectControlValueAccessor.ctorParameters;
    /** @type {?} */
    SelectControlValueAccessor.prototype.value;
    /** @type {?} */
    SelectControlValueAccessor.prototype._optionMap;
    /** @type {?} */
    SelectControlValueAccessor.prototype._idCounter;
    /** @type {?} */
    SelectControlValueAccessor.prototype.onChange;
    /** @type {?} */
    SelectControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    SelectControlValueAccessor.prototype._renderer;
    /** @type {?} */
    SelectControlValueAccessor.prototype._elementRef;
}
/**
 *  *
  * *
  * See docs for {@link SelectControlValueAccessor} for usage examples.
  * *
 */
var NgSelectOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ]; };
    NgSelectOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectOption;
}());
function NgSelectOption_tsickle_Closure_declarations() {
    /** @type {?} */
    NgSelectOption.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgSelectOption.ctorParameters;
    /** @type {?} */
    NgSelectOption.propDecorators;
    /** @type {?} */
    NgSelectOption.prototype.id;
    /** @type {?} */
    NgSelectOption.prototype._element;
    /** @type {?} */
    NgSelectOption.prototype._renderer;
    /** @type {?} */
    NgSelectOption.prototype._select;
}
//# sourceMappingURL=select_control_value_accessor.js.map

/***/ },

/***/ 144:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__ = __webpack_require__(30);
/* unused harmony export SELECT_MULTIPLE_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return SelectMultipleControlValueAccessor; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgSelectMultipleOption; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_2__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["d" /* isPrimitive */])(value))
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 *  Mock interface for HTMLCollection
 * @abstract
 */
var HTMLCollection = (function () {
    function HTMLCollection() {
    }
    /**
     * @abstract
     * @param {?} _
     * @return {?}
     */
    HTMLCollection.prototype.item = function (_) { };
    return HTMLCollection;
}());
function HTMLCollection_tsickle_Closure_declarations() {
    /** @type {?} */
    HTMLCollection.prototype.length;
}
/**
 *  The accessor for writing a value and listening to changes on a select element.
  * *
 */
var SelectMultipleControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** @internal */
        this._optionMap = new Map();
        /** @internal */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["e" /* looseIdentical */])(this._optionMap.get(id)._value, value))
                return id;
        }
        return null;
    };
    /**
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
    };
    SelectMultipleControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                    host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                    providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    SelectMultipleControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return SelectMultipleControlValueAccessor;
}());
function SelectMultipleControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    SelectMultipleControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SelectMultipleControlValueAccessor.ctorParameters;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype.value;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype._optionMap;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype._idCounter;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype.onChange;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype._renderer;
    /** @type {?} */
    SelectMultipleControlValueAccessor.prototype._elementRef;
}
/**
 *  Marks `<option>` as dynamic, so Angular can be notified when options change.
  * *
  * ### Example
  * *
  * ```
  * <select multiple name="city" ngModel>
  * <option *ngFor="let c of cities" [value]="c"></option>
  * </select>
  * ```
 */
var NgSelectMultipleOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    NgSelectMultipleOption.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
    ];
    /** @nocollapse */
    NgSelectMultipleOption.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    ]; };
    NgSelectMultipleOption.propDecorators = {
        'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
    };
    return NgSelectMultipleOption;
}());
function NgSelectMultipleOption_tsickle_Closure_declarations() {
    /** @type {?} */
    NgSelectMultipleOption.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgSelectMultipleOption.ctorParameters;
    /** @type {?} */
    NgSelectMultipleOption.propDecorators;
    /** @type {?} */
    NgSelectMultipleOption.prototype.id;
    /** @type {?} */
    NgSelectMultipleOption.prototype._value;
    /** @type {?} */
    NgSelectMultipleOption.prototype._element;
    /** @type {?} */
    NgSelectMultipleOption.prototype._renderer;
    /** @type {?} */
    NgSelectMultipleOption.prototype._select;
}
//# sourceMappingURL=select_multiple_control_value_accessor.js.map

/***/ },

/***/ 145:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_shared__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_async__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__private_import_core__ = __webpack_require__(315);
/* unused harmony export VALID */
/* unused harmony export INVALID */
/* unused harmony export PENDING */
/* unused harmony export DISABLED */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return AbstractControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return FormControl; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroup; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return FormArray; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};




/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var /** @type {?} */ VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var /** @type {?} */ INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var /** @type {?} */ PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var /** @type {?} */ DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = ((path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return ((path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__private_import_core__["a" /* isPromise */])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
}
/**
 * @param {?} validator
 * @return {?}
 */
function coerceToValidator(validator) {
    return Array.isArray(validator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["b" /* composeValidators */])(validator) : validator;
}
/**
 * @param {?} asyncValidator
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__directives_shared__["c" /* composeAsyncValidators */])(asyncValidator) : asyncValidator;
}
/**
 *  {@link FormArray}.
  * *
  * It provides some of the shared behavior that all controls and groups of controls have, like
  * running validators, calculating status, and resetting state. It also defines the properties
  * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
  * instantiated directly.
  * *
 * @abstract
 */
var AbstractControl = (function () {
    /**
     * @param {?} validator
     * @param {?} asyncValidator
     */
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /** @internal */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /** @internal */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         *  The value of the control.
         * @return {?}
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         *  The parent control.
         * @return {?}
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         *  The validation status of the control. There are four possible
          * validation statuses:
          * *
          * * **VALID**:  control has passed all validation checks
          * * **INVALID**: control has failed at least one validation check
          * * **PENDING**: control is in the midst of conducting a validation check
          * * **DISABLED**: control is exempt from validation checks
          * *
          * These statuses are mutually exclusive, so a control cannot be
          * both valid AND invalid or invalid AND disabled.
         * @return {?}
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         *  A control is `valid` when its `status === VALID`.
          * *
          * In order to have this status, the control must have passed all its
          * validation checks.
         * @return {?}
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         *  A control is `invalid` when its `status === INVALID`.
          * *
          * In order to have this status, the control must have failed
          * at least one of its validation checks.
         * @return {?}
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         *  A control is `pending` when its `status === PENDING`.
          * *
          * In order to have this status, the control must be in the
          * middle of conducting a validation check.
         * @return {?}
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         *  A control is `disabled` when its `status === DISABLED`.
          * *
          * Disabled controls are exempt from validation checks and
          * are not included in the aggregate value of their ancestor
          * controls.
         * @return {?}
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         *  A control is `enabled` as long as its `status !== DISABLED`.
          * *
          * In other words, it has a status of `VALID`, `INVALID`, or
          * `PENDING`.
         * @return {?}
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         *  Returns any errors generated by failing validation. If there
          * are no errors, it will return null.
         * @return {?}
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         *  A control is `pristine` if the user has not yet changed
          * the value in the UI.
          * *
          * Note that programmatic changes to a control's value will
          * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         *  A control is `dirty` if the user has changed the value
          * in the UI.
          * *
          * Note that programmatic changes to a control's value will
          * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
         *  A control is marked `touched` once the user has triggered
          * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         *  A control is `untouched` if the user has not yet triggered
          * a `blur` event on it.
         * @return {?}
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         *  Emits an event every time the value of the control changes, in
          * the UI or programmatically.
         * @return {?}
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         *  Emits an event every time the validation status of the control
          * is re-calculated.
         * @return {?}
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the synchronous validators that are active on this control.  Calling
      * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     *  Sets the async validators that are active on this control. Calling this
      * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     *  Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     *  Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     *  Marks the control as `touched`.
      * *
      * This will also mark all direct ancestors as `touched` to maintain
      * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = true;
        if (this._parent && !onlySelf) {
            this._parent.markAsTouched({ onlySelf: onlySelf });
        }
    };
    /**
     *  Marks the control as `untouched`.
      * *
      * If the control has any children, it will also mark all children as `untouched`
      * to maintain the model, and re-calculate the `touched` status of all parent
      * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     *  Marks the control as `dirty`.
      * *
      * This will also mark all direct ancestors as `dirty` to maintain
      * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = false;
        if (this._parent && !onlySelf) {
            this._parent.markAsDirty({ onlySelf: onlySelf });
        }
    };
    /**
     *  Marks the control as `pristine`.
      * *
      * If the control has any children, it will also mark all children as `pristine`
      * to maintain the model, and re-calculate the `pristine` status of all parent
      * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     *  Marks the control as `pending`.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._status = PENDING;
        if (this._parent && !onlySelf) {
            this._parent.markAsPending({ onlySelf: onlySelf });
        }
    };
    /**
     *  Disables the control. This means the control will be exempt from validation checks and
      * excluded from the aggregate value of any parent. Its status is `DISABLED`.
      * *
      * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.disable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     *  Enables the control. This means the control will be included in validation checks and
      * the aggregate value of its parent. Its status is re-calculated based on its value and
      * its validators.
      * *
      * If the control has children, all children will be enabled.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
        this._updateAncestors(onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} onlySelf
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     *  Sets the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.setValue = function (value, options) { };
    /**
     *  Patches the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.patchValue = function (value, options) { };
    /**
     *  Resets the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.reset = function (value, options) { };
    /**
     *  Re-calculates the value and validation status of the control.
      * *
      * By default, it will also update the value and validity of its ancestors.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(emitEvent);
            }
        }
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        }
    };
    /**
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = function (_a) {
        var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            this._cancelExistingSubscription();
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     *  Sets errors on a form control.
      * *
      * This is used when validations are run manually by the user, rather than automatically.
      * *
      * Calling `setErrors` will also update the validity of the parent control.
      * *
      * ### Example
      * *
      * ```
      * const login = new FormControl("someLogin");
      * login.setErrors({
      * "notUnique": true
      * });
      * *
      * expect(login.valid).toEqual(false);
      * expect(login.errors).toEqual({"notUnique": true});
      * *
      * login.setValue("someOtherLogin");
      * *
      * expect(login.valid).toEqual(true);
      * ```
     * @param {?} errors
     * @param {?=} __1
     * @return {?}
     */
    AbstractControl.prototype.setErrors = function (errors, _a) {
        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
        this._errors = errors;
        this._updateControlsErrors(emitEvent !== false);
    };
    /**
     *  Retrieves a child control given the control's name or path.
      * *
      * Paths can be passed in as an array or a string delimited by a dot.
      * *
      * To get a control nested within a `person` sub-group:
      * *
      * * `this.form.get('person.name');`
      * *
      * -OR-
      * *
      * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     *  Returns true if the control with the given path has the error specified. Otherwise
      * returns null or undefined.
      * *
      * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     *  Returns true if the control with the given path has the error specified. Otherwise
      * returns false.
      * *
      * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return !!this.getError(errorCode, path);
    };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         *  Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_2__facade_async__["a" /* EventEmitter */]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /**
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._updateValue = function () { };
    /**
     * @abstract
     * @param {?} cb
     * @return {?}
     */
    AbstractControl.prototype._forEachChild = function (cb) { };
    /**
     * @abstract
     * @param {?} condition
     * @return {?}
     */
    AbstractControl.prototype._anyControls = function (condition) { };
    /**
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._allControlsDisabled = function () { };
    /**
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /**
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = this._anyControlsTouched();
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
function AbstractControl_tsickle_Closure_declarations() {
    /** @type {?} */
    AbstractControl.prototype._value;
    /** @type {?} */
    AbstractControl.prototype._onCollectionChange;
    /** @type {?} */
    AbstractControl.prototype._valueChanges;
    /** @type {?} */
    AbstractControl.prototype._statusChanges;
    /** @type {?} */
    AbstractControl.prototype._status;
    /** @type {?} */
    AbstractControl.prototype._errors;
    /** @type {?} */
    AbstractControl.prototype._pristine;
    /** @type {?} */
    AbstractControl.prototype._touched;
    /** @type {?} */
    AbstractControl.prototype._parent;
    /** @type {?} */
    AbstractControl.prototype._asyncValidationSubscription;
    /** @type {?} */
    AbstractControl.prototype._onDisabledChange;
    /** @type {?} */
    AbstractControl.prototype.validator;
    /** @type {?} */
    AbstractControl.prototype.asyncValidator;
}
/**
 *  *
  * It is one of the three fundamental building blocks of Angular forms, along with
  * {@link FormGroup} and {@link FormArray}.
  * *
  * *
  * When instantiating a {@link FormControl}, you can pass in an initial value as the
  * first argument. Example:
  * *
  * ```ts
  * const ctrl = new FormControl('some value');
  * console.log(ctrl.value);     // 'some value'
  * *```
  * *
  * You can also initialize the control with a form state object on instantiation,
  * which includes both the value and whether or not the control is disabled.
  * You can't use the value key without the disabled key; both are required
  * to use this way of initialization.
  * *
  * ```ts
  * const ctrl = new FormControl({value: 'n/a', disabled: true});
  * console.log(ctrl.value);     // 'n/a'
  * console.log(ctrl.status);   // 'DISABLED'
  * ```
  * *
  * To include a sync validator (or an array of sync validators) with the control,
  * pass it in as the second argument. Async validators are also supported, but
  * have to be passed in separately as the third arg.
  * *
  * ```ts
  * const ctrl = new FormControl('', Validators.required);
  * console.log(ctrl.value);     // ''
  * console.log(ctrl.status);   // 'INVALID'
  * ```
  * *
  * See its superclass, {@link AbstractControl}, for more properties and methods.
  * *
  * * **npm package**: `@angular/forms`
  * *
 */
var FormControl = (function (_super) {
    __extends(FormControl, _super);
    /**
     * @param {?=} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
        /** @internal */
        this._onChange = [];
        this._applyFormState(formState);
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this._initObservables();
    }
    /**
     *  Set the value of the form control to `value`.
      * *
      * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
      * and not its parent component. This defaults to false.
      * *
      * If `emitEvent` is `true`, this
      * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
      * to true (as it falls through to `updateValueAndValidity`).
      * *
      * If `emitModelToViewChange` is `true`, the view will be notified about the new value
      * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
      * specified.
      * *
      * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
      * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
        this._value = value;
        if (this._onChange.length && emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of a control.
      * *
      * This function is functionally the same as {@link FormControl.setValue} at this level.
      * It exists for symmetry with {@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
      * where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     *  Resets the form control. This means by default:
      * *
      * * it is marked as `pristine`
      * * it is marked as `untouched`
      * * value is set to null
      * *
      * You can also reset to a specific form state by passing through a standalone
      * value or a form state object that contains both a value and a disabled state
      * (these are the only two properties that cannot be calculated).
      * *
      * Ex:
      * *
      * ```ts
      * this.control.reset('Nancy');
      * *
      * console.log(this.control.value);  // 'Nancy'
      * ```
      * *
      * OR
      * *
      * ```
      * this.control.reset({value: 'Nancy', disabled: true});
      * *
      * console.log(this.control.value);  // 'Nancy'
      * console.log(this.control.status);  // 'DISABLED'
      * ```
     * @param {?=} formState
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.reset = function (formState, _a) {
        if (formState === void 0) { formState = null; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._applyFormState(formState);
        this.markAsPristine({ onlySelf: onlySelf });
        this.markAsUntouched({ onlySelf: onlySelf });
        this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * @return {?}
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     *  Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     *  Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = function (cb) { };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
function FormControl_tsickle_Closure_declarations() {
    /** @type {?} */
    FormControl.prototype._onChange;
}
/**
 *  instances.
  * *
  * A `FormGroup` aggregates the values of each child {@link FormControl} into one object,
  * with each control name as the key.  It calculates its status by reducing the statuses
  * of its children. For example, if one of the controls in a group is invalid, the entire
  * group becomes invalid.
  * *
  * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
  * along with {@link FormControl} and {@link FormArray}.
  * *
  * *
  * When instantiating a {@link FormGroup}, pass in a collection of child controls as the first
  * argument. The key for each child will be the name under which it is registered.
  * *
  * ### Example
  * *
  * ```
  * const form = new FormGroup({
  * first: new FormControl('Nancy', Validators.minLength(2)),
  * last: new FormControl('Drew'),
  * });
  * *
  * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
  * console.log(form.status);  // 'VALID'
  * ```
  * *
  * You can also include group-level validators as the second arg, or group-level async
  * validators as the third arg. These come in handy when you want to perform validation
  * that considers the value of more than one child control.
  * *
  * ### Example
  * *
  * ```
  * const form = new FormGroup({
  * password: new FormControl('', Validators.minLength(2)),
  * passwordConfirm: new FormControl('', Validators.minLength(2)),
  * }, passwordMatchValidator);
  * *
  * *
  * function passwordMatchValidator(g: FormGroup) {
  * return g.get('password').value === g.get('passwordConfirm').value
  * ? null : {'mismatch': true};
  * }
  * ```
  * *
  * * **npm package**: `@angular/forms`
  * *
 */
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormGroup(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     *  Registers a control with the group's list of controls.
      * *
      * This method does not update value or validity of the control, so for
      * most cases you'll want to use {@link FormGroup.addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     *  Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     *  Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     *  Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     *  Check whether there is an enabled control with the given name in the group.
      * *
      * It will return false for disabled controls. If you'd like to check for
      * existence in the group only, use {@link AbstractControl.get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {@link FormGroup}. It accepts an object that matches
      * the structure of the group, with control names as keys.
      * *
      * This method performs strict checks, so it will throw an error if you try
      * to set the value of a control that doesn't exist or if you exclude the
      * value of a control.
      * *
      * ### Example
      * *
      * ```
      * const form = new FormGroup({
      * first: new FormControl(),
      * last: new FormControl()
      * });
      * console.log(form.value);   // {first: null, last: null}
      * *
      * form.setValue({first: 'Nancy', last: 'Drew'});
      * console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
      * *
      * ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {@link FormGroup}. It accepts an object with control
      * names as keys, and will do its best to match the values to the correct controls
      * in the group.
      * *
      * It accepts both super-sets and sub-sets of the group without throwing an error.
      * *
      * ### Example
      * *
      * ```
      * const form = new FormGroup({
      * first: new FormControl(),
      * last: new FormControl()
      * });
      * console.log(form.value);   // {first: null, last: null}
      * *
      * form.patchValue({first: 'Nancy'});
      * console.log(form.value);   // {first: 'Nancy', last: null}
      * *
      * ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Resets the {@link FormGroup}. This means by default:
      * *
      * * The group and all descendants are marked `pristine`
      * * The group and all descendants are marked `untouched`
      * * The value of all descendants will be null or null maps
      * *
      * You can also reset to a specific form state by passing in a map of states
      * that matches the structure of your form, with control names as keys. The state
      * can be a standalone value or a form state object with both a value and a disabled
      * status.
      * *
      * ### Example
      * *
      * ```ts
      * this.form.reset({first: 'name', last: 'last name'});
      * *
      * console.log(this.form.value);  // {first: 'name', last: 'last name'}
      * ```
      * *
      * - OR -
      * *
      * ```
      * this.form.reset({
      * first: {value: 'name', disabled: true},
      * last: 'last'
      * });
      * *
      * console.log(this.form.value);  // {first: 'name', last: 'last name'}
      * console.log(this.form.get('first').status);  // 'DISABLED'
      * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.reset = function (value, _a) {
        if (value === void 0) { value = {}; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     *  The aggregate value of the {@link FormGroup}, including any disabled controls.
      * *
      * If you'd like to include all values regardless of disabled status, use this method.
      * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control.value;
            return acc;
        });
    };
    /**
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /**
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /**
     * @return {?}
     */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /**
     * @return {?}
     */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /**
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /**
     * @return {?}
     */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /**
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /**
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
function FormGroup_tsickle_Closure_declarations() {
    /** @type {?} */
    FormGroup.prototype.controls;
}
/**
 *  instances.
  * *
  * A `FormArray` aggregates the values of each child {@link FormControl} into an array.
  * It calculates its status by reducing the statuses of its children. For example, if one of
  * the controls in a `FormArray` is invalid, the entire array becomes invalid.
  * *
  * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
  * along with {@link FormControl} and {@link FormGroup}.
  * *
  * *
  * When instantiating a {@link FormArray}, pass in an array of child controls as the first
  * argument.
  * *
  * ### Example
  * *
  * ```
  * const arr = new FormArray([
  * new FormControl('Nancy', Validators.minLength(2)),
  * new FormControl('Drew'),
  * ]);
  * *
  * console.log(arr.value);   // ['Nancy', 'Drew']
  * console.log(arr.status);  // 'VALID'
  * ```
  * *
  * You can also include array-level validators as the second arg, or array-level async
  * validators as the third arg. These come in handy when you want to perform validation
  * that considers the value of more than one child control.
  * *
  * ### Adding or removing controls
  * *
  * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
  * in `FormArray` itself. These methods ensure the controls are properly tracked in the
  * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
  * the `FormArray` directly, as that will result in strange and unexpected behavior such
  * as broken change detection.
  * *
  * * **npm package**: `@angular/forms`
  * *
 */
var FormArray = (function (_super) {
    __extends(FormArray, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormArray(controls, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        _super.call(this, validator, asyncValidator);
        this.controls = controls;
        this._initObservables();
        this._setUpControls();
        this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
    }
    /**
     *  Get the {@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     *  Insert a new {@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     *  Insert a new {@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     *  Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     *  Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         *  Length of the control array.
         * @return {?}
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {@link FormArray}. It accepts an array that matches
      * the structure of the control.
      * *
      * This method performs strict checks, so it will throw an error if you try
      * to set the value of a control that doesn't exist or if you exclude the
      * value of a control.
      * *
      * ### Example
      * *
      * ```
      * const arr = new FormArray([
      * new FormControl(),
      * new FormControl()
      * ]);
      * console.log(arr.value);   // [null, null]
      * *
      * arr.setValue(['Nancy', 'Drew']);
      * console.log(arr.value);   // ['Nancy', 'Drew']
      * ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {@link FormArray}. It accepts an array that matches the
      * structure of the control, and will do its best to match the values to the correct
      * controls in the group.
      * *
      * It accepts both super-sets and sub-sets of the array without throwing an error.
      * *
      * ### Example
      * *
      * ```
      * const arr = new FormArray([
      * new FormControl(),
      * new FormControl()
      * ]);
      * console.log(arr.value);   // [null, null]
      * *
      * arr.patchValue(['Nancy']);
      * console.log(arr.value);   // ['Nancy', null]
      * ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Resets the {@link FormArray}. This means by default:
      * *
      * * The array and all descendants are marked `pristine`
      * * The array and all descendants are marked `untouched`
      * * The value of all descendants will be null or null maps
      * *
      * You can also reset to a specific form state by passing in an array of states
      * that matches the structure of the control. The state can be a standalone value
      * or a form state object with both a value and a disabled status.
      * *
      * ### Example
      * *
      * ```ts
      * this.arr.reset(['name', 'last name']);
      * *
      * console.log(this.arr.value);  // ['name', 'last name']
      * ```
      * *
      * - OR -
      * *
      * ```
      * this.arr.reset([
      * {value: 'name', disabled: true},
      * 'last'
      * ]);
      * *
      * console.log(this.arr.value);  // ['name', 'last name']
      * console.log(this.arr.get(0).status);  // 'DISABLED'
      * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.reset = function (value, _a) {
        if (value === void 0) { value = []; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     *  The aggregate value of the array, including any disabled controls.
      * *
      * If you'd like to include all values regardless of disabled status, use this method.
      * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = function () { return this.controls.map(function (control) { return control.value; }); };
    /**
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /**
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /**
     * @return {?}
     */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /**
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /**
     * @return {?}
     */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /**
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
function FormArray_tsickle_Closure_declarations() {
    /** @type {?} */
    FormArray.prototype.controls;
}
//# sourceMappingURL=model.js.map

/***/ },

/***/ 151:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(59);
var Observable_1 = __webpack_require__(1);
var config_service_1 = __webpack_require__(10);
var TranslateService = (function () {
    function TranslateService(config, http) {
        this.config = config;
        this.http = http;
        this._translations = {};
        this._observables = {};
    }
    TranslateService.prototype.getTranslations = function (name, lang) {
        var _this = this;
        var key = name + "." + lang;
        // check if cached
        if (this._translations[key]) {
            return Observable_1.Observable.of(this._translations[key]);
        }
        // first time create observable
        if (!this._observables[key]) {
            ////console.log(`load http: ${this.config.i18nUrl}/generic.${lang}.json`);
            this._observables[key] = this.http.get(this.config.i18nUrl + "/generic." + lang + ".json")
                .map(function (res) {
                ////console.log('loaded');
                _this._translations[key] = res.json();
                return _this._translations[key];
            })
                .concatMap(function (specificT) {
                ////console.log(`load http: ${this.config.i18nUrl}/${name}.${lang}.json`);
                return _this.http.get(_this.config.i18nUrl + "/" + name + "." + lang + ".json")
                    .map(function (res) {
                    ////console.log('loaded');
                    var genericT = res.json();
                    return Object.assign(specificT, genericT);
                })
                    .catch(function (err) {
                    console.warn(err);
                    return specificT;
                });
            })
                .catch(function (err) {
                // Check if almost one translations is ok
                if (_this._translations[key]) {
                    return Observable_1.Observable.of(_this._translations[key]);
                }
                // cache and return empty
                var fake = { emptyResx: true };
                _this._translations[key] = fake;
                if (!_this._timeout) {
                    console.error('error on GET resx file');
                    ////console.log('create fake empty resx');
                    // dopo 30s lo cancella così alla prossima richiesta riproverà
                    _this._timeout = setTimeout(function () {
                        ////console.log('clear');
                        _this._translations[key] = null;
                        _this._timeout = null;
                    }, 30000);
                }
                return Observable_1.Observable.of(fake);
            })
                .share();
        }
        return this._observables[key];
    };
    TranslateService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, http_1.Http])
    ], TranslateService);
    return TranslateService;
}());
exports.TranslateService = TranslateService;


/***/ },

/***/ 19:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var serialijse_1 = __webpack_require__(250);
var ng2_webstorage_1 = __webpack_require__(115);
var config_service_1 = __webpack_require__(10);
var cart_service_1 = __webpack_require__(13);
var models_1 = __webpack_require__(55);
var configurator_api_service_1 = __webpack_require__(78);
var loading_panel_service_1 = __webpack_require__(226);
var router_1 = __webpack_require__(8);
var models_2 = __webpack_require__(55);
var SessionService = (function () {
    function SessionService(storage, config, cartService, configApi, loadingPanel, router) {
        this.storage = storage;
        this.config = config;
        this.cartService = cartService;
        this.configApi = configApi;
        this.loadingPanel = loadingPanel;
        this.router = router;
        this.lang = 'en';
        this._params = [];
        this.swapFormatSizes = false;
        this.cropHeight = 30;
        this.cropWidth = 20;
        this.validParams = [];
        this.hiddenParams = [];
        this.othersParams = [];
        this.sessionState = SESSION_STATE;
        this.config.setPersistable();
        if (this.storage.retrieve('cart') !== null) {
            this.cartService.cart = serialijse_1.deserialize(this.storage.retrieve('cart'));
            console.log('CARICAto DA LOCAL STORAGE: CARTSERVICE', this.cartService.cart);
        }
        this.cartService.cartCheckProducts();
        if (this.storage.retrieve('session') !== null) {
            var loaded = this.storage.retrieve('session');
            SessionPayload.setSession(loaded, this);
            console.log('CARICATA DA LOCAL STORAGE:SESSION', this);
        }
        console.log(window.location.href.toString().indexOf('configurator-zodio'));
        if (window.location.href.toString().indexOf('configurator-zodio') !== -1) {
            this.config.isModeZodio = true;
        }
        console.log('this.config.isModeZodio', this.config.isModeZodio);
        // MODALITA' TOPCOLOR
        if (this.config.isModeZodio === false) {
            this.modelsVisible = this.config.models.filter(function (x) { return x.id !== 9; });
            console.log('this.productConfig', this.productConfig);
            if (this.productConfig.idModel === 9) {
                console.log('setProduct primo products TOPCOLOR');
                this.setProduct(this.config.products.filter(function (x) { return x.idModel !== 9; })[0], '', '');
            }
            this.cartService.cart.SelDeliveryOption.id = 1;
        }
        else {
            this.modelsVisible = this.config.models.filter(function (x) { return x.id === 9; });
            // se non è impostato un prodotto Zodio lo forzo
            if (this.productConfig.idModel !== 9) {
                console.log('setProduct primo products ZODIO');
                this.setProduct(this.config.products.filter(function (x) { return x.idModel === 9; })[0], '', '');
            }
            // FILTRO LE MODALITA' DI SPEDIZIONE
            this.config.deliveryOptions = this.config.deliveryOptions.filter(function (v) { return v.id === 2; });
            this.cartService.cart.SelDeliveryOption.id = 2;
            // FILTRO LE MODALITA' PAGAMENTO
            this.config.paymentOptions = this.config.paymentOptions.filter(function (v) { return v.key === models_2.PaymentType.Bank; });
            this.cartService.cart.paymentType = models_2.PaymentType.Bank;
        }
        console.log('TEST');
    }
    SessionService.prototype.setProduct = function (productConfig, preFilterKey, preFilterValue) {
        console.log('productConfig', productConfig);
        console.log('preFilterKey', preFilterKey); // es: AccoppiamentoPannello
        console.log('preFilterValue', preFilterValue); // es: Legno
        // es: localhost:57136/configurator/#/load-product/30?url=possibili-accoppiamenti&preFilterKey=AccoppiamentoPannello&preFilterValue=Forex
        console.log('this.cartService.cart', this.cartService.cart);
        var prefName = '';
        if (preFilterKey) {
            productConfig.preFilters.forEach(function (v) {
                if (v.key === preFilterKey) {
                    v.selectedValue = preFilterValue;
                    prefName = ' - ' + preFilterValue;
                }
            });
        }
        this.productConfig = productConfig;
        this.thisModel = productConfig.name + prefName;
        // if (!this.cartService.cart.currentCartProduct)
        //   this.cartService.cart.currentCartProduct = new CartProduct();
        if (!this.cartService.cart.currentCartProduct) {
            console.log('cartService.cart.currentCartProduct NON DEFINITO', this.cartService.cart.currentCartProduct);
            this.cartService.addProduct(productConfig.id, 1);
        }
        this.cartService.cart.currentCartProduct.config = productConfig;
        // this.cartService.cart.currentCartProduct.productName = 'SET: ' +  productConfig.name; // + prefName;
        this.cartService.cart.currentCartProduct.idProduct = productConfig.id;
        console.log('setProduct');
        console.log(this.cartService.cart.currentCartProduct.config);
        console.log(this.cartService.cart.currentCartProduct.productName);
        this.cartService.saveCart();
        this.getParamTree();
        this.saveSession();
        this.router.navigate(['/upload-photo']);
    };
    SessionService.prototype.saveSession = function () {
        console.log('saveSession - cart', this.cartService.cart);
        console.log('saveSession - session', SessionPayload.loadFromSession(this));
        this.config.setPersistable();
        this.storage.store('cart', serialijse_1.serialize(this.cartService.cart));
        this.storage.store('session', SessionPayload.loadFromSession(this));
    };
    SessionService.prototype.isLogged = function () {
        // return this.sessionState && this.sessionState.token;
        return this.sessionState.username !== 'Guest';
    };
    Object.defineProperty(SessionService.prototype, "productConfig", {
        // get price(): number {
        //   let cprice = this.getParam('Price', this.params);
        //   if (!cprice) { return null; }
        //   return parseFloat(cprice.selectedValue);
        // }
        get: function () {
            if (!this._productConfig) {
                console.log('VALORIZZO this._productConfig perchè non definito');
                if (this.cartService.cart) {
                    if (this.cartService.cart.currentCartProduct.config) {
                        this._productConfig = this.cartService.cart.currentCartProduct.config;
                    }
                    else {
                        this._productConfig = this.config.products[0];
                    }
                }
                else {
                    this._productConfig = this.config.products[0];
                }
            }
            return this._productConfig;
        },
        set: function (product) {
            this._productConfig = product;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "outputUrl", {
        get: function () {
            return this.config.outputBaseUrl.replace('{lang}', this.lang);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SessionService.prototype, "params", {
        get: function () {
            return this._params;
        },
        set: function (prms) {
            var _this = this;
            this._params = prms.sort(function (p1, p2) { return ((p1.page - p2.page) * 1000) + (p1.sort - p2.sort); });
            // NO PERCHE' NON C'E' CORRISPONDENZA (cambia il prezzo tra prodotti che è compreso nel param)
            // this.selectFormat = this.getParamValue('ListaFormati', prms, null);
            if (this.cartService.cart.currentCartProduct.config.preFilters) {
                this.cartService.cart.currentCartProduct.config.preFilters.filter(function (pf) { return pf.showOnlyThis; }).forEach(function (pf) {
                    var p = _this.getParam(pf.key, _this.params);
                    if (p) {
                        p.values = p.values.filter(function (v) { return pf.values.indexOf(v.value) >= 0; });
                    }
                });
            }
            this.orientamento = this.getParamValue('FormatoOrientamento', prms, null);
            this.swapFormatSizes = this.getParamValue('FormatoOrientamento', prms, null) === 'Formato_Landscape';
            this.cropHeight = Number(this.getParamValue('CropHeight', prms, null));
            this.cropWidth = Number(this.getParamValue('CropWidth', prms, null));
            this.cornice = this.getParamValue('Cornice', prms, null);
            // Imposta il formato corrente con quello che ritorna l'api
            var formatG = this.getParamValue('FormatoGruppo', this.params, '');
            var format = this.getParamValue('Formato', this.params, '');
            if (this.cartService.cart.currentCartProduct) {
                this.cartService.cart.currentCartProduct.format = formatG + '|' + format;
                this.cartService.cart.currentCartProduct.rounded =
                    (this.cartService.cart.currentCartProduct.format != null ?
                        (this.cartService.cart.currentCartProduct.format.indexOf('O') !== -1) : false);
                this.cartService.cart.currentCartProduct.price = Number(this.getParamValue('Price', prms, null));
                this.cartService.cart.currentCartProduct.cornicePrice = Number(this.getParamValue('CornicePrice', prms, null));
                this.cartService.cart.currentCartProduct.additionalPrice = Number(this.getParamValue('AdditionalPrice', prms, null));
                // recupero valore param NomeProdotto
                console.log(' recupero valore param NomeProdotto per .productName');
                var NomeProdotto = this.getParamValue('NomeProdotto', prms, null);
                if (NomeProdotto) {
                    this.cartService.cart.currentCartProduct.productName = NomeProdotto;
                    console.log('cambiato NomeProdotto .productName ', NomeProdotto);
                }
                // Faccio il parse della lista dei formati // es: F_4X3|80_x_60|80|60|200|"
                var ff = prms.filter(function (p) { return p.name === 'ListaFormati'; });
                if (ff.length === 0) {
                    this.formats = [];
                }
                else {
                    this.formats = ff[0].values.map(function (p) {
                        var f = new models_1.Format();
                        var s = p.value.split('|');
                        f.format = s[0];
                        f.dimensions = s[1];
                        f.width = Number(s[2]);
                        f.height = Number(s[3]);
                        f.price = parseFloat(s[4]);
                        f.priceDiscounted = parseFloat(s[5]);
                        f.valueParam = p.value;
                        return f;
                    });
                }
                // RECUPERO DALLA NUOVA LISTA FORMATI IL PARAM DA REIMPOSTARE MANUALMENTE (se presente)
                var filterFormat = this.formats.filter(function (r) { return r.dimensions === _this.cartService.cart.currentCartProduct.format.split('|')[1]; });
                if (filterFormat[0]) {
                    var recordFormat_1 = filterFormat !== null ? filterFormat[0].valueParam : null;
                    if (recordFormat_1 !== null) {
                        var paramFormat = this.getParam('Formato', this.cartService.cart.currentCartProduct.params);
                        if (paramFormat) {
                            if (paramFormat.values.filter(function (p) { return p.value === recordFormat_1; }).length !== 0) {
                                paramFormat.selectedValue = recordFormat_1;
                            }
                        }
                        paramFormat = this.getParam('Formato', this.params);
                        if (paramFormat) {
                            if (paramFormat.values.filter(function (p) { return p.value === recordFormat_1; }).length !== 0) {
                                paramFormat.selectedValue = recordFormat_1;
                            }
                        }
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    SessionService.prototype.getParam = function (name, prms) {
        if (prms && prms.length !== 0) {
            var paramFormat = prms.filter(function (p) { return p.name === name; });
            if (paramFormat && paramFormat.length !== 0) {
                return paramFormat[0];
            }
        }
        return null;
    };
    SessionService.prototype.getParamValue = function (name, prms, defaultValue) {
        if (!prms) {
            prms = this.params;
        }
        var prm = prms.filter(function (p) { return p.name === name; });
        if (prm.length === 0) {
            return defaultValue;
        }
        return prm[0].selectedValue;
    };
    SessionService.prototype.setParamLists = function (page) {
        var ret = [];
        // creo un dictionary con chiave 'page' e valore l'array di param
        this.params
            .filter(function (p) { return p.table === 'Parameters' || p.table === 'Formats' || p.table.startsWith('Navbar'); })
            .forEach(function (p) {
            if (!ret[p.page]) {
                ret[p.page] = { page: p.page, params: [], hidden: true };
            }
            ret[p.page].params.push(p);
            if (p.image) {
                ret[p.page].image = p.name;
            }
            p.class = 'col-md-12';
            if (p.type === 'Combo') {
                p.class = 'col-md-4 padding-r-none';
            }
            else if (p.type === 'Label') {
                p.class = '';
            }
            if (p.type !== 'Hidden') {
                ret[p.page].hidden = false;
            }
        });
        // toglie gli undefined creati dall'accesso dichiarativo all'array
        this.validParams = ret.filter(function (r) { return r; });
        // lista parametri nascosti (e per ora non Parameters)
        this.hiddenParams = this.params
            .filter(function (p) { return p.type === 'Hidden' && p.table === 'Parameters'; });
        this.othersParams = this.params; // this.params.filter(x => x.table !== 'Parameters');
    };
    SessionService.prototype.getParamTree = function () {
        var _this = this;
        console.log('GET PARAMTREE', this.cartService.cart.currentCartProduct.config.xml, this.oldModel, this.thisModel);
        // console.log('getParamTree - configurator - ' + this.productConfig.xml);
        if (!!this.cartService.cart.currentCartProduct.config.xml) {
            // if (this.oldLoadedProductXml !== this.productConfig.xml) {
            if (this.oldModel !== this.thisModel || (!this.oldModel)) {
                this.oldLoadedProductXml = this.cartService.cart.currentCartProduct.config.xml;
                this.oldModel = this.thisModel;
                console.log("get default params tree from model " + this.cartService.cart.currentCartProduct.config.xml);
                this.errors = null;
                this.loadingPanel.start();
                var preFilters_1 = [];
                if (this.cartService.cart.currentCartProduct.config.preFilters) {
                    this.cartService.cart.currentCartProduct.config.preFilters.forEach(function (f) {
                        preFilters_1.push({ name: f.key, selectedValue: f.selectedValue });
                        // console.log(f.key + f.selectedValue);
                    });
                }
                if (this.params) {
                    var toSave = this.params.filter(function (p) { return _this.config.paramsToSaveKeys.indexOf(p.name) >= 0; });
                    toSave.forEach(function (p) { return preFilters_1.push(p); });
                }
                this.configApi.load(this.cartService.cart.currentCartProduct.config.xml, preFilters_1).subscribe(function (tree) {
                    _this.code = tree.code;
                    _this.desc = tree.desc;
                    _this.params = tree.parameters;
                    // console.log('PARAMS: getParamTree');
                    _this.partialHash = tree.partialHash;
                    _this.hash = tree.hash;
                    _this.page = tree.parameters.map(function (p) { return p.page; }).sort()[0];
                    _this.setParamLists(_this.page);
                    _this.updateCartParams();
                    _this.setBtnToggle(tree.parameters);
                    _this.loadingPanel.complete();
                }, function (error) {
                    console.warn(error);
                    _this.errors = error;
                    _this.loadingPanel.complete();
                });
            }
            else {
                this.setParamLists(this.page);
                this.setBtnToggle(this.params);
            }
        }
        else {
            console.warn('no model passed');
        }
    };
    SessionService.prototype.setBtnToggle = function (params) {
        // console.log('setBtnToggle', params);
        var _this = this;
        // ELIMINO I PULSANTI PARAMETRI PER POI RIAGGIUNGERLI OGNI VOLTA
        this.config.btnToggles = this.config.btnToggles.filter(function (r) { return r.isParameter === false; });
        var i = 10;
        var tables = params.filter(function (r) { return r.type !== 'Hidden'; }).map(function (p) { return p.table; });
        tables = tables.filter(function (item, pos) { return tables.indexOf(item) === pos; }); // DISTINCT
        tables.forEach(function (table) {
            if (table.startsWith('Navbar')) {
                var name_1 = table.substr('Navbar'.length);
                i++;
                var newBtn_1 = {
                    id: i,
                    sort: i,
                    url: 'slide-parameter/' + name_1,
                    text: table,
                    isMenu: true,
                    isParameter: true,
                    isActive: true
                };
                var indexOfPuls = _this.config.btnToggles.indexOf(_this.config.btnToggles.filter(function (r) { return r.id === newBtn_1.id; })[0]);
                if (indexOfPuls === -1) {
                    _this.config.btnToggles.push(newBtn_1);
                }
                _this.config.btnToggles = _this.config.btnToggles.sort(function (a, b) {
                    if (a.sort < b.sort) {
                        return -1;
                    }
                    else if (a.sort > b.sort) {
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
            }
        });
    };
    SessionService.prototype.updateCartParams = function () {
        if (this.cartService.cart.currentCartProduct) {
            this.cartService.cart.currentCartProduct.params = this.params;
        }
    };
    SessionService.prototype.changeParam = function (param, value) {
        var _this = this;
        this.lastChangeParam = param;
        this.lastChangeValue = value;
        var isPackage = param.values.filter(function (p) { return p.value === value; })[0].package;
        this.errors = null;
        this.loadingPanel.start();
        var wasPackage = (this.validParams.filter(function (p) { return !p.isPackage; }).length === 0);
        var newParams = null;
        /// CUSTOM PARAMETERS
        // Lista formati
        if (param.name === 'ListaFormati') {
            var split = value.split('|');
            newParams = [
                { key: 'FormatoGruppo', value: split[0] },
                { key: 'Formato', value: split[1] },
                { key: 'ListaFormati', value: value }
            ];
        }
        if (!newParams) {
            this.configApi.update(this.cartService.cart.currentCartProduct.config.xml, this.params, param.name, value, this.configureAsPackage && wasPackage && isPackage).subscribe(function (tree) {
                _this.code = tree.code;
                _this.desc = tree.desc;
                _this.params = tree.parameters;
                _this.partialHash = tree.partialHash;
                _this.hash = tree.hash;
                var page = _this.page + 1;
                _this.setParamLists(page);
                _this.saveSession();
                _this.updateCartParams();
                _this.loadingPanel.complete();
            }, function (error) {
                console.warn("changeParam error: " + error);
                _this.errors = error;
                _this.loadingPanel.complete();
            });
        }
        else {
            this.configApi.multiupdate(this.cartService.cart.currentCartProduct.config.xml, this.params, newParams, this.configureAsPackage && wasPackage && isPackage).subscribe(function (tree) {
                _this.code = tree.code;
                _this.desc = tree.desc;
                _this.params = tree.parameters;
                _this.partialHash = tree.partialHash;
                _this.hash = tree.hash;
                var page = _this.page + 1;
                _this.setParamLists(page);
                _this.saveSession();
                _this.updateCartParams();
                _this.loadingPanel.complete();
            }, function (error) {
                console.warn("changeParam error: " + error);
                _this.errors = error;
                _this.loadingPanel.complete();
            });
        }
    };
    SessionService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ng2_webstorage_1.LocalStorageService, config_service_1.ConfigService, cart_service_1.CartService, configurator_api_service_1.ConfiguratorApiService, loading_panel_service_1.LoadingPanelService, router_1.Router])
    ], SessionService);
    return SessionService;
}());
exports.SessionService = SessionService;
var SessionPayload = (function () {
    function SessionPayload() {
    }
    SessionPayload.loadFromSession = function (session) {
        var payload = new SessionPayload();
        payload.lang = session.lang;
        payload._productConfig = session._productConfig;
        payload.code = session.code;
        payload.desc = session.desc;
        payload._params = session._params;
        payload.partialHash = session.partialHash;
        payload.hash = session.hash;
        payload.oldLoadedProductXml = session.oldLoadedProductXml;
        payload.oldModel = session.oldModel;
        payload.thisModel = session.thisModel;
        payload.formats = session.formats;
        payload.orientamento = session.orientamento;
        payload.swapFormatSizes = session.swapFormatSizes;
        payload.cropHeight = session.cropHeight;
        payload.cropWidth = session.cropWidth;
        payload.cornice = session.cornice;
        payload.errors = session.errors;
        payload.page = session.page;
        payload.validParams = session.validParams;
        payload.hiddenParams = session.hiddenParams;
        payload.othersParams = session.othersParams;
        payload.lastChangeParam = session.lastChangeParam;
        payload.lastChangeValue = session.lastChangeValue;
        payload.configureAsPackage = session.configureAsPackage;
        payload.btnToggles = session.btnToggles;
        payload.sessionState = session.sessionState;
        return payload;
    };
    SessionPayload.setSession = function (loaded, session) {
        console.log('SetSession');
        session.lang = loaded.lang;
        session.productConfig = loaded._productConfig;
        session.code = loaded.code;
        session.desc = loaded.desc;
        session.params = loaded._params;
        session.partialHash = loaded.partialHash;
        session.hash = loaded.hash;
        session.oldLoadedProductXml = loaded.oldLoadedProductXml;
        session.oldModel = loaded.oldModel;
        session.thisModel = loaded.thisModel;
        session.formats = loaded.formats;
        session.orientamento = loaded.orientamento;
        session.swapFormatSizes = loaded.swapFormatSizes;
        session.cropHeight = loaded.cropHeight;
        session.cropWidth = loaded.cropWidth;
        session.cornice = loaded.cornice;
        session.errors = loaded.errors;
        session.page = loaded.page;
        session.validParams = loaded.validParams;
        session.hiddenParams = loaded.hiddenParams;
        session.othersParams = loaded.othersParams;
        session.lastChangeParam = loaded.lastChangeParam;
        session.lastChangeValue = loaded.lastChangeValue;
        session.configureAsPackage = loaded.configureAsPackage;
        session.btnToggles = loaded.btnToggles;
        // session.sessionState = loaded.sessionState; //NON LA RISETTO PERCHE' ALTRIMENTI NON CONSIDERA LA SESSIONE DEL LOGIN MA QUELLA PRECEDENTE
    };
    return SessionPayload;
}());
exports.SessionPayload = SessionPayload;


/***/ },

/***/ 203:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 *  Base class for control directives.
  * *
  * Only used internally in the forms module.
  * *
 * @abstract
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    Object.defineProperty(AbstractControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { throw new Error('unimplemented'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.statusChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valueChanges : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        if (path === void 0) { path = null; }
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
//# sourceMappingURL=abstract_control_directive.js.map

/***/ },

/***/ 204:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(65);
/* unused harmony export AbstractControlStatus */
/* unused harmony export ngControlStatusHost */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgControlStatus; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NgControlStatusGroup; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



var AbstractControlStatus = (function () {
    /**
     * @param {?} cd
     */
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
function AbstractControlStatus_tsickle_Closure_declarations() {
    /** @type {?} */
    AbstractControlStatus.prototype._cd;
}
var /** @type {?} */ ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 *  Directive automatically applied to Angular form controls that sets CSS classes
  * based on control status (valid/invalid/dirty/etc).
  * *
 */
var NgControlStatus = (function (_super) {
    __extends(NgControlStatus, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatus(cd) {
        _super.call(this, cd);
    }
    NgControlStatus.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
    ];
    /** @nocollapse */
    NgControlStatus.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_2__ng_control__["a" /* NgControl */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ]; };
    return NgControlStatus;
}(AbstractControlStatus));
function NgControlStatus_tsickle_Closure_declarations() {
    /** @type {?} */
    NgControlStatus.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgControlStatus.ctorParameters;
}
/**
 *  Directive automatically applied to Angular form groups that sets CSS classes
  * based on control status (valid/invalid/dirty/etc).
  * *
 */
var NgControlStatusGroup = (function (_super) {
    __extends(NgControlStatusGroup, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatusGroup(cd) {
        _super.call(this, cd);
    }
    NgControlStatusGroup.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                    host: ngControlStatusHost
                },] },
    ];
    /** @nocollapse */
    NgControlStatusGroup.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_1__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    ]; };
    return NgControlStatusGroup;
}(AbstractControlStatus));
function NgControlStatusGroup_tsickle_Closure_declarations() {
    /** @type {?} */
    NgControlStatusGroup.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgControlStatusGroup.ctorParameters;
}
//# sourceMappingURL=ng_control_status.js.map

/***/ },

/***/ 205:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__control_value_accessor__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ng_control__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ng_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ng_model_group__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__ = __webpack_require__(311);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgModel; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};












var /** @type {?} */ formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_7__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var /** @type {?} */ resolvedPromise = Promise.resolve(null);
/**
 *  to a form control element.
  * *
  * The {@link FormControl} instance will track the value, user interaction, and
  * validation status of the control and keep the view synced with the model. If used
  * within a parent form, the directive will also register itself with the form as a child
  * control.
  * *
  * *
  * This directive can be used by itself or as part of a larger form. All you need is the
  * `ngModel` selector to activate it.
  * *
  * It accepts a domain model as an optional {@link @Input}. If you have a one-way binding
  * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
  * class will set the value in the view. If you have a two-way binding with `[()]` syntax
  * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
  * the domain model in your class as well.
  * *
  * If you wish to inspect the properties of the associated {@link FormControl} (like
  * validity state), you can also export the directive into a local template variable using
  * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
  * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
  * will fall through to the control anyway, so you can access them directly. You can see a
  * full list of properties directly available in {@link AbstractControlDirective}.
  * *
  * The following is an example of a simple standalone control using `ngModel`:
  * *
  * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
  * *
  * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
  * so that the control can be registered with the parent form under that name.
  * *
  * It's worth noting that in the context of a parent form, you often can skip one-way or
  * two-way binding because the parent form will sync the value for you. You can access
  * its properties by exporting it into a local template variable using `ngForm` (ex:
  * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
  * *
  * If you do need to populate initial values into your form, using a one-way binding for
  * `ngModel` tends to be sufficient as long as you use the exported form's value rather
  * than the domain model's value on submit.
  * *
  * Take a look at an example of using `ngModel` within a form:
  * *
  * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
  * *
  * To see `ngModel` examples with different form control types, see:
  * *
  * * Radio buttons: {@link RadioControlValueAccessor}
  * * Selects: {@link SelectControlValueAccessor}
  * *
  * **npm package**: `@angular/forms`
  * *
  * **NgModule**: `FormsModule`
  * *
  * @stable
 */
var NgModel = (function (_super) {
    __extends(NgModel, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        /** @internal */
        this._control = new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */]();
        /** @internal */
        this._registered = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["a" /* controlPath */])(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = function () {
        return !this._parent || (this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__shared__["d" /* setUpControl */])(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_4__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].formGroupNameException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__ng_model_group__["a" /* NgModelGroup */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_8__ng_form__["a" /* NgForm */])) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            __WEBPACK_IMPORTED_MODULE_11__template_driven_errors__["a" /* TemplateDrivenErrors */].missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    NgModel.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[ngModel]:not([formControlName]):not([formControl])',
                    providers: [formControlBinding],
                    exportAs: 'ngModel'
                },] },
    ];
    /** @nocollapse */
    NgModel.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_5__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_6__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ]; };
    NgModel.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelOptions',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    };
    return NgModel;
}(__WEBPACK_IMPORTED_MODULE_7__ng_control__["a" /* NgControl */]));
function NgModel_tsickle_Closure_declarations() {
    /** @type {?} */
    NgModel.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgModel.ctorParameters;
    /** @type {?} */
    NgModel.propDecorators;
    /** @type {?} */
    NgModel.prototype._control;
    /** @type {?} */
    NgModel.prototype._registered;
    /** @type {?} */
    NgModel.prototype.viewModel;
    /** @type {?} */
    NgModel.prototype.name;
    /** @type {?} */
    NgModel.prototype.isDisabled;
    /** @type {?} */
    NgModel.prototype.model;
    /** @type {?} */
    NgModel.prototype.options;
    /** @type {?} */
    NgModel.prototype.update;
}
//# sourceMappingURL=ng_model.js.map

/***/ },

/***/ 206:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(30);
/* unused harmony export NUMBER_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NumberValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ NUMBER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 *  The accessor for writing a number value and listening to changes that is used by the
  * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
  * *
  * ### Example
  * ```
  * <input type="number" [(ngModel)]="age">
  * ```
 */
var NumberValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    NumberValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [NUMBER_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    NumberValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return NumberValueAccessor;
}());
function NumberValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    NumberValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NumberValueAccessor.ctorParameters;
    /** @type {?} */
    NumberValueAccessor.prototype.onChange;
    /** @type {?} */
    NumberValueAccessor.prototype.onTouched;
    /** @type {?} */
    NumberValueAccessor.prototype._renderer;
    /** @type {?} */
    NumberValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=number_value_accessor.js.map

/***/ },

/***/ 207:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(30);
/* unused harmony export RANGE_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RangeValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


var /** @type {?} */ RANGE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 *  The accessor for writing a range value and listening to changes that is used by the
  * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
  * *
  * ### Example
  * ```
  * <input type="range" [(ngModel)]="age" >
  * ```
 */
var RangeValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    RangeValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                    host: {
                        '(change)': 'onChange($event.target.value)',
                        '(input)': 'onChange($event.target.value)',
                        '(blur)': 'onTouched()'
                    },
                    providers: [RANGE_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RangeValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    ]; };
    return RangeValueAccessor;
}());
function RangeValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    RangeValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RangeValueAccessor.ctorParameters;
    /** @type {?} */
    RangeValueAccessor.prototype.onChange;
    /** @type {?} */
    RangeValueAccessor.prototype.onTouched;
    /** @type {?} */
    RangeValueAccessor.prototype._renderer;
    /** @type {?} */
    RangeValueAccessor.prototype._elementRef;
}
//# sourceMappingURL=range_value_accessor.js.map

/***/ },

/***/ 208:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__control_value_accessor__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ng_control__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(53);
/* unused harmony export formControlBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var /** @type {?} */ formControlBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_4__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 *  *
  * In other words, this directive ensures that any values written to the {@link FormControl}
  * instance programmatically will be written to the DOM element (model -> view). Conversely,
  * any values written to the DOM element through user input will be reflected in the
  * {@link FormControl} instance (view -> model).
  * *
  * *
  * Use this directive if you'd like to create and manage a {@link FormControl} instance directly.
  * Simply create a {@link FormControl}, save it to your component class, and pass it into the
  * {@link FormControlDirective}.
  * *
  * This directive is designed to be used as a standalone control.  Unlike {@link FormControlName},
  * it does not require that your {@link FormControl} instance be part of any parent
  * {@link FormGroup}, and it won't be registered to any {@link FormGroupDirective} that
  * exists above it.
  * *
  * **Get the value**: the `value` property is always synced and available on the
  * {@link FormControl} instance. See a full list of available properties in
  * {@link AbstractControl}.
  * *
  * **Set the value**: You can pass in an initial value when instantiating the {@link FormControl},
  * or you can set it programmatically later using {@link AbstractControl.setValue} or
  * {@link AbstractControl.patchValue}.
  * *
  * **Listen to value**: If you want to listen to changes in the value of the control, you can
  * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
  * {@link AbstractControl.statusChanges} to be notified when the validation status is
  * re-calculated.
  * *
  * ### Example
  * *
  * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * * **NgModule**: `ReactiveFormsModule`
  * *
  * @stable
 */
var FormControlDirective = (function (_super) {
    __extends(FormControlDirective, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(this.form, this);
            if (this.control.disabled && this.valueAccessor.setDisabledState) {
                this.valueAccessor.setDisabledState(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    FormControlDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding], exportAs: 'ngForm' },] },
    ];
    /** @nocollapse */
    FormControlDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ]; };
    FormControlDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControl',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlDirective;
}(__WEBPACK_IMPORTED_MODULE_4__ng_control__["a" /* NgControl */]));
function FormControlDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    FormControlDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormControlDirective.ctorParameters;
    /** @type {?} */
    FormControlDirective.propDecorators;
    /** @type {?} */
    FormControlDirective.prototype.viewModel;
    /** @type {?} */
    FormControlDirective.prototype.form;
    /** @type {?} */
    FormControlDirective.prototype.model;
    /** @type {?} */
    FormControlDirective.prototype.update;
}
//# sourceMappingURL=form_control_directive.js.map

/***/ },

/***/ 209:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__control_value_accessor__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ng_control__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__reactive_errors__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__form_group_directive__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__form_group_name__ = __webpack_require__(100);
/* unused harmony export controlNameBinding */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormControlName; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};











var /** @type {?} */ controlNameBinding = {
    provide: __WEBPACK_IMPORTED_MODULE_6__ng_control__["a" /* NgControl */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 *  element by name.
  * *
  * In other words, this directive ensures that any values written to the {@link FormControl}
  * instance programmatically will be written to the DOM element (model -> view). Conversely,
  * any values written to the DOM element through user input will be reflected in the
  * {@link FormControl} instance (view -> model).
  * *
  * *
  * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
  * `[formGroup]`).
  * *
  * It accepts the string name of the {@link FormControl} instance you want to
  * link, and will look for a {@link FormControl} registered with that name in the
  * closest {@link FormGroup} or {@link FormArray} above it.
  * *
  * **Access the control**: You can access the {@link FormControl} associated with
  * this directive by using the {@link AbstractControl.get} method.
  * Ex: `this.form.get('first');`
  * *
  * **Get value**: the `value` property is always synced and available on the {@link FormControl}.
  * See a full list of available properties in {@link AbstractControl}.
  * *
  * **Set value**: You can set an initial value for the control when instantiating the
  * {@link FormControl}, or you can set it programmatically later using
  * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
  * *
  * **Listen to value**: If you want to listen to changes in the value of the control, you can
  * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
  * {@link AbstractControl.statusChanges} to be notified when the validation status is
  * re-calculated.
  * *
  * ### Example
  * *
  * In this example, we create form controls for first name and last name.
  * *
  * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
  * *
  * To see `formControlName` examples with different form control types, see:
  * *
  * * Radio buttons: {@link RadioControlValueAccessor}
  * * Selects: {@link SelectControlValueAccessor}
  * *
  * **npm package**: `@angular/forms`
  * *
  * **NgModule**: {@link ReactiveFormsModule}
  * *
  * @stable
 */
var FormControlName = (function (_super) {
    __extends(FormControlName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        _super.call(this);
        this._added = false;
        this.update = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this._parent = parent;
        this._rawValidators = validators || [];
        this._rawAsyncValidators = asyncValidators || [];
        this.valueAccessor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["f" /* selectValueAccessor */])(this, valueAccessors);
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["g" /* isPropertyUpdated */])(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["b" /* composeValidators */])(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__shared__["c" /* composeAsyncValidators */])(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["a" /* FormGroupName */]) &&
            this._parent instanceof __WEBPACK_IMPORTED_MODULE_3__abstract_form_group_directive__["a" /* AbstractFormGroupDirective */]) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].ngModelGroupException();
        }
        else if (!(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["a" /* FormGroupName */]) && !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_9__form_group_directive__["a" /* FormGroupDirective */]) &&
            !(this._parent instanceof __WEBPACK_IMPORTED_MODULE_10__form_group_name__["b" /* FormArrayName */])) {
            __WEBPACK_IMPORTED_MODULE_7__reactive_errors__["a" /* ReactiveErrors */].controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && this.valueAccessor.setDisabledState) {
            this.valueAccessor.setDisabledState(true);
        }
        this._added = true;
    };
    FormControlName.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
    ];
    /** @nocollapse */
    FormControlName.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_2__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_5__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],] },] },
    ]; };
    FormControlName.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControlName',] },],
        'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
        'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
        'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    };
    return FormControlName;
}(__WEBPACK_IMPORTED_MODULE_6__ng_control__["a" /* NgControl */]));
function FormControlName_tsickle_Closure_declarations() {
    /** @type {?} */
    FormControlName.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormControlName.ctorParameters;
    /** @type {?} */
    FormControlName.propDecorators;
    /** @type {?} */
    FormControlName.prototype._added;
    /** @type {?} */
    FormControlName.prototype.viewModel;
    /** @type {?} */
    FormControlName.prototype._control;
    /** @type {?} */
    FormControlName.prototype.name;
    /** @type {?} */
    FormControlName.prototype.model;
    /** @type {?} */
    FormControlName.prototype.update;
}
//# sourceMappingURL=form_control_name.js.map

/***/ },

/***/ 225:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(59);
var Observable_1 = __webpack_require__(1);
var config_service_1 = __webpack_require__(10);
var BraintreePaymentService = (function () {
    // braintree: any = require('braintree-web');
    function BraintreePaymentService(config, http) {
        this.config = config;
        this.http = http;
    }
    BraintreePaymentService.prototype.setup = function (options, success) {
        this.getToken()
            .subscribe(function (token) {
            braintree.setup(token, 'dropin', {
                container: options.container,
                paypal: {
                    singleUse: true,
                    amount: options.price,
                    currency: 'EUR',
                    button: {
                        type: 'checkout'
                    }
                },
                onReady: options.onReady,
                onError: options.onError,
                onPaymentMethodReceived: success
            });
        }, function (error) { return options.onError(error); });
    };
    BraintreePaymentService.prototype.getToken = function () {
        var _this = this;
        return this.http.get(this.config.braintreeTokenUrl)
            .map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    BraintreePaymentService.prototype.mapResponse = function (res) {
        if (!res.ok) {
            this.handleError(res);
        }
        else {
            return res.text();
        }
    };
    BraintreePaymentService.prototype.handleError = function (error) {
        var errMsg;
        if (!!error._body) {
            var errJson = JSON.parse(error._body);
            errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
        }
        else {
            errMsg = (error.message) ? error.message :
                error.status ? error.status + " - " + error.statusText : 'Server error';
        }
        console.error(errMsg); // log to console instead
        return Observable_1.Observable.throw(errMsg);
    };
    BraintreePaymentService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, http_1.Http])
    ], BraintreePaymentService);
    return BraintreePaymentService;
}());
exports.BraintreePaymentService = BraintreePaymentService;


/***/ },

/***/ 226:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_slim_loading_bar_1 = __webpack_require__(167);
var LoadingPanelService = (function () {
    function LoadingPanelService(slimLoadingBarService) {
        this.slimLoadingBarService = slimLoadingBarService;
    }
    LoadingPanelService.prototype.start = function () {
        this.slimLoadingBarService.start();
        this.isLoading = true;
    };
    LoadingPanelService.prototype.complete = function () {
        this.slimLoadingBarService.complete();
        this.isLoading = false;
    };
    LoadingPanelService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ng2_slim_loading_bar_1.SlimLoadingBarService])
    ], LoadingPanelService);
    return LoadingPanelService;
}());
exports.LoadingPanelService = LoadingPanelService;


/***/ },

/***/ 227:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(59);
var Observable_1 = __webpack_require__(1);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var WebsiteInterfaceService = (function () {
    function WebsiteInterfaceService(http, config, session) {
        this.http = http;
        this.config = config;
        this.session = session;
    }
    WebsiteInterfaceService.prototype.output = function (model, code, desc, params, isPackage) {
        var _this = this;
        return this.http.post(this.session.outputUrl + '/payment', {
            model: model,
            code: code,
            desc: desc,
            params: params.map(function (p) { return { key: p.name, value: p.selectedValue }; }),
            isPackage: isPackage,
            headers: this.getHeaders()
        }).map(function (res) {
            // mi aspetto l'url a cui fare redirect un redirect
            if (res.ok) {
                return res.text();
            }
            else {
                _this.handleError({
                    message: "Error in communication with website.\n          Status code: " + res.status + ". Status text: " + res.statusText + ".\n          Body: " + res.text()
                });
            }
        }).catch(function (err) { return _this.handleError(err); });
    };
    WebsiteInterfaceService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        return headers;
    };
    /*private mapResponse(res: Response) {
      if (!res.ok) {
        this.handleError(res);
      } else {
        return res.json();
      }
    }*/
    WebsiteInterfaceService.prototype.handleError = function (error) {
        var errMsg;
        if (!!error._body) {
            var errJson = JSON.parse(error._body);
            errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
        }
        else {
            errMsg = (error.message) ? error.message :
                error.status ? error.status + " - " + error.statusText : 'Server error';
        }
        console.error(errMsg); // log to console instead
        return Observable_1.Observable.throw(errMsg);
    };
    WebsiteInterfaceService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http, config_service_1.ConfigService, session_service_1.SessionService])
    ], WebsiteInterfaceService);
    return WebsiteInterfaceService;
}());
exports.WebsiteInterfaceService = WebsiteInterfaceService;


/***/ },

/***/ 250:
/***/ function(module, exports, __webpack_require__) {

/*global exports,require*/
var lib = __webpack_require__(254);
exports.serialize = lib.serialize;
exports.deserialize = lib.deserialize;
exports.serializeZ = lib.serializeZ;
exports.deserializeZ = lib.deserializeZ;
exports.declarePersistable = lib.declarePersistable;


/***/ },

/***/ 30:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NG_VALUE_ACCESSOR; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * Used to provide a {@link ControlValueAccessor} for form controls.
 *
 * See {@link DefaultValueAccessor} for how to implement one.
 * @stable
 */
var /** @type {?} */ NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValueAccessor');
//# sourceMappingURL=control_value_accessor.js.map

/***/ },

/***/ 310:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormErrorExamples; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var /** @type {?} */ FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
//# sourceMappingURL=error_examples.js.map

/***/ },

/***/ 311:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_examples__ = __webpack_require__(310);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TemplateDrivenErrors; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + __WEBPACK_IMPORTED_MODULE_0__error_examples__["a" /* FormErrorExamples */].ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
//# sourceMappingURL=template_driven_errors.js.map

/***/ },

/***/ 312:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(34);
/* unused harmony export REQUIRED_VALIDATOR */
/* unused harmony export CHECKBOX_REQUIRED_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RequiredValidator; });
/* harmony export (binding) */ __webpack_require__.d(exports, "e", function() { return CheckboxRequiredValidator; });
/* unused harmony export MIN_LENGTH_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return MinLengthValidator; });
/* unused harmony export MAX_LENGTH_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return MaxLengthValidator; });
/* unused harmony export PATTERN_VALIDATOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "d", function() { return PatternValidator; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


var /** @type {?} */ REQUIRED_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var /** @type {?} */ CHECKBOX_REQUIRED_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 *  A Directive that adds the `required` validator to any controls marked with the
  * `required` attribute, via the {@link NG_VALIDATORS} binding.
  * *
  * ### Example
  * *
  * ```
  * <input name="fullName" ngModel required>
  * ```
  * *
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        /**
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    RequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                    providers: [REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    RequiredValidator.ctorParameters = function () { return []; };
    RequiredValidator.propDecorators = {
        'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RequiredValidator;
}());
function RequiredValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    RequiredValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RequiredValidator.ctorParameters;
    /** @type {?} */
    RequiredValidator.propDecorators;
    /** @type {?} */
    RequiredValidator.prototype._required;
    /** @type {?} */
    RequiredValidator.prototype._onChange;
}
/**
 *  A Directive that adds the `required` validator to checkbox controls marked with the
  * `required` attribute, via the {@link NG_VALIDATORS} binding.
  * *
  * ### Example
  * *
  * ```
  * <input type="checkbox" name="active" ngModel required>
  * ```
  * *
 */
var CheckboxRequiredValidator = (function (_super) {
    __extends(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        _super.apply(this, arguments);
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = function (c) {
        return this.required ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].requiredTrue(c) : null;
    };
    CheckboxRequiredValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                    providers: [CHECKBOX_REQUIRED_VALIDATOR],
                    host: { '[attr.required]': 'required ? "" : null' }
                },] },
    ];
    /** @nocollapse */
    CheckboxRequiredValidator.ctorParameters = function () { return []; };
    return CheckboxRequiredValidator;
}(RequiredValidator));
function CheckboxRequiredValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    CheckboxRequiredValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    CheckboxRequiredValidator.ctorParameters;
}
/**
 * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var /** @type {?} */ MIN_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 *  A directive which installs the {@link MinLengthValidator} for any `formControlName`,
  * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
  * *
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].minLength(parseInt(this.minlength, 10));
    };
    MinLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                    providers: [MIN_LENGTH_VALIDATOR],
                    host: { '[attr.minlength]': 'minlength ? minlength : null' }
                },] },
    ];
    /** @nocollapse */
    MinLengthValidator.ctorParameters = function () { return []; };
    MinLengthValidator.propDecorators = {
        'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MinLengthValidator;
}());
function MinLengthValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    MinLengthValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MinLengthValidator.ctorParameters;
    /** @type {?} */
    MinLengthValidator.propDecorators;
    /** @type {?} */
    MinLengthValidator.prototype._validator;
    /** @type {?} */
    MinLengthValidator.prototype._onChange;
    /** @type {?} */
    MinLengthValidator.prototype.minlength;
}
/**
 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var /** @type {?} */ MAX_LENGTH_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 *  A directive which installs the {@link MaxLengthValidator} for any `formControlName,
  * `formControl`,
  * or control with `ngModel` that also has a `maxlength` attribute.
  * *
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].maxLength(parseInt(this.maxlength, 10));
    };
    MaxLengthValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                    providers: [MAX_LENGTH_VALIDATOR],
                    host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
                },] },
    ];
    /** @nocollapse */
    MaxLengthValidator.ctorParameters = function () { return []; };
    MaxLengthValidator.propDecorators = {
        'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return MaxLengthValidator;
}());
function MaxLengthValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    MaxLengthValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MaxLengthValidator.ctorParameters;
    /** @type {?} */
    MaxLengthValidator.propDecorators;
    /** @type {?} */
    MaxLengthValidator.prototype._validator;
    /** @type {?} */
    MaxLengthValidator.prototype._onChange;
    /** @type {?} */
    MaxLengthValidator.prototype.maxlength;
}
var /** @type {?} */ PATTERN_VALIDATOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__validators__["b" /* NG_VALIDATORS */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 *  A Directive that adds the `pattern` validator to any controls marked with the
  * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
  * as the regex to validate Control value against.  Follows pattern attribute
  * semantics; i.e. regex must match entire Control value.
  * *
  * ### Example
  * *
  * ```
  * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
  * ```
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = function () { this._validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].pattern(this.pattern); };
    PatternValidator.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                    providers: [PATTERN_VALIDATOR],
                    host: { '[attr.pattern]': 'pattern ? pattern : null' }
                },] },
    ];
    /** @nocollapse */
    PatternValidator.ctorParameters = function () { return []; };
    PatternValidator.propDecorators = {
        'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return PatternValidator;
}());
function PatternValidator_tsickle_Closure_declarations() {
    /** @type {?} */
    PatternValidator.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    PatternValidator.ctorParameters;
    /** @type {?} */
    PatternValidator.propDecorators;
    /** @type {?} */
    PatternValidator.prototype._validator;
    /** @type {?} */
    PatternValidator.prototype._onChange;
    /** @type {?} */
    PatternValidator.prototype.pattern;
}
//# sourceMappingURL=validators.js.map

/***/ },

/***/ 313:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__(75);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return StringMapWrapper; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ListWrapper; });
/* unused harmony export isListLikeIterable */
/* unused harmony export areIterablesEqual */
/* unused harmony export iterateListLike */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 *  Wraps Javascript Objects
 */
var StringMapWrapper = (function () {
    function StringMapWrapper() {
    }
    /**
     * @param {?} m1
     * @param {?} m2
     * @return {?}
     */
    StringMapWrapper.merge = function (m1, m2) {
        var /** @type {?} */ m = {};
        for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
            var k = _a[_i];
            m[k] = m1[k];
        }
        for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
            var k = _c[_b];
            m[k] = m2[k];
        }
        return m;
    };
    /**
     * @param {?} m1
     * @param {?} m2
     * @return {?}
     */
    StringMapWrapper.equals = function (m1, m2) {
        var /** @type {?} */ k1 = Object.keys(m1);
        var /** @type {?} */ k2 = Object.keys(m2);
        if (k1.length != k2.length) {
            return false;
        }
        for (var /** @type {?} */ i = 0; i < k1.length; i++) {
            var /** @type {?} */ key = k1[i];
            if (m1[key] !== m2[key]) {
                return false;
            }
        }
        return true;
    };
    return StringMapWrapper;
}());
var ListWrapper = (function () {
    function ListWrapper() {
    }
    /**
     * @param {?} arr
     * @param {?} condition
     * @return {?}
     */
    ListWrapper.findLast = function (arr, condition) {
        for (var /** @type {?} */ i = arr.length - 1; i >= 0; i--) {
            if (condition(arr[i])) {
                return arr[i];
            }
        }
        return null;
    };
    /**
     * @param {?} list
     * @param {?} items
     * @return {?}
     */
    ListWrapper.removeAll = function (list, items) {
        for (var /** @type {?} */ i = 0; i < items.length; ++i) {
            var /** @type {?} */ index = list.indexOf(items[i]);
            if (index > -1) {
                list.splice(index, 1);
            }
        }
    };
    /**
     * @param {?} list
     * @param {?} el
     * @return {?}
     */
    ListWrapper.remove = function (list, el) {
        var /** @type {?} */ index = list.indexOf(el);
        if (index > -1) {
            list.splice(index, 1);
            return true;
        }
        return false;
    };
    /**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    ListWrapper.equals = function (a, b) {
        if (a.length != b.length)
            return false;
        for (var /** @type {?} */ i = 0; i < a.length; ++i) {
            if (a[i] !== b[i])
                return false;
        }
        return true;
    };
    /**
     * @param {?} list
     * @return {?}
     */
    ListWrapper.flatten = function (list) {
        return list.reduce(function (flat, item) {
            var /** @type {?} */ flatItem = Array.isArray(item) ? ListWrapper.flatten(item) : item;
            return ((flat)).concat(flatItem);
        }, []);
    };
    return ListWrapper;
}());
/**
 * @param {?} obj
 * @return {?}
 */
function isListLikeIterable(obj) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["a" /* isJsObject */])(obj))
        return false;
    return Array.isArray(obj) ||
        (!(obj instanceof Map) &&
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])() in obj); // JS Iterable have a Symbol.iterator prop
}
/**
 * @param {?} a
 * @param {?} b
 * @param {?} comparator
 * @return {?}
 */
function areIterablesEqual(a, b, comparator) {
    var /** @type {?} */ iterator1 = a[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
    var /** @type {?} */ iterator2 = b[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
    while (true) {
        var /** @type {?} */ item1 = iterator1.next();
        var /** @type {?} */ item2 = iterator2.next();
        if (item1.done && item2.done)
            return true;
        if (item1.done || item2.done)
            return false;
        if (!comparator(item1.value, item2.value))
            return false;
    }
}
/**
 * @param {?} obj
 * @param {?} fn
 * @return {?}
 */
function iterateListLike(obj, fn) {
    if (Array.isArray(obj)) {
        for (var /** @type {?} */ i = 0; i < obj.length; i++) {
            fn(obj[i]);
        }
    }
    else {
        var /** @type {?} */ iterator = obj[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lang__["b" /* getSymbolIterator */])()]();
        var /** @type {?} */ item = void 0;
        while (!((item = iterator.next()).done)) {
            fn(item.value);
        }
    }
}
//# sourceMappingURL=collection.js.map

/***/ },

/***/ 314:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_lang__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(145);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormBuilder; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 *  *
  * It is essentially syntactic sugar that shortens the `new FormGroup()`,
  * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
  * forms.
  * *
  * *
  * To use, inject `FormBuilder` into your component class. You can then call its methods
  * directly.
  * *
  * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * * **NgModule**: {@link ReactiveFormsModule}
  * *
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     *  Construct a new {@link FormGroup} with the given map of configuration.
      * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
      * *
      * See the {@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isPresent */])(extra) ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__facade_lang__["c" /* isPresent */])(extra) ? extra['asyncValidator'] : null;
        return new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */](controls, validator, asyncValidator);
    };
    /**
     *  Construct a new {@link FormControl} with the given `formState`,`validator`, and
      * `asyncValidator`.
      * *
      * `formState` can either be a standalone value for the form control or an object
      * that contains both a value and a disabled status.
      * *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        return new __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */](formState, validator, asyncValidator);
    };
    /**
     *  Construct a {@link FormArray} from the given `controlsConfig` array of
      * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        if (validator === void 0) { validator = null; }
        if (asyncValidator === void 0) { asyncValidator = null; }
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */](controls, validator, asyncValidator);
    };
    /**
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /**
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["b" /* FormControl */] || controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */] ||
            controlConfig instanceof __WEBPACK_IMPORTED_MODULE_2__model__["c" /* FormArray */]) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    FormBuilder.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    FormBuilder.ctorParameters = function () { return []; };
    return FormBuilder;
}());
function FormBuilder_tsickle_Closure_declarations() {
    /** @type {?} */
    FormBuilder.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormBuilder.ctorParameters;
}
//# sourceMappingURL=form_builder.js.map

/***/ },

/***/ 315:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return isPromise; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var /** @type {?} */ isPromise = __WEBPACK_IMPORTED_MODULE_0__angular_core__["__core_private__"].isPromise;
//# sourceMappingURL=private_import_core.js.map

/***/ },

/***/ 34:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__facade_lang__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__private_import_core__ = __webpack_require__(315);
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return NG_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return NG_ASYNC_VALIDATORS; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return Validators; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
 * @stable
 */
var /** @type {?} */ NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {@link NG_VALIDATORS} for more details.
 *
 * @stable
 */
var /** @type {?} */ NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('NgAsyncValidators');
/**
 *  Provides a set of validators used by form controls.
  * *
  * A validator is a function that processes a {@link FormControl} or collection of
  * controls and returns a map of errors. A null map means that validation has passed.
  * *
  * ### Example
  * *
  * ```typescript
  * var loginControl = new FormControl("", Validators.required)
  * ```
  * *
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     *  Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     *  Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     *  Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     *  Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     *  Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = "^" + pattern + "$";
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     *  No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     *  Compose multiple validators into a single function that returns the union
      * of the individual error maps.
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = validators.filter(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */]);
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
            return Promise.all(promises).then(_mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} obj
 * @return {?}
 */
function _convertToPromise(obj) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__private_import_core__["a" /* isPromise */])(obj) ? obj : __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_toPromise__["toPromise"].call(obj);
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__facade_lang__["c" /* isPresent */])(errors) ? __WEBPACK_IMPORTED_MODULE_2__facade_collection__["a" /* StringMapWrapper */].merge(res, errors) : res;
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
//# sourceMappingURL=validators.js.map

/***/ },

/***/ 346:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_responsive_1 = __webpack_require__(166);
var ResponsoveService = (function () {
    function ResponsoveService(responsive) {
        var _this = this;
        this.responsive = responsive;
        this.media = 'xs';
        this.width = 0;
        this.mediaChange = this.responsive.elementoObservar;
        this.mediaChange.subscribe(function (media) { return _this.media = media; });
        this.widthChange = this.responsive.anchoObservar;
        this.widthChange.subscribe(function (width) { return _this.width = width; });
    }
    ResponsoveService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [ng2_responsive_1.ResponsiveState])
    ], ResponsoveService);
    return ResponsoveService;
}());
exports.ResponsoveService = ResponsoveService;


/***/ },

/***/ 347:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(560));
__export(__webpack_require__(557));
__export(__webpack_require__(551));
__export(__webpack_require__(553));
__export(__webpack_require__(547));
__export(__webpack_require__(556));
__export(__webpack_require__(555));
__export(__webpack_require__(548));
__export(__webpack_require__(550));
__export(__webpack_require__(549));
__export(__webpack_require__(554));
__export(__webpack_require__(552));
__export(__webpack_require__(546));
__export(__webpack_require__(558));
__export(__webpack_require__(559));
__export(__webpack_require__(114));


/***/ },

/***/ 399:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(46);
var http_1 = __webpack_require__(59);
var forms_1 = __webpack_require__(481);
// import { FormsModule, ReactiveFormsModule } from '@angular/forms';
var hmr_1 = __webpack_require__(252);
var ng2_webstorage_1 = __webpack_require__(115);
var ng2_responsive_1 = __webpack_require__(166);
var ng2_slim_loading_bar_1 = __webpack_require__(167);
var app_component_1 = __webpack_require__(538);
var app_routing_1 = __webpack_require__(539);
var session_service_1 = __webpack_require__(19);
var config_service_1 = __webpack_require__(10);
var scroll_service_1 = __webpack_require__(79);
var cart_service_1 = __webpack_require__(13);
var website_interface_service_1 = __webpack_require__(227);
var configurator_api_service_1 = __webpack_require__(78);
var translate_service_1 = __webpack_require__(151);
var responsive_service_1 = __webpack_require__(346);
var loading_panel_service_1 = __webpack_require__(226);
var braintree_payment_service_1 = __webpack_require__(225);
var safe_pipe_1 = __webpack_require__(541);
var translate_pipe_1 = __webpack_require__(542);
var euro_currency_pipe_1 = __webpack_require__(540);
var utilities_service_1 = __webpack_require__(42);
var configurator_1 = __webpack_require__(545);
var ng2_img_cropper_1 = __webpack_require__(165);
var angulartics2_1 = __webpack_require__(114);
// import { Uploader } from 'angular2-http-file-upload';
var pages_1 = __webpack_require__(347);
var AppModule = (function () {
    function AppModule(appRef) {
        this.appRef = appRef;
        // PageScrollConfig.defaultDuration = 300;
    }
    AppModule.prototype.hmrOnInit = function (store) {
        ////console.log('HMR store', store);
    };
    AppModule.prototype.hmrOnDestroy = function (store) {
        var cmpLocation = this.appRef.components.map(function (cmp) { return cmp.location.nativeElement; });
        // recreate elements
        store.disposeOldHosts = hmr_1.createNewHosts(cmpLocation);
        // remove styles
        hmr_1.removeNgStyles();
    };
    AppModule.prototype.hmrAfterDestroy = function (store) {
        // display new elements
        store.disposeOldHosts();
        delete store.disposeOldHosts;
    };
    AppModule = __decorate([
        core_1.NgModule({
            declarations: [
                pages_1.UploadPhotoComponent, pages_1.LoadProductComponent, pages_1.OrderCompletedComponent, pages_1.SelectProductsComponent, pages_1.SelectDimensionsComponent,
                pages_1.CartComponent, pages_1.CheckoutComponent, pages_1.CheckoutCampionarioComponent, pages_1.CampionarioCompletedComponent, pages_1.PageCropComponent,
                pages_1.PreviewComponent,
                pages_1.NoContentComponent,
                pages_1.BtnToggleComponent,
                pages_1.SimilFancyComponent,
                app_component_1.AppComponent,
                ng2_slim_loading_bar_1.SlimLoadingBarComponent,
                safe_pipe_1.SafePipe, translate_pipe_1.TranslatePipe, euro_currency_pipe_1.EuroCurrencyPipe,
                configurator_1.ConfiguratorComponent, configurator_1.ConfigControlComponent,
                pages_1.SlideParameterComponent
            ],
            imports: [
                platform_browser_1.BrowserModule,
                forms_1.FormsModule,
                http_1.HttpModule,
                app_routing_1.routing,
                ng2_webstorage_1.Ng2Webstorage,
                ng2_responsive_1.ResponsiveModule,
                ng2_img_cropper_1.ImageCropperModule,
                angulartics2_1.Angulartics2Module.forRoot([angulartics2_1.Angulartics2GoogleAnalytics, angulartics2_1.Angulartics2Facebook])
            ],
            providers: [
                session_service_1.SessionService,
                config_service_1.ConfigService,
                scroll_service_1.ScrollService,
                cart_service_1.CartService,
                utilities_service_1.UtilitiesService,
                website_interface_service_1.WebsiteInterfaceService,
                configurator_api_service_1.ConfiguratorApiService,
                translate_service_1.TranslateService,
                responsive_service_1.ResponsoveService,
                ng2_slim_loading_bar_1.SlimLoadingBarService,
                loading_panel_service_1.LoadingPanelService,
                braintree_payment_service_1.BraintreePaymentService,
            ],
            bootstrap: [app_component_1.AppComponent]
        }), 
        __metadata('design:paramtypes', [core_1.ApplicationRef])
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;


/***/ },

/***/ 40:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(203);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return ControlContainer; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 *  A directive that contains multiple {@link NgControl}s.
  * *
  * Only used by the forms module.
  * *
 */
var ControlContainer = (function (_super) {
    __extends(ControlContainer, _super);
    function ControlContainer() {
        _super.apply(this, arguments);
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         *  Get the form to which this container belongs.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         *  Get the path to this container.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
function ControlContainer_tsickle_Closure_declarations() {
    /** @type {?} */
    ControlContainer.prototype.name;
}
//# sourceMappingURL=control_container.js.map

/***/ },

/***/ 42:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(59);
var Observable_1 = __webpack_require__(1);
var session_service_1 = __webpack_require__(19);
var cart_service_1 = __webpack_require__(13);
var UtilitiesService = (function () {
    // @ViewChild('txtUserName') txtUserName: ElementRef;
    // @ViewChild('txtPassword') txtPassword: ElementRef;
    function UtilitiesService(_http, session, cartService) {
        this._http = _http;
        this.session = session;
        this.cartService = cartService;
    }
    // Data un'immagine, torna la relativa stringa in base64, per poterla salvare nello storage
    UtilitiesService.prototype.getBase64Image = function (img) {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        // Flip
        // ctx.translate(canvas.width, 0);
        // ctx.scale(-1, 1);
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL('image/jpeg', 1);
        return dataURL;
    };
    UtilitiesService.prototype.FlipImage = function (imgSrc) {
        var img = document.createElement('img');
        img.src = imgSrc;
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.translate(canvas.width, 0);
        ctx.scale(-1, 1);
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL('image/jpeg', 0.5);
        return dataURL;
    };
    UtilitiesService.prototype.setLoginData = function (user) {
        this.cartService.cart.customer.Email = user.Email;
        this.cartService.cart.customer.Phone = user.PhoneNumber;
        this.cartService.cart.customer.Name = user.Customer.Name;
        this.cartService.cart.customer.Surname = user.Customer.Surname;
        this.cartService.cart.customer.TaxCode = user.Customer.TaxCode;
        this.cartService.cart.customer.VatNumber = user.Customer.VatNumber;
        this.cartService.cart.billing.Email = user.Email;
        this.cartService.cart.billing.Phone = user.PhoneNumber;
        this.cartService.cart.billing.Name = user.Billing.Name;
        this.cartService.cart.billing.Surname = user.Billing.Surname;
        this.cartService.cart.billing.TaxCode = user.Billing.TaxCode;
        this.cartService.cart.billing.VatNumber = user.Billing.VatNumber;
        this.cartService.cart.billing.CodeSDI = user.Billing.CodeSDI;
        this.cartService.cart.billing.PEC = user.Billing.PEC;
        this.cartService.cart.shipmentAddress.City = user.Address.City;
        this.cartService.cart.shipmentAddress.Country = user.Address.Country;
        this.cartService.cart.shipmentAddress.District = user.Address.District;
        this.cartService.cart.shipmentAddress.Extended = user.Address.Extended;
        this.cartService.cart.shipmentAddress.Locality = user.Address.Locality;
        this.cartService.cart.shipmentAddress.PostalCode = user.Address.PostalCode;
        this.cartService.cart.shipmentAddress.Street = user.Address.Street;
        this.cartService.cart.billingAddress.City = user.Address.City;
        this.cartService.cart.billingAddress.Country = user.Address.Country;
        this.cartService.cart.billingAddress.District = user.Address.District;
        this.cartService.cart.billingAddress.Extended = user.Address.Extended;
        this.cartService.cart.billingAddress.Locality = user.Address.Locality;
        this.cartService.cart.billingAddress.PostalCode = user.Address.PostalCode;
        this.cartService.cart.billingAddress.Street = user.Address.Street;
    };
    UtilitiesService.prototype.cartTOTAL = function (cartTOTALUpdated) {
        if (cartTOTALUpdated === void 0) { cartTOTALUpdated = null; }
        this.cartService.cart.recalculateDeliveryPrice();
        if (this.cartService.cart.cartProducts.length > 0) {
            this.cartService.cart.totalPriceProducts =
                this.cartService.cart.cartProducts.map(function (r) { return r.totalPrice(); }).reduce(this.cartService.cart.getSum);
        }
        else {
            this.cartService.cart.totalPriceProducts = 0;
        }
        this.cartService.cart.totalALLPriceStatic = this.cartService.cart.totalPriceProducts + this.cartService.cart.delivPrice;
        // if (this.cartService.cart.couponLabel) {
        //   coupon = this.cartService.cart.couponLabel;
        // }
        this.CalculateCoupon(this.cartService.cart.couponLabel, cartTOTALUpdated);
        //console.log('cartTOTAL ' + this.cartService.cart.couponLabel, cartTOTALUpdated);
        if (this.cartService.cart.totalALLPriceStatic !== this.cartService.cart.TOTALCartORDER) {
            console.log('ATTENZIONE !!!!', 'this.TOTALCartORDER: ' + this.cartService.cart.TOTALCartORDER
                + ' - this.totalALLPriceStatic: ' + this.cartService.cart.totalALLPriceStatic);
        }
        else {
            console.log('OK totali');
        }
    };
    UtilitiesService.prototype.CalculateCoupon = function (coupon, cartTOTALUpdated, alertCoupon) {
        // let couponPass = new CouponData();
        // couponPass.couponEmail = this.cartService.cart.customer.Email;
        // couponPass.totalPrice = this.cartService.cart.totalALLPriceStatic;
        var _this = this;
        if (coupon === void 0) { coupon = null; }
        if (cartTOTALUpdated === void 0) { cartTOTALUpdated = null; }
        if (alertCoupon === void 0) { alertCoupon = false; }
        // if (coupon) {
        //   couponPass.couponLabel = coupon;
        // } else {
        //   couponPass.couponLabel = this.cartService.cart.couponLabel;
        // }
        // IMPOSTO TEMPORANEAMENTE IL COUPON NEL CARRELLO, SE NON VA A BUON FINE LO RESETTO
        this.cartService.cart.couponLabel = coupon;
        this.cartService.cart.couponEmail = this.cartService.cart.customer.Email;
        // 10-04-2018 passo il carrello con i prodotti per poterli ciclare ed applicare lo sconto ev. solo su alcuni
        this.requestAngular2('coupon', this.cartService.cart).subscribe(function (result) {
            if (result.result === 'ok') {
                _this.cartService.cart.TOTALCartORDER = result.newTotal;
                if (alertCoupon) {
                    alert('CODICE SCONTO APPLICATO CORRETTAMENTE');
                }
            }
            else {
                if (alertCoupon) {
                    alert(result.message);
                }
                //console.log(result.result, result.message);
                _this.cartService.cart.TOTALCartORDER = _this.cartService.cart.totalALLPriceStatic;
                _this.cartService.cart.couponLabel = null;
                _this.cartService.cart.couponEmail = null;
            }
            //console.log('cartTOTAL', this.cartService.cart.TOTALCartORDER);
            if (cartTOTALUpdated) {
                cartTOTALUpdated(_this.cartService.cart.TOTALCartORDER);
            }
        }, function (error) {
            console.error(error);
            //console.log(error.result, error.message);
            _this.cartService.cart.TOTALCartORDER = _this.cartService.cart.totalALLPriceStatic;
            _this.cartService.cart.couponLabel = null;
            _this.cartService.cart.couponEmail = null;
        });
    };
    UtilitiesService.prototype.AutoLogin = function (sessionState) {
        var _this = this;
        console.log('AutoLogin');
        this.requestAngular2('autologin', sessionState).subscribe(function (result) {
            console.log(result);
            // se login ok precompilo i dati
            if (result.Item1 === 'ok') {
                console.log(result.User);
                _this.setLoginData(result.Item2);
            }
            else {
                console.log(result.Item1);
                alert('Login fallito\r\nDati errati');
            }
        }, function (error) {
            console.error(error);
        });
    };
    UtilitiesService.prototype.Login = function () {
        var _this = this;
        console.log('Login');
        var txtUserName = document.getElementById('txtUserName');
        var txtPassword = document.getElementById('txtPassword');
        // ViewChild non funziona perchè in un componente interno, provare ViewChildren od altro.
        // let txtUserName = this.txtUserName.nativeElement;
        // let txtPassword = this.txtPassword.nativeElement;
        // console.log(txtPassword.value + txtUserName.value);
        var body = {
            username: txtUserName.value,
            password: txtPassword.value
        };
        this.requestAngular2('login', body).subscribe(function (result) {
            console.log(result);
            // se login ok precompilo i dati
            if (result.Item1 === 'ok') {
                console.log(result.User);
                _this.setLoginData(result.Item2);
                $('#mdLoginBox').modal('hide');
            }
            else {
                console.log(result.Item1);
                alert('Login fallito\r\nDati errati');
            }
        }, function (error) {
            console.error(error);
        });
    };
    /**
    * Fare una richiesta senza Ajax e senza aggiornare la pagina
    * Invisibile per l'utente
    * @param url string
    * @param params object
    * @param method string get or post
    **/
    UtilitiesService.prototype.requestWithoutAjax = function (url, params, method) {
        //console.log('requestWithoutAjax');
        params = params || {};
        method = method || 'post';
        // function to remove the iframe
        var removeIframe = function (iframe) {
            iframe.parentElement.removeChild(iframe);
        };
        // make a iframe...
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.onload = function () {
            var iframeDoc = this.contentWindow.document;
            // Make a invisible form
            var form = iframeDoc.createElement('form');
            form.method = method;
            form.action = url;
            iframeDoc.body.appendChild(form);
            // pass the parameters
            // tslint:disable-next-line:forin
            for (var name_1 in params) {
                var input = iframeDoc.createElement('input');
                input.type = 'hidden';
                input.name = name_1;
                input.value = params[name_1];
                form.appendChild(input);
            }
            form.submit();
            // remove the iframe
            setTimeout(function () {
                removeIframe(iframe);
            }, 500);
        };
        document.body.appendChild(iframe);
    };
    UtilitiesService.prototype.fileUpload = function (action, file) {
        var _this = this;
        var wsURL = this.session.outputUrl + '/' + action;
        console.log('fileUpload');
        var formData = new FormData();
        formData.append('file', file);
        return this._http.post(wsURL, formData, {
            headers: this.getHeaders()
        })
            .map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    UtilitiesService.prototype.requestAngular2 = function (action, params) {
        return this.requestAngular2Type(action, params);
    };
    /*ANGULAR2 REQUEST*/
    UtilitiesService.prototype.requestAngular2Type = function (action, params) {
        var _this = this;
        var wsURL = this.session.outputUrl + '/' + action;
        console.log('requestAngular2Type - ' + action);
        return this._http.post(wsURL, params, {
            headers: this.getHeaders()
        })
            .map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    UtilitiesService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        return headers;
    };
    UtilitiesService.prototype.mapResponse = function (res) {
        if (!res.ok) {
            console.log('requestAngular2Type- mapResponse');
            console.log(res);
            this.handleError(res);
        }
        else {
            return res.json();
        }
    };
    UtilitiesService.prototype.handleError = function (error) {
        console.log('requestAngular2Type -handleError');
        console.log(error);
        var errMsg;
        if (!!error._body) {
            // errMsg = JSON.stringify(error._body);
            var errJson = JSON.parse(JSON.stringify(error._body || null)); // JSON.parse(error._body);
            errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
        }
        else {
            errMsg = (error.message) ? error.message :
                error.status ? error.status + " - " + error.statusText : 'Server error';
        }
        console.log('error');
        console.error(errMsg); // log to console instead
        return Observable_1.Observable.throw(errMsg);
    };
    UtilitiesService.prototype._keyPress = function (event) {
        var pattern = /[0-9\+\-\ ]/;
        var inputChar = String.fromCharCode(event.charCode);
        console.log(inputChar, event.charCode);
        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
        }
    };
    UtilitiesService.prototype.validate = function (value) {
        console.log('validate-value: ' + value);
        if (value < 1) {
            this.cartService.cart.currentCartProduct.quantity = 1;
        }
        else if (value > 100) {
            this.cartService.cart.currentCartProduct.quantity = 100;
        }
        else {
            this.cartService.cart.currentCartProduct.quantity = value;
        }
    };
    UtilitiesService.prototype.validateCart = function (value, idRow) {
        console.log('validate-value: ' + value);
        var currentRow = this.cartService.cart.cartProducts.filter(function (r) { return r.idRow === idRow; })[0];
        if (currentRow != null) {
            if (value < 1) {
                currentRow.quantity = 1;
            }
            else if (value > 100) {
                currentRow.quantity = 100;
            }
            else {
                currentRow.quantity = value;
            }
        }
        this.cartService.saveCart();
    };
    UtilitiesService.prototype.refreshValue = function (myComponentRef, quantity) {
        console.log(myComponentRef);
        myComponentRef.value = quantity.toString();
    };
    UtilitiesService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [http_1.Http, session_service_1.SessionService, cart_service_1.CartService])
    ], UtilitiesService);
    return UtilitiesService;
}());
exports.UtilitiesService = UtilitiesService;


/***/ },

/***/ 481:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_forms__ = __webpack_require__(485);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgSelectOption", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AbstractFormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CheckboxControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ControlContainer", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NG_VALUE_ACCESSOR", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "DefaultValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControlStatus", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgControlStatusGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgForm", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgModel", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NgModelGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RadioControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControlName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroupDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormArrayName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroupName", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["r"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AbstractControlDirective", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["s"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SelectControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["t"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "SelectMultipleControlValueAccessor", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["u"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "CheckboxRequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["v"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "MaxLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["w"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "MinLengthValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["x"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "PatternValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["y"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "RequiredValidator", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["z"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormBuilder", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["A"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "AbstractControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["B"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormArray", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["C"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormControl", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["D"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["E"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NG_ASYNC_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["F"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "NG_VALIDATORS", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["G"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "Validators", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["H"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["I"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "FormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["J"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "ReactiveFormsModule", function() { return __WEBPACK_IMPORTED_MODULE_0__src_forms__["K"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */

//# sourceMappingURL=index.js.map

/***/ },

/***/ 482:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_ng_model__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_range_value_accessor__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_directive__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_control_name__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_directive__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_validators__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_ng_control__ = __webpack_require__(65);
/* unused harmony export SHARED_FORM_DIRECTIVES */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return TEMPLATE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "c", function() { return REACTIVE_DRIVEN_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return InternalFormsSharedModule; });
/* unused harmony reexport CheckboxControlValueAccessor */
/* unused harmony reexport DefaultValueAccessor */
/* unused harmony reexport NgControl */
/* unused harmony reexport NgControlStatus */
/* unused harmony reexport NgControlStatusGroup */
/* unused harmony reexport NgForm */
/* unused harmony reexport NgModel */
/* unused harmony reexport NgModelGroup */
/* unused harmony reexport NumberValueAccessor */
/* unused harmony reexport RadioControlValueAccessor */
/* unused harmony reexport RangeValueAccessor */
/* unused harmony reexport FormControlDirective */
/* unused harmony reexport FormControlName */
/* unused harmony reexport FormGroupDirective */
/* unused harmony reexport FormArrayName */
/* unused harmony reexport FormGroupName */
/* unused harmony reexport NgSelectOption */
/* unused harmony reexport SelectControlValueAccessor */
/* unused harmony reexport NgSelectMultipleOption */
/* unused harmony reexport SelectMultipleControlValueAccessor */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

































var /** @type {?} */ SHARED_FORM_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__["b" /* NgSelectOption */],
    __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__["b" /* NgSelectMultipleOption */],
    __WEBPACK_IMPORTED_MODULE_2__directives_default_value_accessor__["a" /* DefaultValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_7__directives_number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_9__directives_range_value_accessor__["a" /* RangeValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_1__directives_checkbox_value_accessor__["a" /* CheckboxControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_14__directives_select_control_value_accessor__["a" /* SelectControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_15__directives_select_multiple_control_value_accessor__["a" /* SelectMultipleControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_8__directives_radio_control_value_accessor__["a" /* RadioControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["a" /* NgControlStatus */],
    __WEBPACK_IMPORTED_MODULE_3__directives_ng_control_status__["b" /* NgControlStatusGroup */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["a" /* RequiredValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["b" /* MinLengthValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["c" /* MaxLengthValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["d" /* PatternValidator */],
    __WEBPACK_IMPORTED_MODULE_16__directives_validators__["e" /* CheckboxRequiredValidator */],
];
var /** @type {?} */ TEMPLATE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_5__directives_ng_model__["a" /* NgModel */], __WEBPACK_IMPORTED_MODULE_6__directives_ng_model_group__["a" /* NgModelGroup */], __WEBPACK_IMPORTED_MODULE_4__directives_ng_form__["a" /* NgForm */]];
var /** @type {?} */ REACTIVE_DRIVEN_DIRECTIVES = [__WEBPACK_IMPORTED_MODULE_10__directives_reactive_directives_form_control_directive__["a" /* FormControlDirective */], __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_group_directive__["a" /* FormGroupDirective */], __WEBPACK_IMPORTED_MODULE_11__directives_reactive_directives_form_control_name__["a" /* FormControlName */], __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__["a" /* FormGroupName */], __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_group_name__["b" /* FormArrayName */]];
/**
 *  Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    InternalFormsSharedModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: SHARED_FORM_DIRECTIVES,
                    exports: SHARED_FORM_DIRECTIVES,
                },] },
    ];
    /** @nocollapse */
    InternalFormsSharedModule.ctorParameters = function () { return []; };
    return InternalFormsSharedModule;
}());
function InternalFormsSharedModule_tsickle_Closure_declarations() {
    /** @type {?} */
    InternalFormsSharedModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    InternalFormsSharedModule.ctorParameters;
}
//# sourceMappingURL=directives.js.map

/***/ },

/***/ 483:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ exports["a"] = normalizeValidator;
/* harmony export (immutable) */ exports["b"] = normalizeAsyncValidator;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
//# sourceMappingURL=normalize_validator.js.map

/***/ },

/***/ 484:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_builder__ = __webpack_require__(314);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return ReactiveFormsModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 *  The ng module for forms.
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    FormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* TEMPLATE_DRIVEN_DIRECTIVES */],
                    providers: [__WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["b" /* RadioControlRegistry */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["b" /* InternalFormsSharedModule */], __WEBPACK_IMPORTED_MODULE_1__directives__["a" /* TEMPLATE_DRIVEN_DIRECTIVES */]]
                },] },
    ];
    /** @nocollapse */
    FormsModule.ctorParameters = function () { return []; };
    return FormsModule;
}());
function FormsModule_tsickle_Closure_declarations() {
    /** @type {?} */
    FormsModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormsModule.ctorParameters;
}
/**
 *  The ng module for reactive forms.
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    ReactiveFormsModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    declarations: [__WEBPACK_IMPORTED_MODULE_1__directives__["c" /* REACTIVE_DRIVEN_DIRECTIVES */]],
                    providers: [__WEBPACK_IMPORTED_MODULE_3__form_builder__["a" /* FormBuilder */], __WEBPACK_IMPORTED_MODULE_2__directives_radio_control_value_accessor__["b" /* RadioControlRegistry */]],
                    exports: [__WEBPACK_IMPORTED_MODULE_1__directives__["b" /* InternalFormsSharedModule */], __WEBPACK_IMPORTED_MODULE_1__directives__["c" /* REACTIVE_DRIVEN_DIRECTIVES */]]
                },] },
    ];
    /** @nocollapse */
    ReactiveFormsModule.ctorParameters = function () { return []; };
    return ReactiveFormsModule;
}());
function ReactiveFormsModule_tsickle_Closure_declarations() {
    /** @type {?} */
    ReactiveFormsModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    ReactiveFormsModule.ctorParameters;
}
//# sourceMappingURL=form_providers.js.map

/***/ },

/***/ 485:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__directives_control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__directives_validators__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__form_builder__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__model__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__version__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__form_providers__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(exports, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__directives_abstract_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__directives_abstract_form_group_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__directives_checkbox_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__directives_control_container__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__directives_control_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__directives_default_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__directives_ng_control__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__directives_ng_control_status__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "j", function() { return __WEBPACK_IMPORTED_MODULE_8__directives_ng_form__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__directives_ng_model__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "l", function() { return __WEBPACK_IMPORTED_MODULE_10__directives_ng_model_group__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "m", function() { return __WEBPACK_IMPORTED_MODULE_11__directives_radio_control_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "n", function() { return __WEBPACK_IMPORTED_MODULE_12__directives_reactive_directives_form_control_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "o", function() { return __WEBPACK_IMPORTED_MODULE_13__directives_reactive_directives_form_control_name__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "p", function() { return __WEBPACK_IMPORTED_MODULE_14__directives_reactive_directives_form_group_directive__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "q", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "r", function() { return __WEBPACK_IMPORTED_MODULE_15__directives_reactive_directives_form_group_name__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "a", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "t", function() { return __WEBPACK_IMPORTED_MODULE_16__directives_select_control_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "u", function() { return __WEBPACK_IMPORTED_MODULE_17__directives_select_multiple_control_value_accessor__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "w", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "x", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "y", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "z", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "v", function() { return __WEBPACK_IMPORTED_MODULE_18__directives_validators__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "A", function() { return __WEBPACK_IMPORTED_MODULE_19__form_builder__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "C", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "D", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "E", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "B", function() { return __WEBPACK_IMPORTED_MODULE_20__model__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "F", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "G", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "H", function() { return __WEBPACK_IMPORTED_MODULE_21__validators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "I", function() { return __WEBPACK_IMPORTED_MODULE_22__version__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "J", function() { return __WEBPACK_IMPORTED_MODULE_23__form_providers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(exports, "K", function() { return __WEBPACK_IMPORTED_MODULE_23__form_providers__["b"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */

























//# sourceMappingURL=forms.js.map

/***/ },

/***/ 486:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return VERSION; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * @stable
 */
var /** @type {?} */ VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('2.4.2');
//# sourceMappingURL=version.js.map

/***/ },

/***/ 53:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__facade_lang__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__normalize_validator__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__range_value_accessor__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__select_control_value_accessor__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__select_multiple_control_value_accessor__ = __webpack_require__(144);
/* harmony export (immutable) */ exports["a"] = controlPath;
/* harmony export (immutable) */ exports["d"] = setUpControl;
/* harmony export (immutable) */ exports["h"] = cleanUpControl;
/* harmony export (immutable) */ exports["e"] = setUpFormContainer;
/* harmony export (immutable) */ exports["b"] = composeValidators;
/* harmony export (immutable) */ exports["c"] = composeAsyncValidators;
/* harmony export (immutable) */ exports["g"] = isPropertyUpdated;
/* unused harmony export isBuiltInAccessor */
/* harmony export (immutable) */ exports["f"] = selectValueAccessor;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */










/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return parent.path.concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync([control.asyncValidator, dir.asyncValidator]);
    dir.valueAccessor.writeValue(control.value);
    // view -> model
    dir.valueAccessor.registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    });
    // touched
    dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        // control -> view
        dir.valueAccessor.writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (dir.valueAccessor.setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((validator)).registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
    dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["f" /* isBlank */])(control))
        _throwError(dir, 'Cannot find control with');
    control.validator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose([control.validator, dir.validator]);
    control.asyncValidator = __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (dir.path.length > 1) {
        messageEnd = "path: '" + dir.path.join(' -> ') + "'";
    }
    else if (dir.path[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].compose(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["a" /* normalizeValidator */])) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["c" /* isPresent */])(validators) ? __WEBPACK_IMPORTED_MODULE_1__validators__["a" /* Validators */].composeAsync(validators.map(__WEBPACK_IMPORTED_MODULE_4__normalize_validator__["b" /* normalizeAsyncValidator */])) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__facade_lang__["e" /* looseIdentical */])(viewModel, change.currentValue);
}
var /** @type {?} */ BUILTIN_ACCESSORS = [
    __WEBPACK_IMPORTED_MODULE_2__checkbox_value_accessor__["a" /* CheckboxControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_7__range_value_accessor__["a" /* RangeValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_5__number_value_accessor__["a" /* NumberValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_8__select_control_value_accessor__["a" /* SelectControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_9__select_multiple_control_value_accessor__["a" /* SelectMultipleControlValueAccessor */],
    __WEBPACK_IMPORTED_MODULE_6__radio_control_value_accessor__["a" /* RadioControlValueAccessor */],
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var /** @type {?} */ defaultAccessor;
    var /** @type {?} */ builtinAccessor;
    var /** @type {?} */ customAccessor;
    valueAccessors.forEach(function (v) {
        if (v.constructor === __WEBPACK_IMPORTED_MODULE_3__default_value_accessor__["a" /* DefaultValueAccessor */]) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
//# sourceMappingURL=shared.js.map

/***/ },

/***/ 538:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var responsive_service_1 = __webpack_require__(346);
var session_service_1 = __webpack_require__(19);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var scroll_service_1 = __webpack_require__(79);
var utilities_service_1 = __webpack_require__(42);
var configurator_api_service_1 = __webpack_require__(78);
var router_2 = __webpack_require__(8);
var angulartics2_1 = __webpack_require__(114);
var AppComponent = (function () {
    function AppComponent(session, router, responsive, cartService, scroll, configApi, config, utilities, activatedRoute, angulartics2, angulartics2GoogleAnalytics, angulartics2Facebook) {
        this.session = session;
        this.router = router;
        this.responsive = responsive;
        this.cartService = cartService;
        this.scroll = scroll;
        this.configApi = configApi;
        this.config = config;
        this.utilities = utilities;
        this.activatedRoute = activatedRoute;
        this.angulartics2 = angulartics2;
        this.angulartics2GoogleAnalytics = angulartics2GoogleAnalytics;
        this.angulartics2Facebook = angulartics2Facebook;
        this.classe = 'active';
        this.media = 'xs';
        this.isXS = false;
        this.showHideNav = false;
    }
    AppComponent.prototype.changeShowStatus = function () {
        this.showHideNav = !this.showHideNav;
    };
    AppComponent.prototype.sendAnalytics = function () {
        var newRoute = window.location.href.replace(this.config.urlHost, '/');
        ga('send', 'pageview', newRoute);
        ////console.log('ANALYTICS - send to ga: ' + newRoute);
        var ecomm_prodids = '';
        this.cartService.cart.cartProducts.forEach(function (prod) {
            if (prod.idProduct) {
                ecomm_prodids += prod.idProduct.toString() + ',';
            }
        });
        // fbq('track', 'PageView');
        //console.log('FACEBOOK PIXEL - send to fbq: \'track\', \'PageView\'');
        // this.angulartics2Facebook.eventTrack('track', 'PageView');
        //console.log('FACEBOOK PIXEL - send to fbq: \'track\', \'PageView\'');
        //     // this.angulartics2.eventTrack.next({ action: 'View page', properties: { category: newRoute } });
        //     // this.angulartics2.settings.pageTracking.trackRelativePath = true;
        //     // this.angulartics2.pageTrack.subscribe((x: any) => this.pageTrack(x.path));
        //     // this.angulartics2.eventTrack.subscribe((x: any) =>
        //     //   ga('send', 'pageview', x.path)
        //     // );
    };
    AppComponent.prototype.ngOnInit = function () {
        ////console.log('ngOnInit');
        var _this = this;
        if (this.session.isLogged()) {
            ////console.log('UTENTE isLogged : utilities.AutoLogin');
            ////console.log(this.session.sessionState);
            this.utilities.AutoLogin(this.session.sessionState);
        }
        ////console.log('ngOnInit - app.component');
        this.responsive.mediaChange.subscribe(function (media) {
            _this.media = media;
            _this.isXS = media === 'xs';
        });
        this.activatedRoute.params.subscribe(function (params) {
            if (params['paramsTable']) {
                _this.table = 'Navbar' + params['paramsTable'];
            }
        });
        this.RouteMenu = this.router.config;
        this.cartService.cartCheckProducts();
        if (this.cartService.cart.currentCartProduct) {
            if (!this.cartService.cart.currentCartProduct.config) {
                this.cartService.cart.currentCartProduct.config = this.config.products[0];
            }
        }
        else {
            this.session.setProduct(this.config.products.filter(function (x) { return x.idModel === 9; })[0], '', '');
        }
        // this.cartService.saveCart();
        // this.session.getParamTree();
        this.session.setBtnToggle(this.session.params);
        this.router.events.subscribe(function (route) {
            if (route instanceof router_2.NavigationEnd) {
                _this.sendAnalytics();
                window.scrollTo(0, 0);
                $('html, body').animate({ scrollTop: 0 }, 'slow');
            }
        });
        this.sendAnalytics();
    };
    AppComponent.prototype.ShowPREVButton = function () {
        var thisUrl = this.router.url.toString();
        if (thisUrl.indexOf('select-products') > -1) {
            return false;
        }
        else {
            return true;
        }
    };
    AppComponent.prototype.ShowNEXTButton = function () {
        var thisUrl = this.router.url.toString();
        if (thisUrl.indexOf('checkout') > -1 || thisUrl.indexOf('pagecrop') > -1) {
            return false;
        }
        else {
            return true;
        }
    };
    AppComponent.prototype.IdStep = function () {
        var _this = this;
        this.table = this.router.url.substring(1);
        var thisButton = this.config.btnToggles.filter(function (r) { return r.url === _this.table; })[0];
        if (thisButton) {
            return (this.config.btnToggles.indexOf(thisButton) + 1).toString();
        }
        else {
            var thisUrl = this.router.url.toString();
            if (thisUrl.indexOf('checkout') > -1) {
                return 'checkout';
            }
            else if (thisUrl.indexOf('cart') > -1) {
                return 'cart';
            }
            else if (thisUrl.indexOf('pagecrop') > -1) {
                return 'ritaglio';
            }
            else {
                return '';
            }
        }
    };
    AppComponent.prototype.PrevStep = function () {
        var _this = this;
        this.table = this.router.url.substring(1);
        var thisSlideSort = 0;
        var thisButton = this.config.btnToggles.filter(function (r) { return r.url === _this.table; })[0];
        var thisUrl = this.router.url.toString();
        if (thisUrl.indexOf('checkout') > -1) {
            this.cambiaSlide('cart');
        }
        else if (thisUrl.indexOf('cart') > -1) {
            this.cambiaSlide('preview');
        }
        if (thisButton) {
            thisSlideSort = thisButton.sort;
            var NextUrl = this.config.btnToggles.filter(function (r) { return r.sort < thisSlideSort; }).reverse();
            if (NextUrl[0]) {
                this.cambiaSlide(NextUrl[0].url);
            } /*else {
              this.cambiaSlide('preview');
            }*/
        }
        // else if (thisUrl.indexOf('slide-parameter') > -1)
        // {
        //   this.cambiaSlide('preview');
        // }
    };
    AppComponent.prototype.NextStep = function () {
        ////console.log('this.config.btnToggles', this.config.btnToggles);
        var _this = this;
        this.table = this.router.url.substring(1);
        var thisSlideSort = 0;
        var thisButton = this.config.btnToggles.filter(function (r) { return r.url === _this.table; })[0];
        var thisUrl = this.router.url.toString();
        if (thisButton) {
            thisSlideSort = thisButton.sort;
            var NextUrl = this.config.btnToggles.filter(function (r) { return r.sort > thisSlideSort; });
            if (NextUrl[0]) {
                this.cambiaSlide(NextUrl[0].url);
            }
            else if (thisUrl.indexOf('preview') > -1) {
                this.cambiaSlide('cart');
            }
            else {
                this.cambiaSlide('preview');
            }
        }
        else if (thisUrl.indexOf('cart') > -1) {
            this.cambiaSlide('checkout');
        }
    };
    AppComponent.prototype.cambiaSlide = function (link) {
        if (this.router.url !== ('/' + link)) {
            this.classe = 'inactive';
            this.router.navigate(['/' + link]);
            this.classe = 'active';
            window.scrollTo(0, 0);
        }
        this.showHideNav = false;
    };
    AppComponent.prototype.toggleSlide = function (cmp) {
        if (this.classe === 'active') {
            this.classe = 'inactive';
        }
        else {
            this.classe = 'active';
        }
    };
    AppComponent.prototype.isDisabled = function (text, parameter) {
        if (this.session.params && this.session.params.length !== 0) {
            var thisParam = this.session.params.filter(function (p) { return p.table === text && p.reportTable === 'Navbar'; })[0];
            var result = '';
            if (parameter && thisParam.type === 'Hidden' && thisParam.table !== 'NavbarFormato') {
                result = 'hidden';
            }
            return result;
        }
        return 'hidden';
    };
    AppComponent = __decorate([
        core_1.Component({
            selector: 'my-app',
            encapsulation: core_1.ViewEncapsulation.None,
            template: __webpack_require__(601),
            styles: [__webpack_require__(599)],
            animations: [
                core_1.trigger('AnimationSlide', [
                    core_1.state('inactive', core_1.style({ left: '-110%' })),
                    core_1.state('active', core_1.style({ left: '0' })),
                    core_1.transition('inactive <=> active', core_1.animate('400ms cubic-bezier(0.5,-0.6,0.5,1.6)'))
                ]),
                core_1.trigger('OpenShowSlide', [
                    core_1.state('inactive', core_1.style({ left: 'calc(-100% - 25px)' })),
                    core_1.state('active', core_1.style({ left: '0' })),
                    core_1.transition('inactive <=> active', core_1.animate('400ms cubic-bezier(0.5,-0.6,0.5,1.6)'))
                ])
            ]
        }), 
        __metadata('design:paramtypes', [session_service_1.SessionService, router_1.Router, responsive_service_1.ResponsoveService, cart_service_1.CartService, scroll_service_1.ScrollService, configurator_api_service_1.ConfiguratorApiService, config_service_1.ConfigService, utilities_service_1.UtilitiesService, router_2.ActivatedRoute, angulartics2_1.Angulartics2, angulartics2_1.Angulartics2GoogleAnalytics, angulartics2_1.Angulartics2Facebook])
    ], AppComponent);
    return AppComponent;
}());
exports.AppComponent = AppComponent;


/***/ },

/***/ 539:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var router_1 = __webpack_require__(8);
var pages_1 = __webpack_require__(347);
var routes = [
    { path: '', redirectTo: 'select-products', pathMatch: 'full' },
    {
        path: 'load-product/:idProduct', component: pages_1.LoadProductComponent, data: {
            id: 0, sort: 0, title: 'Precarica prodotto', isMenu: false
        }
    },
    {
        path: 'load-image/:urlFileCatalog', component: pages_1.LoadProductComponent, data: {
            id: 0, sort: 0, title: 'Precarica immagine da Catalogo', isMenu: false
        }
    },
    { path: 'order-completed/:idTransaction', component: pages_1.OrderCompletedComponent },
    { path: 'campionario-completed/:idTransaction', component: pages_1.CampionarioCompletedComponent },
    { path: 'checkout-campionario', component: pages_1.CheckoutCampionarioComponent },
    { path: 'select-products', component: pages_1.SelectProductsComponent, data: { id: 1, sort: 1, title: 'Seleziona prodotto', isMenu: true } },
    { path: 'upload-photo', component: pages_1.UploadPhotoComponent, data: { id: 2, sort: 2, title: 'Carica la tua foto', isMenu: true } },
    { path: 'preview', component: pages_1.PreviewComponent, data: { id: 4, sort: 99, title: 'Anteprima', isMenu: true } },
    { path: 'cart', component: pages_1.CartComponent, data: { id: 5, sort: 5, title: 'Carrello', isMenu: false } },
    { path: 'checkout', component: pages_1.CheckoutComponent, data: { id: 6, sort: 6, title: 'Checkout', isMenu: false } },
    { path: 'pagecrop', component: pages_1.PageCropComponent, data: { id: 7, sort: 7, title: 'PageCropComponent', isMenu: false } },
    {
        path: 'slide-parameter/Formato', component: pages_1.SelectDimensionsComponent, data: {
            id: 3, sort: 3, title: 'Seleziona Dimensioni', isMenu: false
        }
    },
    {
        path: 'slide-parameter/:paramsTable', component: pages_1.SlideParameterComponent, data: {
            id: 8, sort: 8, title: 'SlideParameterComponent', isMenu: false
        }
    },
    { path: '**', component: pages_1.NoContentComponent }
];
exports.routing = router_1.RouterModule.forRoot(routes, { useHash: true });


/***/ },

/***/ 540:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var EuroCurrencyPipe = (function () {
    function EuroCurrencyPipe() {
    }
    EuroCurrencyPipe.prototype.transform = function (value) {
        if (value && !isNaN(value)) {
            return parseFloat(value).toFixed(2) + ' €';
        }
        return '0.00 €';
    };
    EuroCurrencyPipe = __decorate([
        core_1.Pipe({ name: 'euroCurrency' }), 
        __metadata('design:paramtypes', [])
    ], EuroCurrencyPipe);
    return EuroCurrencyPipe;
}());
exports.EuroCurrencyPipe = EuroCurrencyPipe;


/***/ },

/***/ 541:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(46);
var SafePipe = (function () {
    function SafePipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    SafePipe.prototype.transform = function (url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    };
    SafePipe = __decorate([
        core_1.Pipe({ name: 'safe' }), 
        __metadata('design:paramtypes', [platform_browser_1.DomSanitizer])
    ], SafePipe);
    return SafePipe;
}());
exports.SafePipe = SafePipe;


/***/ },

/***/ 542:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var session_service_1 = __webpack_require__(19);
var translate_service_1 = __webpack_require__(151);
var TranslatePipe = (function () {
    function TranslatePipe(session, translate) {
        this.session = session;
        this.translate = translate;
    }
    TranslatePipe.prototype.transform = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        // let ret;
        return this.translate
            .getTranslations(this.session._productConfig.resx, this.session.lang)
            .map(function (t) { return t[key] || key; });
        // return ret;
    };
    TranslatePipe = __decorate([
        core_1.Pipe({ name: 'translate' }), 
        __metadata('design:paramtypes', [session_service_1.SessionService, translate_service_1.TranslateService])
    ], TranslatePipe);
    return TranslatePipe;
}());
exports.TranslatePipe = TranslatePipe;


/***/ },

/***/ 543:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var scroll_service_1 = __webpack_require__(79);
var cart_service_1 = __webpack_require__(13);
var models_1 = __webpack_require__(55);
var router_1 = __webpack_require__(8);
var ConfigControlComponent = (function () {
    function ConfigControlComponent(config, router, session, scroll, cartService) {
        this.config = config;
        this.router = router;
        this.session = session;
        this.scroll = scroll;
        this.cartService = cartService;
        this.valueChange = new core_1.EventEmitter();
    }
    ConfigControlComponent.prototype.ngOnInit = function () {
        //console.log(this.param);
    };
    ConfigControlComponent.prototype.GoPersonalized = function (cmp, link) {
        this.router.navigate(['/' + link]);
    };
    ConfigControlComponent.prototype.setFormat = function (param, format, goNext) {
        if (this.EnableFormat(format)) {
            this.cartService.setFormat(format);
            this.onValueChange(param, format);
            // alert(goNext);
            if (goNext) {
                this.NextStep();
            }
        }
        else {
            var avviso = 'ATTENZIONE !\r\nImmagine troppo piccola per questo formato\r\nCaricare un immagine maggiormente risoluta';
            alert(avviso);
        }
    };
    ConfigControlComponent.prototype.NextStep = function () {
        var stringTable = 'Navbar' + this.router.url.split('/').reverse()[0];
        ////console.log('this.table: ' + stringTable);
        var thisSlideSort = 0;
        var thisButton = this.config.btnToggles.filter(function (r) { return r.isParameter && r.text === stringTable; })[0];
        if (thisButton) {
            thisSlideSort = thisButton.sort;
            var NextUrl = this.config.btnToggles.filter(function (r) { return r.isParameter && r.sort > thisSlideSort; })[0];
            if (NextUrl) {
                this.router.navigate(['/' + NextUrl.url]);
            }
        }
    };
    ConfigControlComponent.prototype.IsActiveFormat = function (format) {
        return this.cartService.cart.currentCartProduct.format === format.split('|')[0] + '|' + format.split('|')[1] ? 'active' : '';
    };
    ConfigControlComponent.prototype.EnableFormat = function (value) {
        if (value != null) {
            var isOK = false;
            var width = value.split('|')[2];
            var height = value.split('|')[3];
            if (!this.session.swapFormatSizes) {
                height = value.split('|')[2];
                width = value.split('|')[3];
            }
            if ((this.cartService.cart.currentCartProduct.naturalHeight > (height * this.config.RappRisoluzMin))
                &&
                    (this.cartService.cart.currentCartProduct.naturalWidth > (width * this.config.RappRisoluzMin))) {
                isOK = true;
            }
            return isOK;
        }
        else {
            return true;
        }
    };
    ConfigControlComponent.prototype.onValueChange = function (param, value) {
        //console.log('Changed: ' + param);
        this.valueChange.emit(value);
    };
    ConfigControlComponent.prototype.group = function (values, size) {
        var ret = [];
        var groups = Math.floor(values.length / size);
        for (var i = 0; i < groups; i++) {
            ret.push({ values: values.slice(i * size, (i + 1) * size) });
        }
        if ((values.length % size) !== 0) {
            ret.push({ values: values.slice(groups * size) });
        }
        return ret;
    };
    ConfigControlComponent.prototype.isLabelLink = function (param) {
        return param.type === 'Label' || (param.type === 'Combo' && param.values.length <= 1);
    };
    ConfigControlComponent.prototype.getParamImage = function (paramName, value) {
        if (value === 'NONE') {
            return this.config.imagesUrl + "/param_ico/none.png";
        }
        else {
            var extension = ".png";
            if (paramName == "SistemaFissaggio") {
                extension = ".jpg";
            }
            return this.config.imagesUrl + "/param_ico/" + paramName + "/" + value + extension;
        }
    };
    ConfigControlComponent.prototype.getImage = function (param, value) {
        var name = param.name + "_" + value;
        return this.config.imagesUrl + "/" + this.model + "/" + (this.config.imageMap[name] || name) + ".jpg";
    };
    ConfigControlComponent.prototype.FormatsFiltered = function (items, filtro) {
        var arrayFiltrato = items.filter(function (item) { return item.value.indexOf(filtro) !== -1; });
        return arrayFiltrato;
    };
    ConfigControlComponent.prototype.DistinctFormat = function (items) {
        var uniqueNames = [];
        items.forEach(function (element) {
            var formatCateg = element.value.split('|')[0];
            if (uniqueNames.indexOf(formatCateg) === -1) {
                uniqueNames.push(formatCateg);
            }
        });
        return uniqueNames;
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ConfigControlComponent.prototype, "model", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], ConfigControlComponent.prototype, "showHidden", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', models_1.Param)
    ], ConfigControlComponent.prototype, "param", void 0);
    __decorate([
        core_1.Output('valueChange'), 
        __metadata('design:type', core_1.EventEmitter)
    ], ConfigControlComponent.prototype, "valueChange", void 0);
    ConfigControlComponent = __decorate([
        core_1.Component({
            selector: 'config-control',
            template: __webpack_require__(602),
            // styles: [require('./config-control.component.scss')],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, router_1.Router, session_service_1.SessionService, scroll_service_1.ScrollService, cart_service_1.CartService])
    ], ConfigControlComponent);
    return ConfigControlComponent;
}());
exports.ConfigControlComponent = ConfigControlComponent;


/***/ },

/***/ 544:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var scroll_service_1 = __webpack_require__(79);
var translate_service_1 = __webpack_require__(151);
var website_interface_service_1 = __webpack_require__(227);
var configurator_api_service_1 = __webpack_require__(78);
var loading_panel_service_1 = __webpack_require__(226);
var models_1 = __webpack_require__(55);
var cart_service_1 = __webpack_require__(13);
var utilities_service_1 = __webpack_require__(42);
var ConfiguratorComponent = (function () {
    function ConfiguratorComponent(config, session, scroll, translate, configApi, website, loadingPanel, cartService, utilities) {
        this.config = config;
        this.session = session;
        this.scroll = scroll;
        this.translate = translate;
        this.configApi = configApi;
        this.website = website;
        this.loadingPanel = loadingPanel;
        this.cartService = cartService;
        this.utilities = utilities;
    }
    Object.defineProperty(ConfiguratorComponent.prototype, "validParams", {
        get: function () {
            var t = !this.tables ? null : this.tables.split(',');
            var ret = [];
            this.session.validParams.forEach(function (vp) {
                if (t === null) {
                    ret.push(vp);
                }
                else {
                    ret.push({
                        page: vp.page,
                        params: vp.params.filter(function (p) { return t.indexOf(p.table) >= 0; }),
                        hidden: vp.hidden,
                        image: vp.image,
                        isPackage: vp.isPackage
                    });
                }
            });
            return ret;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConfiguratorComponent.prototype, "model", {
        get: function () {
            return this.session.thisModel;
        },
        enumerable: true,
        configurable: true
    });
    ConfiguratorComponent.prototype.ngOnInit = function () {
        //console.log('ngOnInit - configurator.component' + this.session.productConfig.xml);
        // if (this.productConfig) {
        //   this.hasPackage = this.productConfig.hasPackage;
        //   this.session.configureAsPackage = this.productConfig.hasPackage;
        //   this.session.getParamTree();
        // }
    };
    ConfiguratorComponent.prototype.ngOnChanges = function () {
        ////console.log('ngOnChanges - configurator - ' + this.productConfig.name);
        if (this.productConfig) {
            this.hasPackage = this.productConfig.hasPackage;
            this.session.configureAsPackage = this.productConfig.hasPackage;
            this.session.getParamTree();
        }
    };
    ConfiguratorComponent.prototype.group = function (values, size) {
        var ret = [];
        var groups = Math.floor(values.length / size);
        for (var i = 0; i < groups; i++) {
            ret.push({ values: values.slice(i * size, (i + 1) * size) });
        }
        if ((values.length % size) !== 0) {
            ret.push({ values: values.slice(groups * size) });
        }
        return ret;
    };
    ConfiguratorComponent.prototype.closeNoPackageSelectedModal = function (switchToCustom) {
        this.showNoPackageSelectedModal = false;
        if (switchToCustom) {
            this.session.changeParam(this.session.lastChangeParam, this.session.lastChangeValue);
            this.session.configureAsPackage = false;
        }
    };
    ConfiguratorComponent.prototype.getParamImage = function (name) {
        return this.config.imagesUrl + "/" + this.productConfig.name + "/Param_" + name + ".jpg";
    };
    ConfiguratorComponent.prototype.paramChanged = function (param, value) {
        this.utilities.cartTOTAL();
        this.session.changeParam(param, value);
        this.scroll.ResetScrollLeft(this.cartService.cart.currentCartProduct ? this.cartService.cart.currentCartProduct.format : '');
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', models_1.ProductConfig)
    ], ConfiguratorComponent.prototype, "productConfig", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], ConfiguratorComponent.prototype, "tables", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', core_1.EventEmitter)
    ], ConfiguratorComponent.prototype, "configChange", void 0);
    ConfiguratorComponent = __decorate([
        core_1.Component({
            selector: 'configurator',
            template: __webpack_require__(603),
            styles: [__webpack_require__(600)]
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, session_service_1.SessionService, scroll_service_1.ScrollService, translate_service_1.TranslateService, configurator_api_service_1.ConfiguratorApiService, website_interface_service_1.WebsiteInterfaceService, loading_panel_service_1.LoadingPanelService, cart_service_1.CartService, utilities_service_1.UtilitiesService])
    ], ConfiguratorComponent);
    return ConfiguratorComponent;
}());
exports.ConfiguratorComponent = ConfiguratorComponent;


/***/ },

/***/ 545:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(__webpack_require__(544));
__export(__webpack_require__(543));


/***/ },

/***/ 546:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var session_service_1 = __webpack_require__(19);
var cart_service_1 = __webpack_require__(13);
var configurator_api_service_1 = __webpack_require__(78);
var translate_service_1 = __webpack_require__(151);
var BtnToggleComponent = (function () {
    function BtnToggleComponent(router, session, cartService, configApi, translate) {
        this.router = router;
        this.session = session;
        this.cartService = cartService;
        this.configApi = configApi;
        this.translate = translate;
        this.text = 'testo';
        this.clickBtn = new core_1.EventEmitter();
    }
    BtnToggleComponent.prototype.getBtnDesc = function () {
        var _this = this;
        //console.log(this.text);
        if (this.number === 1) {
            return [this.session.productConfig.name];
        }
        else if (this.text === 'NavbarFormato') {
            return [
                this.cartService.cart.currentCartProduct.format ?
                    this.cartService.cart.currentCartProduct.format.split('|')[1].split('_').join('')
                    : null,
                this.session.orientamento
            ];
        }
        else if (this.parameter) {
            var prms = this.session.params
                .filter(function (p) { return p.table === _this.text && p.reportTable === 'Navbar' && p.type !== 'Hidden'; })
                .sort(function (p1, p2) { return p2.sort - p1.sort; })
                .reverse()
                .map(function (p) { return p.selectedValue.replace('F_', '').replace('_x_', ' x '); });
            return prms;
        }
        return [];
    };
    BtnToggleComponent.prototype.visibility = function () {
        var _this = this;
        var thisParam = this.session.params.filter(function (p) { return p.table === _this.text && p.reportTable === 'Navbar'; })[0];
        var isDisabled = '';
        if (thisParam) {
            if (this.parameter && thisParam.type === 'Hidden' && thisParam.table !== 'NavbarFormato') {
                isDisabled = ' hidden';
            }
        }
        if (this.router.isActive('/' + this.url, true)) {
            return 'active' + isDisabled;
        }
        else {
            return 'inactive' + isDisabled;
        }
    };
    BtnToggleComponent.prototype.isEnabled = function () {
        var stateEnabled = 'enabled'; // 'disabled';
        if (this.url === 'select-products' || this.url === 'upload-photo') {
            stateEnabled = 'enabled';
        }
        if (this.cartService.cart.currentCartProduct != null) {
            if (this.url === 'slide-parameter/Formato') {
                if (this.cartService.cart.currentCartProduct.photoOriginal != null) {
                    stateEnabled = 'enabled';
                }
            }
            else if (this.url === 'preview') {
                if (this.cartService.cart.currentCartProduct.photoResized != null) {
                    stateEnabled = 'enabled';
                }
            }
        }
        return stateEnabled;
    };
    BtnToggleComponent.prototype.isParameter = function () {
        if (this.parameter === true) {
            return 'isparameter';
        }
        else {
            return null;
        }
    };
    BtnToggleComponent.prototype.changeState = function () {
        if (this.isEnabled() === 'enabled') {
            this.clickBtn.emit(this);
        }
    };
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], BtnToggleComponent.prototype, "text", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], BtnToggleComponent.prototype, "url", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], BtnToggleComponent.prototype, "sort", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Number)
    ], BtnToggleComponent.prototype, "number", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], BtnToggleComponent.prototype, "parameter", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], BtnToggleComponent.prototype, "clickBtn", void 0);
    BtnToggleComponent = __decorate([
        core_1.Component({
            selector: 'mybtnToggle',
            template: "\n    <li class=\"btnToggle {{ this.visibility() }} {{ this.isEnabled() }} {{this.isParameter()}}\" (click)=\"changeState($event)\">\n\n      <span class=\"number\">{{this.number}}</span>\n\n      <a title=\"{{this.sort}} {{this.text}} {{this.url}}\">\n\n          {{this.text | translate | async}}\n\n          <div class=\"nameproduct\">\n            <div *ngFor=\"let v of this.getBtnDesc()\">{{ v ? (v | translate | async) : '' }} </div>\n          </div>\n\n          <i class=\"fa fa-angle-right big\"></i>\n      </a>\n\n    </li>\n\n  "
        }), 
        __metadata('design:paramtypes', [router_1.Router, session_service_1.SessionService, cart_service_1.CartService, configurator_api_service_1.ConfiguratorApiService, translate_service_1.TranslateService])
    ], BtnToggleComponent);
    return BtnToggleComponent;
}());
exports.BtnToggleComponent = BtnToggleComponent;


/***/ },

/***/ 547:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var router_1 = __webpack_require__(8);
var CampionarioCompletedComponent = (function () {
    function CampionarioCompletedComponent(cartService, config, activatedRoute, router) {
        this.cartService = cartService;
        this.config = config;
        this.activatedRoute = activatedRoute;
        this.router = router;
    }
    CampionarioCompletedComponent.prototype.ngOnInit = function () {
        $('#loaderApp').hide();
        var idTransaction = 0;
        this.activatedRoute.params.subscribe(function (params) {
            idTransaction = params['idTransaction'];
        });
        if (idTransaction !== 0) {
            // FACEBOOK ECOMMERCE
            fbq('track', 'Purchase', {
                content_ids: 99,
                content_type: 'product',
                value: this.config.campionarioPrice,
                currency: 'EUR'
            });
            // ANALYTICS ECOMMERCE
            ga('require', 'ecommerce', 'ecommerce.js');
            ga('ecommerce:addTransaction', {
                'id': idTransaction,
                'affiliation': 'Topcolor - Campionario',
                'revenue': this.config.campionarioPrice,
                'shipping': 0,
                'tax': this.config.campionarioPrice - (this.config.campionarioPrice / 1.22)
            });
            ga('ecommerce:send');
        }
    };
    CampionarioCompletedComponent = __decorate([
        core_1.Component({
            selector: 'campionario-completed',
            template: __webpack_require__(604),
        }), 
        __metadata('design:paramtypes', [cart_service_1.CartService, config_service_1.ConfigService, router_1.ActivatedRoute, router_1.Router])
    ], CampionarioCompletedComponent);
    return CampionarioCompletedComponent;
}());
exports.CampionarioCompletedComponent = CampionarioCompletedComponent;


/***/ },

/***/ 548:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(13);
var session_service_1 = __webpack_require__(19);
var configurator_api_service_1 = __webpack_require__(78);
var utilities_service_1 = __webpack_require__(42);
var CartComponent = (function () {
    function CartComponent(router, cartService, session, configApi, utilities) {
        this.router = router;
        this.cartService = cartService;
        this.session = session;
        this.configApi = configApi;
        this.utilities = utilities;
        this.ecomm_prodids = '';
        this.ecomm_value = 0;
    }
    CartComponent.prototype.removeCartProduct = function (idRow) {
        this.cartService.removeCartRow(idRow);
        //console.log('removeCartProduct');
        this.cartService.cartCheckProducts();
    };
    CartComponent.prototype.removeCartConfirm = function (product) {
        alert('TO DO');
    };
    CartComponent.prototype.ngOnInit = function () {
        var _this = this;
        ////console.log('ngOnInit - cartCheckProducts:');
        this.cartService.cartCheckProducts();
        this.cartService.cartCheckCROPPED();
        ////console.log('cartProducts.forEach - ga(ecommerce:addItem...' );
        this.cartService.cart.cartProducts.forEach(function (prod) {
            _this.ecomm_prodids += '\'' + prod.idProduct + '\',';
            _this.ecomm_value += prod.totalPriceStatic;
            ga('ecommerce:addItem', {
                'id': prod.idProduct,
                'name': prod.productName,
                'sku': prod.idProduct,
                'category': prod.config.idModel,
                'price': (prod.price + prod.additionalPrice),
                'quantity': prod.quantity
            });
        });
        ga('ecommerce:send');
        this.ecomm_prodids = this.ecomm_prodids.substring(0, this.ecomm_prodids.length - 1);
        ////console.log('ecomm_prodid: ' + this.ecomm_prodids + ' - this.ecomm_value: ' + this.ecomm_value);
        fbq('track', 'AddToCart', {
            content_ids: [this.ecomm_prodids],
            content_type: 'product',
            value: this.ecomm_value,
            currency: 'EUR'
        });
    };
    CartComponent.prototype.addNewProduct = function () {
        if (this.cartService.cart.currentCartProduct != null) {
            this.cartService.cloneProduct();
        }
        else {
            this.cartService.addProduct(this.cartService.cart.currentCartProduct.idProduct, 1);
        }
        this.router.navigate(['/upload-photo']);
    };
    CartComponent.prototype.userEvt = function (idRowquantity) {
        var idRow = Number(idRowquantity.split(';')[0]);
        var quantity = Number(idRowquantity.split(';')[0]);
        //console.log('idRow:' + idRow + ' quantity:' + quantity);
        this.cartService.refreshQuantity(idRow, quantity);
    };
    CartComponent.prototype.getListParam = function (cli) {
        if (cli.params) {
            return cli.params.filter(function (p) { return p.reportTable === 'Navbar' && p.type !== 'Hidden'; });
        }
        else {
            return null;
        }
    };
    CartComponent = __decorate([
        core_1.Component({
            selector: 'cart',
            template: __webpack_require__(605),
        }), 
        __metadata('design:paramtypes', [router_1.Router, cart_service_1.CartService, session_service_1.SessionService, configurator_api_service_1.ConfiguratorApiService, utilities_service_1.UtilitiesService])
    ], CartComponent);
    return CartComponent;
}());
exports.CartComponent = CartComponent;


/***/ },

/***/ 549:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var config_service_1 = __webpack_require__(10);
var cart_service_1 = __webpack_require__(13);
var utilities_service_1 = __webpack_require__(42);
var braintree_payment_service_1 = __webpack_require__(225);
var models_1 = __webpack_require__(55);
var UppercaseDirective = (function () {
    function UppercaseDirective() {
        this.ngModelChange = new core_1.EventEmitter();
    }
    UppercaseDirective.prototype.onInputChange = function ($event) {
        this.value = $event.target.value.toUpperCase();
        this.ngModelChange.emit(this.value);
    };
    __decorate([
        core_1.Output(), 
        __metadata('design:type', core_1.EventEmitter)
    ], UppercaseDirective.prototype, "ngModelChange", void 0);
    UppercaseDirective = __decorate([
        core_1.Directive({
            selector: '[ngModel][uppercase]',
            host: {
                "(input)": 'onInputChange($event)'
            }
        }), 
        __metadata('design:paramtypes', [])
    ], UppercaseDirective);
    return UppercaseDirective;
}());
exports.UppercaseDirective = UppercaseDirective;
var CheckoutCampionarioComponent = (function () {
    function CheckoutCampionarioComponent(config, router, cartService, utilities, braintreePayment) {
        this.config = config;
        this.router = router;
        this.cartService = cartService;
        this.utilities = utilities;
        this.braintreePayment = braintreePayment;
    }
    Object.defineProperty(CheckoutCampionarioComponent.prototype, "selPaymentType", {
        get: function () {
            return this.cartService.cart.paymentType;
        },
        set: function (type) {
            this.cartService.cart.paymentType = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutCampionarioComponent.prototype, "selDeliveryOptionId", {
        get: function () {
            return this.cartService.cart.SelDeliveryOption.id;
        },
        set: function (id) {
            this.cartService.cart.SelDeliveryOption = this.config.deliveryOptions.filter(function (v) { return v.id === id; })[0];
        },
        enumerable: true,
        configurable: true
    });
    CheckoutCampionarioComponent.prototype.ngOnInit = function () {
        fbq('track', 'InitiateCheckout');
        fbq('track', 'AddToCart', {
            content_ids: 99,
            content_type: 'product',
            value: this.config.campionarioPrice,
            currency: 'EUR'
        });
        //console.log('campionario init');
        this.utilities.cartTOTAL();
        this.changeStep(1);
        //console.log(this.cartService.cart);
    };
    CheckoutCampionarioComponent.prototype.onChange = function (value) {
        //console.log('campionario change');
        this.utilities.cartTOTAL();
    };
    CheckoutCampionarioComponent.prototype.isEnabled = function () {
        if (this.cartService.cart.checkoutStepIndex < 4) {
            return true;
        }
        else {
            return false;
        }
    };
    CheckoutCampionarioComponent.prototype.changeStep = function (newStep) {
        //console.log(this.cartService.cart.checkoutStepIndex);
        // controllo per non tornare indietro una volta arrivati al pagamento
        if (newStep < this.cartService.cart.checkoutStepIndex && this.cartService.cart.checkoutStepIndex !== 4) {
            this.cartService.cart.checkoutStepIndex = newStep;
            this.cartService.cart.paymentNonce = null;
        }
        else {
        }
    };
    CheckoutCampionarioComponent.prototype.frmShipmentSubmit = function (f) {
        // alert('ok ship | ' + f.value.shipmentName);
        this.cartService.cart.checkoutStepIndex = 2;
        this.cartService.saveCart();
    };
    CheckoutCampionarioComponent.prototype.frmInvoiceSubmit = function (f) {
        // alert('ok invoic | ' + f.value.name);
        if (!this.cartService.cart.billing.TaxCode && !this.cartService.cart.billing.VatNumber) {
            alert('inserire almeno Codice Fiscale o P.IVA ');
            return;
        }
        if (!!this.cartService.cart.billing.VatNumber && !this.cartService.cart.billing.CodeSDI && !this.cartService.cart.billing.PEC) {
            alert('obbligatorio il codice SDI oppure la PEC');
            return;
        }
        this.cartService.cart.checkoutStepIndex = 3;
        this.cartService.saveCart();
    };
    // frmShipmentTypeSubmit(f) {
    //   fbq('track', 'AddPaymentInfo');
    //   this.cartService.cart.checkoutStepIndex = 4;
    //   this.cartService.saveCart();
    // }
    CheckoutCampionarioComponent.prototype.frmPaymentTypeSubmit = function (f) {
        var _this = this;
        this.cartService.cart.checkoutStepIndex = 4;
        this.cartService.saveCart();
        if (this.cartService.cart.paymentType === models_1.PaymentType.Braintree) {
            this.braintreePayment.setup({
                container: 'braintree-container',
                price: this.config.campionarioPrice,
                onReady: function (integration) {
                    //console.log('braintree', 'onReady');
                },
                onError: function (error) {
                    alert('braintree - error: ' + error);
                }
            }, function (onPaymentMethodReceived) {
                //console.log('braintree', 'method - onPaymentMethodReceived');
                _this.cartService.cart.paymentNonce = onPaymentMethodReceived.nonce;
                _this.closeCampionario(onPaymentMethodReceived.nonce);
            });
        }
        else {
        }
    };
    CheckoutCampionarioComponent.prototype.frmEndCampionarioSubmit = function (f) {
        // Se è Braintree lo fa sopra
        if (this.selPaymentType !== models_1.PaymentType.Braintree) {
            this.closeCampionario();
        }
    };
    CheckoutCampionarioComponent.prototype.closeCampionario = function (paymentNonce) {
        var _this = this;
        if (paymentNonce === void 0) { paymentNonce = null; }
        $('#mdCloseCampionario').hide();
        $('#loaderApp').show();
        var dataCampionario = new models_1.DataCampionario();
        dataCampionario.customer = this.cartService.cart.customer;
        dataCampionario.billing = this.cartService.cart.billing;
        dataCampionario.shipmentAddress = this.cartService.cart.shipmentAddress;
        dataCampionario.billingAddress = this.cartService.cart.shipmentAddress;
        dataCampionario.shippingPrice = 0;
        dataCampionario.totalPriceCampionario = this.config.campionarioPrice;
        dataCampionario.paymentType = this.cartService.cart.paymentType;
        dataCampionario.paymentNonce = paymentNonce;
        //console.log(dataCampionario);
        this.utilities.requestAngular2('cartAllCampionario', dataCampionario).subscribe(function (result) {
            //console.log(result);
            //console.log(result.Item1);
            //console.log(result.Item2);
            if (result.Item1 === 'ok') {
                $('#mdCloseCampionario').modal('hide');
                _this.router.navigate(['/campionario-completed/' + result.Item2]);
            }
            else {
                alert('Acquisto Campionario fallito \r\n verifica tutti i dati');
                $('#loaderApp').hide();
            }
        }, function (error) {
            console.error(error);
        });
    };
    CheckoutCampionarioComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(606),
            styles: ["\n     .form-step-header{ color:#fff; background-color:#333; padding:8px 6px; margin:10px 0 10px;\n       font-size:19px; text-transform:uppercase;}\n       .step-content{ margin-bottom:20px;}\n  "]
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, router_1.Router, cart_service_1.CartService, utilities_service_1.UtilitiesService, braintree_payment_service_1.BraintreePaymentService])
    ], CheckoutCampionarioComponent);
    return CheckoutCampionarioComponent;
}());
exports.CheckoutCampionarioComponent = CheckoutCampionarioComponent;


/***/ },

/***/ 55:
/***/ function(module, exports) {

"use strict";
"use strict";
var KeyValue = (function () {
    function KeyValue() {
    }
    return KeyValue;
}());
exports.KeyValue = KeyValue;
var SessionState = (function () {
    function SessionState() {
    }
    return SessionState;
}());
exports.SessionState = SessionState;
var ModelConfig = (function () {
    function ModelConfig() {
    }
    return ModelConfig;
}());
exports.ModelConfig = ModelConfig;
var ProductConfig = (function () {
    function ProductConfig() {
    }
    return ProductConfig;
}());
exports.ProductConfig = ProductConfig;
var PaymentOption = (function () {
    function PaymentOption() {
    }
    return PaymentOption;
}());
exports.PaymentOption = PaymentOption;
var DeliveryOption = (function () {
    function DeliveryOption() {
    }
    return DeliveryOption;
}());
exports.DeliveryOption = DeliveryOption;
var DeliveryPriceConfigITA = (function () {
    function DeliveryPriceConfigITA() {
    }
    return DeliveryPriceConfigITA;
}());
exports.DeliveryPriceConfigITA = DeliveryPriceConfigITA;
var DeliveryPriceConfigEXT = (function () {
    function DeliveryPriceConfigEXT() {
    }
    return DeliveryPriceConfigEXT;
}());
exports.DeliveryPriceConfigEXT = DeliveryPriceConfigEXT;
var BtnToggleConfig = (function () {
    function BtnToggleConfig() {
    }
    return BtnToggleConfig;
}());
exports.BtnToggleConfig = BtnToggleConfig;
var ConfigState = (function () {
    function ConfigState() {
    }
    return ConfigState;
}());
exports.ConfigState = ConfigState;
var Tree = (function () {
    function Tree() {
    }
    Object.defineProperty(Tree.prototype, "isPackage", {
        get: function () {
            if (!this.parameters || this.parameters.length === 0) {
                return false;
            }
            return this.parameters.filter(function (p) { return !p.isPackage; }).length === 0;
        },
        enumerable: true,
        configurable: true
    });
    return Tree;
}());
exports.Tree = Tree;
var ValidParamConfig = (function () {
    function ValidParamConfig() {
    }
    return ValidParamConfig;
}());
exports.ValidParamConfig = ValidParamConfig;
var Param = (function () {
    function Param() {
        this.values = [];
    }
    Object.defineProperty(Param.prototype, "isPackage", {
        get: function () {
            var _this = this;
            if (this.selectedValue === undefined
                || !this.values
                || this.values.length === 0) {
                return false;
            }
            var filtered = this.values
                .filter(function (v) { return v.value === _this.selectedValue; });
            if (filtered.length === 0) {
                return false;
            }
            return filtered[0].package;
        },
        enumerable: true,
        configurable: true
    });
    return Param;
}());
exports.Param = Param;
var Format = (function () {
    function Format() {
    }
    return Format;
}());
exports.Format = Format;
var PreFilter = (function () {
    function PreFilter() {
    }
    return PreFilter;
}());
exports.PreFilter = PreFilter;
var ParamValue = (function () {
    function ParamValue() {
    }
    return ParamValue;
}());
exports.ParamValue = ParamValue;
var ViewViewerSettings = (function () {
    function ViewViewerSettings() {
    }
    return ViewViewerSettings;
}());
exports.ViewViewerSettings = ViewViewerSettings;
var DownloadViewerSettings = (function () {
    function DownloadViewerSettings() {
    }
    return DownloadViewerSettings;
}());
exports.DownloadViewerSettings = DownloadViewerSettings;
var DownloadSettings = (function () {
    function DownloadSettings() {
    }
    return DownloadSettings;
}());
exports.DownloadSettings = DownloadSettings;
var SaveResult = (function () {
    function SaveResult() {
    }
    return SaveResult;
}());
exports.SaveResult = SaveResult;
var DataCampionario = (function () {
    function DataCampionario() {
        this.paymentType = PaymentType.Bank;
    }
    return DataCampionario;
}());
exports.DataCampionario = DataCampionario;
// export class CouponData {
// public couponLabel: string;
// public couponEmail: string;
// public totalPrice: number;
// }
var Cart = (function () {
    function Cart() {
        this.paymentType = PaymentType.Bank;
    }
    Object.defineProperty(Cart.prototype, "currentCartProduct", {
        get: function () {
            return this.cartProducts[this.cartProducts.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    Cart.prototype.getSum = function (total, num) {
        if (num > 0) {
            return total + num;
        }
        else {
            return total;
        }
    };
    // SPEDIZIONI BARTOLINI
    Cart.prototype.delivITApesoVolumTOT = function () {
        // calcolo il peso volumetrico ITA totale
        var totITAvolum = 0;
        if (this.cartProducts) {
            this.cartProducts.forEach(function (r) {
                if (r.pesoVolumITA > 0) {
                    totITAvolum += (r.pesoVolumITA * r.quantity);
                }
            });
        }
        return totITAvolum;
    };
    Cart.prototype.delivEXTpesoVolumTOT = function () {
        var totEXTvolum = 0;
        if (this.cartProducts) {
            this.cartProducts.forEach(function (r) {
                if (r.pesoVolumEXT > 0) {
                    totEXTvolum += (r.pesoVolumEXT * r.quantity);
                }
            });
        }
        return totEXTvolum;
    };
    Cart.prototype.getDelivITAprice = function () {
        var _this = this;
        var totITAvolum = this.delivITApesoVolumTOT();
        //console.log('totITAvolum = ' + totITAvolum);
        // in base agli scaglioni di pesoVolumITA trovo il prezzo
        var returnPrice = 0;
        if (this.deliveryPricesItaly) {
            this.deliveryPricesItaly.forEach(function (element) {
                if (totITAvolum > element.rangeMinKg && totITAvolum <= element.rangeMaxKg) {
                    returnPrice = element.price;
                }
            });
        }
        // per i prodotti (Fine-art, Carta cotone stampa, Carta fotografica stampa) aggiungo prezzo fisso a 9
        if (this.cartProducts && this.deliveryFissi) {
            this.cartProducts.forEach(function (r) {
                if (_this.deliveryFissi.indexOf(r.productName) > -1) {
                    returnPrice += 9;
                }
            });
        }
        //console.log(returnPrice);
        return returnPrice;
    };
    Cart.prototype.getDelivEXTprice = function (country) {
        var totEXTvolum = this.delivEXTpesoVolumTOT();
        //console.log('totEXTvolum = ' + totEXTvolum);
        // SCAGLIONI DI PREZZO DIFFERENTI DA NAZIONE A NAZIONE
        var returnPrice = 0;
        var nazioneSEL;
        if (this.shipmentAddress) {
            nazioneSEL = country;
            if (nazioneSEL !== 'IT') {
                if (this.deliveryPricesEXT) {
                    var ScaglioneEXT = this.deliveryPricesEXT.filter(function (item) { return item.nation === nazioneSEL; })[0];
                    ////console.log(ScaglioneEXT);
                    if (ScaglioneEXT) {
                        if (totEXTvolum <= 5) {
                            returnPrice = ScaglioneEXT.range_0_5kg;
                        }
                        else if (totEXTvolum > 5 && totEXTvolum <= 15) {
                            returnPrice = ScaglioneEXT.range_5_15kg;
                        }
                        else if (totEXTvolum > 15 && totEXTvolum <= 31.5) {
                            returnPrice = ScaglioneEXT.range_15_31_5kg;
                        }
                        else if (totEXTvolum > 31.5) {
                            returnPrice =
                                Number(ScaglioneEXT.range_15_31_5kg +
                                    Number(ScaglioneEXT.oltre_31_5kg_alKG * Number(totEXTvolum - 31.5)));
                        }
                    }
                }
            }
        }
        //console.log(returnPrice);
        return returnPrice;
    };
    Cart.prototype.recalculateDeliveryPrice = function () {
        this.delivPrice = 0;
        if (this.SelDeliveryOption) {
            if (this.SelDeliveryOption.id === 1) {
                var country = this.shipmentAddress.Country;
                if (country === 'IT') {
                    this.delivPrice = this.getDelivITAprice();
                }
                else {
                    this.delivPrice = this.getDelivEXTprice(country);
                }
            }
        }
        // return this.delivPrice;
    };
    return Cart;
}());
exports.Cart = Cart;
var CartProduct = (function () {
    function CartProduct() {
        this.rounded = false;
    }
    CartProduct.prototype.totalPrice = function () {
        if (!this.quantity || isNaN(this.quantity) || this.quantity < 1) {
            this.quantity = 1;
        }
        var priceTot = this.price + this.additionalPrice;
        this.totalPriceStatic = this.quantity * priceTot;
        return this.totalPriceStatic;
    };
    return CartProduct;
}());
exports.CartProduct = CartProduct;
var Address = (function () {
    function Address() {
    }
    return Address;
}());
exports.Address = Address;
var Customer = (function () {
    function Customer() {
    }
    return Customer;
}());
exports.Customer = Customer;
(function (PaymentType) {
    PaymentType[PaymentType["Bank"] = 0] = "Bank";
    PaymentType[PaymentType["Braintree"] = 1] = "Braintree";
})(exports.PaymentType || (exports.PaymentType = {}));
var PaymentType = exports.PaymentType;
var BraintreeOptions = (function () {
    function BraintreeOptions() {
    }
    return BraintreeOptions;
}());
exports.BraintreeOptions = BraintreeOptions;
var BraintreeResult = (function () {
    function BraintreeResult() {
    }
    return BraintreeResult;
}());
exports.BraintreeResult = BraintreeResult;


/***/ },

/***/ 550:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var config_service_1 = __webpack_require__(10);
var cart_service_1 = __webpack_require__(13);
var utilities_service_1 = __webpack_require__(42);
var braintree_payment_service_1 = __webpack_require__(225);
var models_1 = __webpack_require__(55);
var CheckoutComponent = (function () {
    function CheckoutComponent(config, router, cartService, utilities, braintreePayment) {
        this.config = config;
        this.router = router;
        this.cartService = cartService;
        this.utilities = utilities;
        this.braintreePayment = braintreePayment;
        this.enabledConfirmOrder = false;
    }
    Object.defineProperty(CheckoutComponent.prototype, "selPaymentType", {
        get: function () {
            return this.cartService.cart.paymentType;
        },
        set: function (type) {
            this.cartService.cart.paymentType = type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CheckoutComponent.prototype, "selDeliveryOptionId", {
        get: function () {
            return this.cartService.cart.SelDeliveryOption.id;
        },
        set: function (id) {
            this.cartService.cart.SelDeliveryOption = this.config.deliveryOptions.filter(function (v) { return v.id === id; })[0];
        },
        enumerable: true,
        configurable: true
    });
    CheckoutComponent.prototype.ngOnInit = function () {
        //console.log('ngOnInit - cartCheckProducts:');
        this.cartService.cartCheckProducts();
        this.cartService.cartCheckCROPPED();
        fbq('track', 'InitiateCheckout');
        this.utilities.cartTOTAL();
        //console.log('onInit');
        this.cartService.cart.checkoutStepIndex = 1;
        this.changeStep(1);
        //console.log(this.cartService.cart);
        this.cartService.cart.TOTALCartORDER = this.cartService.cart.totalALLPriceStatic;
        this.cartService.cart.couponLabel = null;
    };
    CheckoutComponent.prototype.onShipmentChange = function (value) {
        this.utilities.cartTOTAL();
        //console.log('onCountryChange');
        this.cartService.cart.paymentNonce = null;
    };
    CheckoutComponent.prototype.isEnabled = function () {
        if (this.cartService.cart.checkoutStepIndex < 5) {
            return true;
        }
        else {
            return false;
        }
    };
    CheckoutComponent.prototype.changeStep = function (newStep) {
        //console.log(this.cartService.cart.checkoutStepIndex);
        // controllo per non tornare indietro una volta arrivati al pagamento
        if (newStep < this.cartService.cart.checkoutStepIndex && this.cartService.cart.checkoutStepIndex !== 5) {
            this.cartService.cart.checkoutStepIndex = newStep;
            this.cartService.cart.paymentNonce = null;
        }
        else {
        }
    };
    CheckoutComponent.prototype.frmShipmentSubmit = function (f) {
        this.cartService.cart.paymentNonce = null;
        // alert('ok ship | ' + f.value.shipmentName);
        this.cartService.cart.checkoutStepIndex = 2;
        this.cartService.saveCart();
    };
    CheckoutComponent.prototype.frmShipmentTypeSubmit = function (f) {
        this.cartService.cart.checkoutStepIndex = 3;
        this.cartService.saveCart();
    };
    CheckoutComponent.prototype.frmInvoiceSubmit = function (f) {
        // alert('ok invoic | ' + f.value.name);
        this.cartService.cart.paymentNonce = null;
        if (!this.cartService.cart.billing.TaxCode && !this.cartService.cart.billing.VatNumber) {
            alert('inserire almeno Codice Fiscale o P.IVA ');
            return;
        }
        if (!!this.cartService.cart.billing.VatNumber && !this.cartService.cart.billing.CodeSDI && !this.cartService.cart.billing.PEC) {
            alert('obbligatorio il codice SDI oppure la PEC');
            return;
        }
        this.cartService.cart.checkoutStepIndex = 4;
        this.cartService.saveCart();
        fbq('track', 'AddPaymentInfo');
    };
    CheckoutComponent.prototype.frmPaymentTypeSubmit = function (f) {
        //console.log('frmPaymentTypeSubmit');
        var _this = this;
        this.cartService.cart.checkoutStepIndex = 5;
        this.cartService.saveCart();
        this.enabledConfirmOrder = false;
        if (this.braintreeContainer.nativeElement.innerHTML.length > 0) {
            //console.log('braintree-dropin è già stato inizializzato per sicurezza quindi ricarico la pagina per resettare il DOM');
            this.router.navigate(['/']);
            this.router.navigate(['/checkout']);
        }
        if (this.cartService.cart.paymentType === models_1.PaymentType.Braintree) {
            // let checkout;
            // this.braintreePayment.setup('CLIENT_TOKEN_FROM_SERVER', 'dropin', {
            //   onReady: function (integration) {
            //     checkout = integration;
            //   }
            // });
            var that_1 = this;
            this.utilities.cartTOTAL(function (price) {
                _this.braintreePayment.setup({
                    container: 'braintree-container',
                    price: price,
                    // onReady: () => {
                    onReady: function (integration) {
                        // checkout = integration;
                        that_1.enabledConfirmOrder = true;
                        //console.log('braintree', 'onReady');
                    },
                    onError: function (error) {
                        alert('braintree - error: ' + error);
                    }
                }, function (onPaymentMethodReceived) {
                    //console.log('braintree', 'method - onPaymentMethodReceived');
                    _this.cartService.cart.paymentNonce = onPaymentMethodReceived.nonce;
                    _this.closeOrder(onPaymentMethodReceived.nonce);
                });
                // // When you are ready to tear down your integration
                // checkout.teardown(function () {
                //   checkout = null;
                //   //console.log('checkout.teardown');
                //   // braintree.setup can safely be run again!
                // });
            });
        }
        else {
            this.enabledConfirmOrder = true;
        }
    };
    CheckoutComponent.prototype.frmEndOrderSubmit = function (f) {
        // Se è Braintree lo fa sopra
        //console.log('frmEndOrderSubmit');
        if (this.selPaymentType === models_1.PaymentType.Bank) {
            //console.log('frmEndOrderSubmit | this.selPaymentType === PaymentType.Bank | closeOrder');
            this.closeOrder();
        }
    };
    CheckoutComponent.prototype.closeOrder = function (paymentNonce) {
        //console.log('closeOrder');
        var _this = this;
        if (paymentNonce === void 0) { paymentNonce = null; }
        $('#mdCloseOrder').hide();
        $('#loaderApp').show();
        this.cartService.cart.billingAddress = this.cartService.cart.shipmentAddress;
        this.cartService.cart.deliveryOptionName = this.cartService.cart.SelDeliveryOption.name;
        this.cartService.cart.paymentNonce = paymentNonce;
        //console.log('paymentNonce ' + paymentNonce);
        //console.log(this.cartService.cart);
        this.utilities.requestAngular2('cartAllData', this.cartService.cart).subscribe(function (result) {
            //console.log(result);
            if (result.Item1 === 'ok') {
                $('#mdCloseOrder').modal('hide');
                // this.router.navigate(['/order-completed']);
                // this.router.navigate(['/order-completed', { idTransaction: result.Item2 }]);
                _this.router.navigate(['/order-completed/' + result.Item2]);
            }
            else {
                alert('Chiusura ordine fallita \r\n verifica tutti i dati');
                $('#loaderApp').hide();
            }
        }, function (error) {
            alert('Chiusura ordine fallita \r\n sito in errore');
            $('#loaderApp').hide();
            console.error(error);
        });
    };
    CheckoutComponent.prototype.emailChanged = function () {
        //console.log('emailChanged');
        this.utilities.cartTOTAL();
    };
    CheckoutComponent.prototype.applyCoupon = function (couponField) {
        this.utilities.CalculateCoupon(couponField.value, null, true);
        this.utilities.cartTOTAL();
        couponField.value = '';
    };
    __decorate([
        core_1.ViewChild('braintreeContainer'), 
        __metadata('design:type', Object)
    ], CheckoutComponent.prototype, "braintreeContainer", void 0);
    CheckoutComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(607),
            styles: ["\n     .form-step-header{ color:#fff; background-color:#333; padding:8px 6px; margin:10px 0 10px;\n       font-size:19px; text-transform:uppercase;}\n       .step-content{ margin-bottom:20px;}\n  "]
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, router_1.Router, cart_service_1.CartService, utilities_service_1.UtilitiesService, braintree_payment_service_1.BraintreePaymentService])
    ], CheckoutComponent);
    return CheckoutComponent;
}());
exports.CheckoutComponent = CheckoutComponent;


/***/ },

/***/ 551:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var utilities_service_1 = __webpack_require__(42);
var LoadProductComponent = (function () {
    function LoadProductComponent(activatedRoute, config, session, cartService, utilities, router) {
        this.activatedRoute = activatedRoute;
        this.config = config;
        this.session = session;
        this.cartService = cartService;
        this.utilities = utilities;
        this.router = router;
        this.isImageCatalog = false;
    }
    LoadProductComponent.prototype.ngOnInit = function () {
        var _this = this;
        // subscribe to router event
        var preFilterKey = null;
        var preFilterValue = null;
        this.activatedRoute.queryParams.subscribe(function (params) {
            if (params['preFilterKey']) {
                preFilterKey = params['preFilterKey'];
            }
            if (params['preFilterValue']) {
                preFilterValue = params['preFilterValue'];
            }
        });
        this.activatedRoute.params.subscribe(function (params) {
            //PRELOAD IMAGE FROM CATALOG URL
            if (params['urlFileCatalog'] != null) {
                _this.isImageCatalog = true;
                //console.log('PRELOAD IMAGE FROM CATALOG URL');
                var urlFileCatalog = params['urlFileCatalog'];
                var body = urlFileCatalog;
                _this.utilities.requestAngular2('fileChange', body).subscribe(function (result) {
                    if (result && result.result === 'ok') {
                        _this.cartService.cart.currentCartProduct.naturalWidth = result.naturalWidth;
                        _this.cartService.cart.currentCartProduct.naturalHeight = result.naturalHeight;
                        //console.log('result.nameFile: ' + result.nameFile);
                        var nameFile = result.nameFile;
                        _this.cartService.cart.currentCartProduct.photoID = nameFile;
                        _this.cartService.cart.currentCartProduct.photoOriginal =
                            _this.config.urlHost + '/files/temp/' + nameFile + '_web.jpg';
                        //console.log('photoOriginal: ' + this.cartService.cart.currentCartProduct.photoOriginal);
                        _this.cartService.cart.currentCartProduct.photoResized = null;
                        _this.cartService.cart.formatoSelected = false;
                        _this.cartService.saveCart();
                        _this.router.navigate(['/upload-photo']);
                    }
                    else {
                        console.error(result);
                        alert('Errore nell caricamento immagine dal catalogo');
                    }
                }, function (error) {
                    console.error(error);
                    alert('Errore nell caricamento immagine dal catalogo');
                });
            }
            else if (params['idProduct'] != null) {
                var idProduct_1 = params['idProduct'];
                var model = _this.config.products.filter(function (x) { return x.id.toString() === idProduct_1.toString(); })[0];
                //console.log(model);
                if (model) {
                    //console.log('load-product: ' + model.id + ' - ' + model.name);
                    _this.session.setProduct(model, preFilterKey, preFilterValue);
                    _this.router.navigate(['/select-products', { preload: model.id, url: model.name.replace(/ /g, '-') }]);
                }
                else {
                }
            }
        });
    };
    LoadProductComponent = __decorate([
        core_1.Component({
            selector: 'load-product',
            template: __webpack_require__(608),
            styles: ["\n   .product { margin-bottom:12px; }\n   "]
        }), 
        __metadata('design:paramtypes', [router_1.ActivatedRoute, config_service_1.ConfigService, session_service_1.SessionService, cart_service_1.CartService, utilities_service_1.UtilitiesService, router_1.Router])
    ], LoadProductComponent);
    return LoadProductComponent;
}());
exports.LoadProductComponent = LoadProductComponent;


/***/ },

/***/ 552:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var NoContentComponent = (function () {
    function NoContentComponent() {
    }
    NoContentComponent = __decorate([
        core_1.Component({
            selector: 'no-content',
            template: "\n    <div>\n      <h1>404: pagina non trovata...</h1>\n    </div>\n  "
        }), 
        __metadata('design:paramtypes', [])
    ], NoContentComponent);
    return NoContentComponent;
}());
exports.NoContentComponent = NoContentComponent;


/***/ },

/***/ 553:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var cart_service_1 = __webpack_require__(13);
var router_1 = __webpack_require__(8);
var config_service_1 = __webpack_require__(10);
var OrderCompletedComponent = (function () {
    function OrderCompletedComponent(cartService, activatedRoute, router, config) {
        this.cartService = cartService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.config = config;
        this.ecomm_prodids = '';
        this.ecomm_value = 0;
    }
    OrderCompletedComponent.prototype.ngOnInit = function () {
        var _this = this;
        $('#loaderApp').hide();
        var value = this.cartService.cart.totalALLPriceStatic;
        if (value && !isNaN(value)) {
            this.OldTotalCart = parseFloat(value.toFixed(2));
        }
        else {
            this.OldTotalCart = 0;
        }
        //console.log('this.OldTotalCart: ' + this.OldTotalCart);
        // if (this.OldTotalCart === 0) {
        //   this.router.navigate(['/']);
        // } else
        {
            this.cartService.cart.cartProducts.forEach(function (prod) {
                _this.ecomm_prodids += '\'' + prod.idProduct + '\',';
                _this.ecomm_value += prod.totalPriceStatic;
                //console.log(prod);
            });
            this.ecomm_prodids = this.ecomm_prodids.substring(0, this.ecomm_prodids.length - 1);
            //console.log('ecomm_prodid: ' + this.ecomm_prodids + ' - this.ecomm_value: ' + this.ecomm_value);
            var idTransaction_1 = 0;
            this.activatedRoute.params.subscribe(function (params) {
                idTransaction_1 = params['idTransaction'];
            });
            if (idTransaction_1 !== 0) {
                // FACEBOOK ECOMMERCE
                fbq('track', 'Purchase', {
                    content_ids: [this.ecomm_prodids],
                    content_type: 'product',
                    value: this.ecomm_value,
                    currency: 'EUR'
                });
                // ANALYTICS ECOMMERCE
                ga('require', 'ecommerce', 'ecommerce.js');
                ga('ecommerce:addTransaction', {
                    'id': idTransaction_1,
                    'affiliation': 'Topcolor - Order',
                    'revenue': this.cartService.cart.totalALLPriceStatic,
                    'shipping': this.cartService.cart.delivPrice,
                    'tax': this.cartService.cart.totalALLPriceStatic - (this.cartService.cart.totalALLPriceStatic / 1.22)
                });
                ga('ecommerce:send');
                // SVUOTO IL CARRELLO DAI PRODOTTI MANTENDO LE ALTRE INFO
                this.cartService.cart.cartProducts = this.cartService.cart.cartProducts.filter(function (r) { return r.idRow === 999999; });
                this.cartService.cart.TOTALCartORDER = 0;
                this.cartService.cart.totalALLPriceStatic = 0;
                this.cartService.saveCart();
                this.cartService.cartCheckProducts(false);
            }
        }
        // Event snippet for Ordine Completato conversion page
        gtag('event', 'conversion', {
            'send_to': 'AW-851653320/tDADCN6TxHEQyOWMlgM',
            'value': 1.0,
            'currency': 'EUR'
        });
        //console.log('conversione adwords AW-851653320');
    };
    OrderCompletedComponent = __decorate([
        core_1.Component({
            selector: 'order-completed',
            template: __webpack_require__(609),
        }), 
        __metadata('design:paramtypes', [cart_service_1.CartService, router_1.ActivatedRoute, router_1.Router, config_service_1.ConfigService])
    ], OrderCompletedComponent);
    return OrderCompletedComponent;
}());
exports.OrderCompletedComponent = OrderCompletedComponent;


/***/ },

/***/ 554:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var ng2_img_cropper_1 = __webpack_require__(165);
var cart_service_1 = __webpack_require__(13);
var session_service_1 = __webpack_require__(19);
var config_service_1 = __webpack_require__(10);
var router_1 = __webpack_require__(8);
var utilities_service_1 = __webpack_require__(42);
var PageCropComponent = (function () {
    function PageCropComponent(config, cartService, session, router, utilities) {
        this.config = config;
        this.cartService = cartService;
        this.session = session;
        this.router = router;
        this.utilities = utilities;
        this.image = new Image();
        this.visibleLoader = false;
        this.name = 'Angular2';
        this.cropperSettings1 = new ng2_img_cropper_1.CropperSettings();
        this.cropperSettings1.noFileInput = true;
        this.cropperSettings1.rounded = this.cartService.cart.currentCartProduct.rounded;
        if (this.cartService.cart.currentCartProduct.rounded) {
            this.session.cropHeight = this.session.cropWidth;
        }
        this.cropperSettings1.width = this.session.cropWidth;
        this.cropperSettings1.height = this.session.cropHeight;
        this.cropperSettings1.croppedWidth = Number((this.session.cropWidth * this.config.RappRisoluzMin).toFixed(0));
        this.cropperSettings1.croppedHeight = Number((this.session.cropHeight * this.config.RappRisoluzMin).toFixed(0));
        // ridimensiono il canvas in proporzione
        var WidthClientCanvas = 740 - 8;
        var HeightClientCanvas = 410 - 8;
        var rappRiduction = this.cartService.cart.currentCartProduct.naturalWidth / WidthClientCanvas;
        if (this.cartService.cart.currentCartProduct.naturalHeight > this.cartService.cart.currentCartProduct.naturalWidth
            || this.cartService.cart.currentCartProduct.naturalHeight / rappRiduction > HeightClientCanvas) {
            rappRiduction = this.cartService.cart.currentCartProduct.naturalHeight / HeightClientCanvas;
        }
        this.cropperSettings1.canvasWidth = this.cartService.cart.currentCartProduct.naturalWidth / rappRiduction;
        this.cropperSettings1.canvasHeight = this.cartService.cart.currentCartProduct.naturalHeight / rappRiduction;
        this.cropperSettings1.minWidth = this.cropperSettings1.croppedWidth;
        this.cropperSettings1.minHeight = this.cropperSettings1.croppedHeight;
        this.cropperSettings1.cropperDrawSettings.strokeColor = 'rgba(255,255,255,1)';
        this.cropperSettings1.cropperDrawSettings.strokeWidth = 1;
        //this.cropperSettings1.preserveSize = true;
        this.data1 = {};
    }
    PageCropComponent.prototype.ngOnInit = function () {
        var loader = document.getElementById('loader');
        //console.log(loader);
        if (loader) {
            loader.style.display = 'block';
        }
        if (!this.cartService.cart.currentCartProduct.photoOriginal) {
            //console.log('no photoOriginal - redirect upload-photo');
            this.router.navigate(['/upload-photo']);
        }
        // ridimensiono il canvas in proporzione
        var WidthClientCanvas = 740 - 8;
        var HeightClientCanvas = 410 - 8;
        var ImgCropper = document.getElementsByClassName('slide')[0];
        if (ImgCropper) {
            WidthClientCanvas = Number(ImgCropper.clientWidth.toFixed(0)); // 840;
            HeightClientCanvas = Number(ImgCropper.clientHeight.toFixed(0)); // 514;
        }
        this.LoadImage();
    };
    PageCropComponent.prototype.LoadImage = function () {
        this.visibleLoader = true;
        if (this.cartService) {
            //console.log(this.cartService);
            if (this.cartService.cart.currentCartProduct.photoOriginal) {
                this.image.crossOrigin = 'Anonymous';
                this.image.src = this.cartService.cart.currentCartProduct.photoOriginal; // this.cartService.cart.photoBase64;
                this.image.height = this.image.naturalHeight;
                this.image.width = this.image.naturalWidth;
                //console.log(this.image.complete);
                var that_1 = this;
                setTimeout(function () {
                    if (that_1.image.complete) {
                        //console.log('this.cropper.setImage(image)');
                        that_1.cropper.setImage(that_1.image);
                        that_1.visibleLoader = false;
                    }
                    else {
                        that_1.LoadImage();
                    }
                }, 1500);
            }
        }
    };
    PageCropComponent.prototype.cropped = function (bounds) {
        //console.log('cropped' + this.data1);
        if (this.data1.image) {
        }
        else {
            this.cartService.cart.currentCartProduct.photoResized = null;
        }
        var boundsJSON = {
            top: bounds.top,
            right: bounds.right,
            left: bounds.left,
            width: bounds.width,
            height: bounds.height,
        };
        //console.log(boundsJSON);
        this.cartService.cart.currentCartProduct.photoBounds = boundsJSON;
        this.cartService.saveCart();
    };
    PageCropComponent.prototype.confirmCropped = function () {
        var _this = this;
        this.visibleLoader = true;
        var body = {
            photoID: this.cartService.cart.currentCartProduct.photoID,
            photoBounds: this.cartService.cart.currentCartProduct.photoBounds,
            widthFormatoSel: this.session.cropWidth
        };
        //console.log(body);
        this.utilities.requestAngular2('cropimage', body).subscribe(function (result) {
            //console.log(result);
            var urlImgCropped = _this.config.urlHost + '/files/cropped/'
                + _this.cartService.cart.currentCartProduct.photoID + '-cropped_web.jpg';
            //console.log(urlImgCropped);
            if (result && result.result === 'ok') {
                // this.cartService.cart.currentCartProduct.photoResized = result.fileNameCroppedWeb   // RESTITUISCE IL PATH NON L'URL
                _this.cartService.cart.currentCartProduct.photoResized = urlImgCropped
                    + '?v=' + new Date().toLocaleTimeString().replace(/([\/\,\!\\\^\$\{\}\[\]\(\)\.\*\+\?\|\<\>\-\&])/g, '-');
                _this.cartService.saveCart();
                _this.visibleLoader = false;
                _this.router.navigate(['/preview']);
            }
            else {
                _this.cartService.cart.currentCartProduct.photoResized = null;
                _this.visibleLoader = false;
            }
        }, function (error) {
            console.error(error);
            _this.visibleLoader = false;
        });
    };
    __decorate([
        core_1.ViewChild('cropper', undefined), 
        __metadata('design:type', ng2_img_cropper_1.ImageCropperComponent)
    ], PageCropComponent.prototype, "cropper", void 0);
    PageCropComponent = __decorate([
        core_1.Component({
            selector: 'my-app',
            template: __webpack_require__(610)
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, cart_service_1.CartService, session_service_1.SessionService, router_1.Router, utilities_service_1.UtilitiesService])
    ], PageCropComponent);
    return PageCropComponent;
}());
exports.PageCropComponent = PageCropComponent;


/***/ },

/***/ 555:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var PreviewComponent = (function () {
    function PreviewComponent(config, cartService, session, router) {
        this.config = config;
        this.cartService = cartService;
        this.session = session;
        this.router = router;
    }
    PreviewComponent.prototype.ngOnInit = function () {
        if (this.cartService.cart.currentCartProduct.photoResized == null) {
            //console.log('no previewImg - redirect pagecrop');
            this.router.navigate(['/pagecrop']);
        }
        this.cartService.cartCheckProducts();
    };
    PreviewComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(611),
            styles: [""]
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, cart_service_1.CartService, session_service_1.SessionService, router_1.Router])
    ], PreviewComponent);
    return PreviewComponent;
}());
exports.PreviewComponent = PreviewComponent;


/***/ },

/***/ 556:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var scroll_service_1 = __webpack_require__(79);
var SelectDimensionsComponent = (function () {
    function SelectDimensionsComponent(config, cartService, session, router, scroll) {
        this.config = config;
        this.cartService = cartService;
        this.session = session;
        this.router = router;
        this.scroll = scroll;
    }
    SelectDimensionsComponent.prototype.ngOnInit = function () {
        this.cartService.cartCheckProducts();
        if (!this.cartService.cart.currentCartProduct.photoOriginal) {
            //console.log('no photoOriginal - redirect upload-photo');
            this.router.navigate(['/upload-photo']);
        }
        else {
            var that_1 = this;
            setTimeout(function () {
                if (that_1.cartService.cart.formatoSelected === false) {
                    var formatoDispPiuBIG = document.getElementById(that_1.cartService.cart.currentCartProduct.format.split('|')[0]);
                    var rigaFormatoBIG = formatoDispPiuBIG.getElementsByClassName('riga-input hidden formatOK');
                    var numeroMedio = ((rigaFormatoBIG.length - 1) / 2).toFixed();
                    that_1.scroll.simulatedClick((rigaFormatoBIG[numeroMedio]));
                    setTimeout(function () {
                        alert('Caricando una nuova foto è stata cambiata la selezione del formato');
                        var posY = $('.riga-input.formatOK.active').offset().top;
                        $('html, body').animate({ scrollTop: posY }, 'slow');
                    }, 100);
                }
                // let BoxSelected = document.getElementById(that.cartService.cart.currentCartProduct.format);
                // that.scroll.simulatedClick(BoxSelected);
            }, 800);
        }
    };
    SelectDimensionsComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(612),
            styles: ["\n      label { display:block; }\n      select{ margin-bottom:20px;}\n      .btn-success{ margin-right:10px;}\n  "]
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, cart_service_1.CartService, session_service_1.SessionService, router_1.Router, scroll_service_1.ScrollService])
    ], SelectDimensionsComponent);
    return SelectDimensionsComponent;
}());
exports.SelectDimensionsComponent = SelectDimensionsComponent;


/***/ },

/***/ 557:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
// import { ProductConfig, ModelConfig } from '../commons/models';
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var SelectProductsComponent = (function () {
    function SelectProductsComponent(session, config, cartService, router) {
        this.session = session;
        this.config = config;
        this.cartService = cartService;
        this.router = router;
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SelectProductsComponent.prototype, "visibility", void 0);
    SelectProductsComponent = __decorate([
        core_1.Component({
            selector: 'my-select-products',
            template: __webpack_require__(613),
            styles: ["\n   .product { margin-bottom:12px; }\n   "]
        }), 
        __metadata('design:paramtypes', [session_service_1.SessionService, config_service_1.ConfigService, cart_service_1.CartService, router_1.Router])
    ], SelectProductsComponent);
    return SelectProductsComponent;
}());
exports.SelectProductsComponent = SelectProductsComponent;


/***/ },

/***/ 558:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
/*, Sanitizer, SecurityContext, ChangeDetectorRef, ChangeDetectionStrategy*/
var session_service_1 = __webpack_require__(19);
var cart_service_1 = __webpack_require__(13);
// import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
var SimilFancyComponent = (function () {
    function SimilFancyComponent(session, cartService) {
        this.session = session;
        this.cartService = cartService;
        this.clickBtn = new core_1.EventEmitter();
        this.visibleLoader = false;
    }
    SimilFancyComponent.prototype.ngOnInit = function () {
        this.loaderSFRefresh();
        // // CURSORE CON FONTAWESOME
        // let canvas = document.createElement('canvas');
        // canvas.width = 24;
        // canvas.height = 24;
        // let ctx = canvas.getContext('2d');
        // ctx.fillStyle = '#fff';
        // ctx.font = '24px FontAwesome';
        // ctx.textAlign = 'center';
        // ctx.textBaseline = 'middle';
        // ctx.fillText('\uf002', 12, 12);
        // let dataURL = canvas.toDataURL('image/png');
        // let container = document.getElementById(this.nameId);
        // if (container) {
        //   let previewImg = container.getElementsByClassName('previewImg')[0] as HTMLElement;
        //   // if (previewImg) {
        //   if (this.cartService.cart.currentCartProduct.photoResized != null && previewImg) {
        //     // previewImg.style.cursor = ':url(' + dataURL + '), auto;';
        //     previewImg.setAttribute('style', 'cursor:url(' + dataURL + '), auto;');
        //   }
        // }
    };
    SimilFancyComponent.prototype.ngOnChanges = function () {
        this.loaderSFRefresh();
    };
    SimilFancyComponent.prototype.loaderSFRefresh = function () {
        //console.log('loaderSFRefresh');
        var _this = this;
        this.visibleLoader = true;
        setTimeout(function () {
            //console.log('if this.imgSimilFancy.complete: ' + this.imgSimilFancy.nativeElement.complete);
            if (_this.imgSimilFancy.nativeElement.complete) {
                _this.visibleLoader = false;
            }
            else {
                _this.loaderSFRefresh();
            }
        }, 500);
    };
    SimilFancyComponent.prototype.clickShowImg = function () {
        var container = document.getElementById(this.nameId);
        var ImgSrc = container.getElementsByClassName('linkPrevImg')[0];
        var ImgThumb = container.getElementsByClassName('ImgThumb')[0];
        if (ImgSrc.className === 'linkPrevImg fancyOpen center-content') {
            ImgSrc.className = 'linkPrevImg fancyClose';
            ImgThumb.className = 'ImgThumb hidden';
        }
        else {
            ImgSrc.className = 'linkPrevImg fancyOpen center-content';
            ImgThumb.className = 'ImgThumb show';
        }
    };
    __decorate([
        core_1.ViewChild('imgSimilFancy'), 
        __metadata('design:type', core_1.ElementRef)
    ], SimilFancyComponent.prototype, "imgSimilFancy", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Boolean)
    ], SimilFancyComponent.prototype, "imgRounded", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SimilFancyComponent.prototype, "imgSrc", void 0);
    __decorate([
        core_1.Input(), 
        __metadata('design:type', String)
    ], SimilFancyComponent.prototype, "nameId", void 0);
    __decorate([
        core_1.Output(), 
        __metadata('design:type', Object)
    ], SimilFancyComponent.prototype, "clickBtn", void 0);
    SimilFancyComponent = __decorate([
        core_1.Component({
            selector: 'similFancy',
            template: __webpack_require__(614),
        }), 
        __metadata('design:paramtypes', [session_service_1.SessionService, cart_service_1.CartService])
    ], SimilFancyComponent);
    return SimilFancyComponent;
}());
exports.SimilFancyComponent = SimilFancyComponent;


/***/ },

/***/ 559:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var session_service_1 = __webpack_require__(19);
var scroll_service_1 = __webpack_require__(79);
var router_2 = __webpack_require__(8);
var SlideParameterComponent = (function () {
    function SlideParameterComponent(config, cartService, session, router, scroll, activatedRoute) {
        this.config = config;
        this.cartService = cartService;
        this.session = session;
        this.router = router;
        this.scroll = scroll;
        this.activatedRoute = activatedRoute;
        this.parametersSlide = [];
    }
    SlideParameterComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cartService.cartCheckProducts();
        if (!this.cartService.cart.currentCartProduct.photoOriginal) {
            //console.log('no photoOriginal - redirect upload-photo');
            this.router.navigate(['/upload-photo']);
        }
        this.activatedRoute.params.subscribe(function (params) {
            _this.table = 'Navbar' + _this.router.url.split('/').reverse()[0];
            var thisButton = _this.config.btnToggles.filter(function (r) { return r.isParameter && r.text === _this.table; })[0];
            _this.parameter = thisButton.text;
            if (_this.session.params && _this.session.params.length !== 0) {
                _this.parametersSlide = _this.session.params.filter(function (r) { return r.table === _this.table; });
            }
        });
    };
    SlideParameterComponent = __decorate([
        core_1.Component({
            template: __webpack_require__(615)
        }), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, cart_service_1.CartService, session_service_1.SessionService, router_1.Router, scroll_service_1.ScrollService, router_2.ActivatedRoute])
    ], SlideParameterComponent);
    return SlideParameterComponent;
}());
exports.SlideParameterComponent = SlideParameterComponent;


/***/ },

/***/ 560:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var router_1 = __webpack_require__(8);
var cart_service_1 = __webpack_require__(13);
var config_service_1 = __webpack_require__(10);
var utilities_service_1 = __webpack_require__(42);
var website_interface_service_1 = __webpack_require__(227);
var UploadPhotoComponent = (function () {
    function UploadPhotoComponent(router, cartService, config, utilities, output) {
        this.router = router;
        this.cartService = cartService;
        this.config = config;
        this.utilities = utilities;
        this.output = output;
        this.visibleLoader = true;
    }
    UploadPhotoComponent.prototype.formatIdeal = function () {
        return Number(this.cartService.cart.currentCartProduct.naturalWidth / this.config.RappRisoluzMin).toFixed(0);
    };
    UploadPhotoComponent.prototype.ngAfterViewInit = function () {
        this.visibleLoader = false;
    };
    UploadPhotoComponent.prototype.fileChange = function (fuImage) {
        if (!fuImage.files || !fuImage.files[0]) {
            return;
        }
        var reader = new FileReader();
        var file = fuImage.files[0];
        var that = this;
        reader.onload = function (event) {
            that.visibleLoader = true;
            // let data = reader.result;
            that.cartService.cart = that.cartService.cart;
            // let body = {
            //   photoID: that.cartService.cart.currentCartProduct.photoID,
            //   photoBase64: data
            // };
            //console.log('INIT - requestAngular2');
            that.utilities.fileUpload('fileChange', file).subscribe(function (result) {
                if (result && result.result === 'ok') {
                    that.cartService.cart.currentCartProduct.naturalWidth = result.naturalWidth;
                    that.cartService.cart.currentCartProduct.naturalHeight = result.naturalHeight;
                    //console.log('result.nameFile: ' + result.nameFile);
                    var nameFile = result.nameFile;
                    that.cartService.cart.currentCartProduct.photoID = nameFile;
                    that.cartService.cart.currentCartProduct.photoOriginal =
                        that.config.urlHost + '/files/temp/' + nameFile + '_web.jpg';
                    //console.log('photoOriginal: ' + that.cartService.cart.currentCartProduct.photoOriginal);
                    that.cartService.cart.currentCartProduct.photoResized = null;
                    that.cartService.cart.formatoSelected = false;
                    that.cartService.saveCart();
                    that.visibleLoader = false;
                }
                else {
                    that.visibleLoader = false;
                    console.error(result);
                    alert('Errore nell\'upload della foto!\r\nImmagine troppo pesante');
                }
            }, function (error) {
                that.visibleLoader = false;
                console.error(error);
                alert('Errore nell\'upload della foto!\r\nImmagine troppo pesante');
            });
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };
    UploadPhotoComponent = __decorate([
        core_1.Component({
            selector: 'no-content',
            template: __webpack_require__(616),
            styles: ["\n    #photoEditBar { margin-bottom:8px; }\n  "]
        }), 
        __metadata('design:paramtypes', [router_1.Router, cart_service_1.CartService, config_service_1.ConfigService, utilities_service_1.UtilitiesService, website_interface_service_1.WebsiteInterfaceService])
    ], UploadPhotoComponent);
    return UploadPhotoComponent;
}());
exports.UploadPhotoComponent = UploadPhotoComponent;


/***/ },

/***/ 599:
/***/ function(module, exports) {

module.exports = ""

/***/ },

/***/ 600:
/***/ function(module, exports) {

module.exports = "label, .as-value {\n  display: block;\n  color: #000; }\n  label.package, .as-value.package {\n    color: #06f; }\n\n.well {\n  padding-bottom: 0; }\n\n.temp-modal {\n  z-index: 2000;\n  position: fixed;\n  top: 5%;\n  left: 10%;\n  width: 80%;\n  max-width: 1000px;\n  height: 80%;\n  background-color: #fff;\n  box-shadow: 0 0 10px 0 rgba(50, 50, 50, 0.35);\n  overflow: hidden; }\n  @media (max-width: 767px) {\n    .temp-modal {\n      top: 0;\n      left: 0;\n      margin-left: 0;\n      width: 100%;\n      max-width: 100%;\n      height: 100%;\n      box-shadow: 0 0 0; } }\n"

/***/ },

/***/ 601:
/***/ function(module, exports) {

module.exports = "<div class=\"row header-angular istopcolor\">\n\n  <div class=\"col-xs-6 col-md-4 col-lg-2 header-logo text-center-sm text-center-xs margin-t-small\">\n    <a href=\"/\" title=\"TOPCOLOR\">\n      <img src=\"/Content/images/configurator/logo.png\" class=\"img-responsive\" />\n    </a>\n  </div>\n  <div class=\"col-xs-6 visible-xs visible-sm padding-t-small relative\">\n    <a (click)=\"this.changeShowStatus()\" class=\"btn btn-default full-width\">\n      MENU <i class=\"fa fa-angle-down big\"></i>\n    </a>\n  </div>\n  <div class=\"visible-xs visible-sm clear\"></div>\n  <div class=\"col-md-8 col-lg-10 text-right text-center-xs text-center-sm {{this.showHideNav == true ? null : 'hidden-xs hidden-sm' }}\">\n\n    <div class=\"float-right margin-t-small\">\n\n      <div class=\"float-left text-center margin-r-medium padding-r-medium hidden-xs\" data-click=\"#linkAssistenza\">\n        Assistenza clienti:<br />\n        <span class=\"block small color-black margin-t-mini\">\n              <i class=\"fa fa-phone margin-r-small\"></i>+39 344 2606133<br />\n              <i class=\"fa fa-envelope margin-r-small\"></i><a id=\"linkAssistenza\" href=\"/assistenza-stampa-fine-art\" title=\"Assistenza Shop\">shop@topcolor.it</a>\n          </span>\n      </div>\n\n      <div class=\"account\">\n\n        <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n            <img src=\"/Content/images/configurator/account.png\" alt=\"Account\" height=\"30\">\n            <br />\n\n            <span class=\"small inline-block\" style=\"line-height:15px;\">\n               {{ this.session.isLogged() ? \"Benvenuto\" : \"Account\"  }}\n            </span>\n\n            <b class=\"caret\"></b>\n        </a>\n        <ul class=\"dropdown-menu\">\n          <li [hidden]=\"!this.session.isLogged()\">\n            <span class=\"padding-h-medium block\">\n              <strong>{{this.session.sessionState.username }}</strong>.\n            </span>\n          </li>\n\n          <li class=\"divider\" [hidden]=\"!this.session.isLogged()\"></li>\n\n          <li [hidden]=\"!this.session.isLogged()\">\n            <a href=\"/logout?ReturnUrl=configurator\"><i class=\"fa fa-sign-out margin-r-small\"></i>LOGOUT</a>\n          </li>\n          <li [hidden]=\"!this.session.isLogged()\">\n            <a href=\"/manage\"><i class=\"fa fa-key margin-r-small\"></i>Cambia Password</a>\n          </li>\n          <li [hidden]=\"!this.session.isLogged()\">\n            <a href=\"/register\"><i class=\"fa fa-user margin-r-small\"></i>I tuoi dati</a>\n          </li>\n\n\n          <li [hidden]=\"this.session.isLogged()\">\n            <a href=\"/login?ReturnUrl=configurator\">\n                    <i class=\"fa fa-sign-in margin-r-small\"></i>LOGIN\n                  </a>\n          </li>\n          <li [hidden]=\"this.session.isLogged()\">\n            <a href=\"/register?ReturnUrl=configurator\"><i class=\"fa fa-user-plus margin-r-small\"></i>Registrati</a>\n          </li>\n\n        </ul>\n\n      </div>\n\n      <div class=\"float-left text-center margin-l-medium\">\n        <a (click)=\"this.cambiaSlide('cart')\" class=\"pointer\">\n          <img src=\"/Content/images/configurator/cart.png\" alt=\"Carrello\" height=\"30\" />\n          <br />\n          <span class=\"small\">\n            Carrello\n          </span>\n        </a>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n\n\n\n\n\n\n<div class=\"row header-angular iszodio\">\n\n  <div class=\"col-md-2 header-logo text-center-sm text-center-xs margin-t-small\">\n    <a href=\"http://www.zodio.it/\" target=\"_blank\" title=\"ZODIO\">\n        <img src=\"/Content/images/configurator/logo-zodio.png\" class=\"img-responsive\" />\n      </a>\n  </div>\n  <div class=\"col-md-10 text-right text-center-xs text-center-sm\">\n\n    <div class=\"float-right margin-t-small\">\n\n      <div class=\"float-left text-center margin-r-medium padding-r-medium\" data-click=\"#linkAssistenza\">\n        Assistenza clienti:<br />\n        <span class=\"block small color-black margin-t-mini\">\n                <i class=\"fa fa-phone margin-r-small\"></i>+39 xxx xxxxx<br />\n                <i class=\"fa fa-envelope margin-r-small\"></i><a href=\"mailto:xxx@zodio.it\" title=\"Assistenza Zodio\">xxx@zodio.it</a>\n            </span>\n      </div>\n\n      <div class=\"account\">\n\n        <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\">\n                <img src=\"/Content/images/configurator/account.png\" alt=\"Account\" height=\"30\">\n                <br />\n                Account\n\n                <b class=\"caret\"></b>\n            </a>\n        <ul class=\"dropdown-menu\">\n\n          <span [hidden]=\"!this.session.isLogged()\" class=\"small inline-block\" style=\"line-height:15px;\">\n              Benvenuto<br><b>{{this.session.sessionState.username }}</b>\n          </span>\n          <span [hidden]=\"this.session.isLogged()\" class=\"small inline-block\" style=\"line-height:15px;\">\n            Account\n          </span>\n\n          <li class=\"divider\" [hidden]=\"!this.session.isLogged()\"></li>\n\n          <li [hidden]=\"!this.session.isLogged()\">\n            <a href=\"/logout?ReturnUrl=configurator-zodio\"><i class=\"fa fa-sign-out margin-r-small\"></i>LOGOUT</a>\n          </li>\n          <li [hidden]=\"!this.session.isLogged()\">\n            <a href=\"/manage\"><i class=\"fa fa-key margin-r-small\"></i>Cambia Password</a>\n          </li>\n          <li [hidden]=\"!this.session.isLogged()\">\n            <a href=\"/register\"><i class=\"fa fa-user margin-r-small\"></i>I tuoi dati</a>\n          </li>\n\n\n          <li [hidden]=\"this.session.isLogged()\">\n            <a href=\"/login?ReturnUrl=configurator\">\n                <i class=\"fa fa-sign-in margin-r-small\"></i>LOGIN\n              </a>\n          </li>\n          <li [hidden]=\"this.session.isLogged()\">\n            <a href=\"/register?ReturnUrl=configurator\"><i class=\"fa fa-user-plus margin-r-small\"></i>Registrati</a>\n          </li>\n\n        </ul>\n\n      </div>\n\n      <div class=\"float-left text-center margin-l-medium\">\n        <a (click)=\"this.cambiaSlide('cart')\" class=\"pointer\">\n            <img src=\"/Content/images/configurator/cart.png\" alt=\"Carrello\" height=\"30\" />\n            <br />Carrello\n          </a>\n      </div>\n\n    </div>\n\n  </div>\n</div>\n\n\n\n\n\n\n<div class=\"margin-t-medium overflow-y\">\n\n  <div class=\"row\">\n    <div class=\"col-lg-3 col-md-4 margin-b-small {{this.showHideNav == true ? null : 'hidden-xs hidden-sm' }}\">\n\n      <nav class=\"navbar navbar-default\">\n        <ul class=\"nav nav-pills nav-stacked\">\n          <mybtnToggle *ngFor=\"let item of this.config.btnToggles; let i = index\" (clickBtn)=\"this.cambiaSlide(item.url)\" [url]=\"item.url\"\n            [number]=\"i+1\" [sort]=\"item.sort\" [parameter]=\"item.isParameter\" [text]=\"item.text\"></mybtnToggle>\n        </ul>\n      </nav>\n\n      <div class=\"hidden-xs hidden-sm\">\n        <div class=\"margin-t-large\"></div>\n\n        <div *ngIf='this.cartService.cart.currentCartProduct'>\n\n\n          <div *ngIf=\"this.router.isActive('/checkout', false) || this.router.isActive('/cart', true) \">\n            <br><br><br><br><br><br><br><br>\n          </div>\n\n          <div *ngIf=\"!router.isActive('/checkout', false) && !router.isActive('/cart', true) \">\n\n\n\n            <br /><br /><br />\n\n            <div *ngIf=\"this.router.isActive('/slide-parameter/Formato', false) || this.router.isActive('/slide-parameter', false) || this.router.isActive('/preview', false) || this.router.isActive('/cart', false)\">\n\n              <div class=\"row margin-b-large margin-t-small\">\n                <div class=\"col-sm-4 padding-r-none\">\n                  {{ (this.cartService.cart.currentCartProduct.price + this.cartService.cart.currentCartProduct.additionalPrice) | euroCurrency\n                  }}\n                </div>\n                <div class=\"col-sm-6\">\n                  <div class=\"input-group margin-bottom-sm\">\n                    <span class=\"input-group-addon\">x</span>\n                    <div *ngIf=\"cartService.cart.currentCartProduct\">\n\n                      <input #thisInput class=\"form-control\" placeholder=\"Quantità\" [(ngModel)]=\"cartService.cart.currentCartProduct.quantity\"\n                        type=\"number\" min=\"1\" max=\"100\" step=\"1\" (ngModelChange)=\"this.utilities.validate($event)\" (keypress)=\"this.utilities._keyPress($event)\"\n                        (blur)=\"this.utilities.refreshValue(thisInput, cartService.cart.currentCartProduct.quantity)\">\n\n                    </div>\n                  </div>\n                </div>\n              </div>\n\n              <b class=\"h2 margin-b-medium float-left\">Tot. {{ this.cartService.cart.currentCartProduct.totalPrice() | euroCurrency }}</b>\n            </div>\n            <br />\n          </div>\n\n          <div *ngIf=\"this.router.isActive('/checkout', true)\">\n            <b>{{ this.cartService.cart.totalPriceProducts | euroCurrency }}</b> prodotti<br>\n\n            <span *ngIf=\"this.cartService.cart.delivPrice > 0\">\n              + <b>{{ this.cartService.cart.delivPrice | euroCurrency }}</b>  di S.S. in\n              <br><i>{{ this.cartService.cart.shipmentAddress.Country }}</i>\n            </span>\n\n            <br><br>\n\n            <b class=\"h2\">\n              Tot.\n              <span class=\"{{this.cartService.cart.couponLabel ? 'line-through small' : null}}\">\n                {{ this.cartService.cart.totalALLPriceStatic | euroCurrency }}</span>\n              <span *ngIf=\"this.cartService.cart.couponLabel\"class=\"h2\">\n                {{ this.cartService.cart.TOTALCartORDER | euroCurrency}}</span>\n            </b>\n          </div>\n\n        </div>\n\n\n      </div>\n    </div>\n\n    <div class=\"col-lg-9 col-md-8 overflow-x\">\n\n      <div class=\"relative full-height\">\n\n        <similFancy *ngIf=\"this.cartService.cart.currentCartProduct\" [imgSrc]=\"this.cartService.cart.currentCartProduct.photoResized\"\n          [imgRounded]=\"this.cartService.cart.currentCartProduct.rounded\" [nameId]=\"'imgMaster'\"></similFancy>\n\n        <div id=\"slide\" class=\"slide\" [@AnimationSlide]=\"this.classe\" [@OpenShowSlide]=\"this.classe\">\n\n          <div  class=\"row margin-b-small\" id=\"navNextPrev\">\n\n\n\n\n              <div class=\"col-xs-5 nopadding\">\n                <a class=\"btn btn-default btn-xs full-width {{ this.ShowPREVButton() == false ? 'hidden' : null}}\" type=\"button\" (click)=\"this.PrevStep()\">\n                  <i class=\"fa fa-step-backward\" aria-hidden=\"true\"></i> &nbsp; Indietro\n                </a>\n              </div>\n\n              <div class=\"col-xs-2 nopadding\">\n                <div class=\"step\">\n                  <span class=\"smallest\">STEP:</span>\n                  {{ this.IdStep() }}\n                </div>\n              </div>\n\n              <div class=\"col-xs-5 nopadding\">\n\n                <a class=\"btn btn-success btn-xs full-width {{ this.ShowNEXTButton() == false ? 'hidden' : null }}\" type=\"button\" (click)=\"this.NextStep()\">\n                    Avanti &nbsp; <i class=\"fa fa-step-forward\" aria-hidden=\"true\"></i>\n                </a>\n              </div>\n            </div>\n\n          <router-outlet #outlet></router-outlet>\n\n\n\n          <div class=\"toggle\" (click)=\"toggleSlide($event)\">\n            <div class=\"fa fa-chevron-left\"></div>\n            <div class=\"fa fa-chevron-right\"></div>\n          </div>\n        </div>\n\n      </div>\n    </div>\n\n  </div>\n\n  <div class=\"clear\"></div>\n\n</div>\n\n\n\n<div class=\"modal fade\" id=\"mdLoginBox\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"LoginLabel\">\n  <div class=\"modal-dialog \" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"LoginLabel\">Login</h4>\n      </div>\n      <div class=\"modal-body\">\n        <p>Inserisci nome utente e password</p>\n\n        <div class=\"form-group row margin-t-medium\">\n          <label class=\"col-md-4 control-label\" for=\"MainContent_UserName\">User name</label>\n          <div class=\"col-md-8\">\n            <input id=\"txtUserName\" #txtUserName class=\"form-control\" type=\"text\">\n          </div>\n        </div>\n        <div class=\"form-group row\">\n          <label class=\"col-md-4 control-label\" for=\"MainContent_Password\">Password</label>\n          <div class=\"col-md-8\">\n            <input id=\"txtPassword\" #txtPassword class=\"form-control\" type=\"password\">\n          </div>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Chiudi</button>\n        <button type=\"button\" class=\"btn btn-success\" (click)=\"this.utilities.Login()\">Login</button>\n      </div>\n    </div>\n  </div>\n</div>\n\n\n<div class=\"modal fade\" id=\"mdCloseOrder\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ConcludiLabel\">\n  <div class=\"modal-dialog \" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"ConcludiLabel\">Concludi l'Ordine</h4>\n      </div>\n      <div class=\"modal-body\">\n        <p>Siete sicuri di voler confermare l'ordine corrente?</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Annulla</button>\n\n        <a id=\"ConfirmOrder\" href=\"#\" onclick=\"document.getElementById('ConfirmOrderHidden').click();return false;\" class=\"btn btn-success\">Conferma Ordine</a>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"modal fade\" id=\"mdCloseCampionario\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ConcludiCampionarioLabel\">\n  <div class=\"modal-dialog \" role=\"document\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <h4 class=\"modal-title\" id=\"ConcludiCampionarioLabel\">Acquista il Campionario</h4>\n      </div>\n      <div class=\"modal-body\">\n        <p>Siete sicuri di voler confermare l'acquisto del Campionario?</p>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Annulla</button>\n\n        <a id=\"ConfirmCampionario\" href=\"#\" onclick=\"document.getElementById('ConfirmCampionarioHidden').click();return false;\" class=\"btn btn-success\">Conferma Acquisto</a>\n\n      </div>\n    </div>\n  </div>\n</div>\n\n<div id=\"loaderApp\" style=\"display:none;\">\n  <span class=\"text\">elaborazione in corso...</span>\n  <i class=\"fa fa-circle-o-notch fa-spin fa-fw\"></i>\n</div>\n"

/***/ },

/***/ 602:
/***/ function(module, exports) {

module.exports = "<!--<div id=\"param-{{param.name}}\" [class]=\"isLabelLink(param) ? 'form-group float-left margin-r-medium' : 'form-group clear-left'\">-->\n\n\n<div id=\"param-{{param.name}}\" [class]=\"param.class  + ' ' + (isLabelLink(param) ? 'float-left margin-r-medium' : null) \">\n\n  <div [ngSwitch]=\"param.type\">\n\n      <div class=\"col-xs-12 margin-t-small\" [class.col-md-6]=\"false && param.image\">\n\n          <label\n            [hidden]=\"!showHidden && param.type === 'Hidden'\"\n            [attr.for]=\"'control-' + param.id\"\n            class=\"control-label\"\n            [class.error]=\"!!param.noPackageValueSelected\">\n            {{param.name | translate | async}}</label>\n\n\n          <input\n            *ngSwitchCase=\"'Hidden'\"\n            [type]=\"showHidden ? 'text' : 'hidden'\"\n            [id]=\"'control-' + param.id\"\n            [name]=\"'control-' + param.id\"\n            [value]=\"param.selectedValue\" />\n\n          <!--<div class=\"row\">\n                <div [hidden]=\"!param.image\" class=\"col-xs-12 col-md-6 pull-right\">\n                  <span class=\"param-image thumbnail\">\n                    <img *ngIf=\"param.image\" [src]=\"getParamImage(param)\" />\n                  </span>\n                </div>\n          -->\n\n\n          <div *ngSwitchCase=\"'Label'\" class=\"param-box thumbnail\" [class.error]=\"param.noPackageValueSelected === param.selectedValue\">\n              <div class=\"padding-h-medium\">\n                {{param.selectedValue | translate | async}}\n              </div>\n              <!--<input type=\"hidden\" [id]=\"'control-' + param.id\" [name]=\"'control-' + param.id\" [value]=\"param.selectedValue\" />-->\n\n                {{ param.selectedValue }}\n\n          </div>\n\n\n          <!--<div *ngSwitchCase=\"'Combo'\">\n            <div *ngFor=\"let v of param.values\" class=\"inline-block padding-r-medium\">\n              <div (click)=\"onValueChange(param, v.value)\"\n                [class.selected]=\"param.values.length > 1 && param.selectedValue === v.value\"\n                [class.package]=\"v.package === true\"\n                [class.no-package]=\"v.package === false\"\n                [class.pointer]=\"param.values.length > 1\"\n                [class.error]=\"param.noPackageValueSelected === v.value\"\n                class=\"param-box thumbnail inline-block\">\n                <div class=\"padding-h-medium\">\n                  {{v.value | translate | async}}\n                </div>\n              </div>\n            </div>\n          </div>-->\n\n\n          <select *ngSwitchCase=\"'Combo'\" #combo [id]=\"'control-' + param.id\" [name]=\"'control-' + param.id\" class=\"form-control\"\n            (change)=\"onValueChange(param, combo.value)\">\n            <!--<option value=\"\" [selected]=\"param.selectedValue === '_NOVALUE_'\">- seleziona -</option>-->\n            <option\n              *ngFor=\"let v of this.param.values\"\n              value=\"{{v.value}}\"\n              [class.selected]=\"param.values.length > 1 && param.selectedValue === v.value\"\n              [selected]=\"param.selectedValue === v.value\"\n              [class.error]=\"param.noPackageValueSelected === v.value\">\n\n              <!--{{v.value.replace('Formato_Portrait', 'Verticale').replace('Formato_Landscape', 'Orizzontale') | translate | async}} {{v.package ? ' (package version)' : ''}}-->\n              {{v.value | translate | async}} {{v.package ? ' (package version)' : ''}}\n              </option>\n\n          </select>\n\n\n          <input *ngSwitchCase=\"'Number'\" type=\"number\" [id]=\"'control-' + param.id\" [name]=\"'control-' + param.id\" [value]=\"param.selectedValue\" />\n\n\n\n          <div *ngSwitchCase=\"'ImageList'\">\n            <div *ngFor=\"let g of group(param.values, 4)\" class=\"row\">\n              <div *ngFor=\"let v of g.values\" class=\"col-xs-6 col-sm-3\">\n                <div (click)=\"onValueChange(param, v.value)\"\n                  [class.package]=\"v.package === true\"\n                  [class.no-package]=\"v.package === false\"\n                  [class.selected]=\"param.selectedValue === v.value\"\n                  [class.error]=\"param.noPackageValueSelected === v.value\"\n                  class=\"param-box pointer text-center\">\n                  <img [src]=\"getParamImage(param.name, v.value)\" class=\"img-responsive\" />\n\n                  {{v.value | translate | async}}\n\n                </div>\n              </div>\n            </div>\n          </div>\n\n\n          <div *ngSwitchCase=\"'Table'\" class=\"row\">\n            <div class=\"col-xs-12 margin-b-medium\">\n              <div *ngFor=\"let v of param.values\" class=\"col-xs-3 col-sm-2 {{param.image ? 'col-md-3 col-lg-2' : 'col-md-2 col-lg-1'}} nopadding\">\n                <div (click)=\"onValueChange(param, v.value)\"\n                  [class.package]=\"v.package === true\"\n                  [class.no-package]=\"v.package === false\"\n                  [class.selected]=\"param.selectedValue === v.value\"\n                  [class.error]=\"param.noPackageValueSelected === v.value\"\n                  class=\"param-box thumbnail nomargin pointer text-center\">\n                  {{v.value | translate | async}}\n                </div>\n              </div>\n            </div>\n          </div>\n\n\n          <div *ngSwitchCase=\"'MultiTable'\" >\n            <!--<div style=\"height: auto; width: 100%; overflow-x: hidden; margin-bottom: 50px;\">-->\n            <div style=\"height: auto; max-height: 400px; width: 100%; overflow-y: auto; position: relative; z-index:10;\">\n\n                <div *ngFor=\"let formatCateg of this.DistinctFormat(param.values)\" class=\"boxFormat\" id=\"{{ formatCateg }}\">\n\n                    <div class=\"titleFormat\">{{ formatCateg.replace('F_', '').replace('X', ':') }}</div>\n\n                    <div *ngFor=\"let v of this.FormatsFiltered(param.values, formatCateg)\">\n\n                        <div class=\"riga-input hidden {{ this.EnableFormat(v.value) == false ? 'disabled' : 'formatOK' }} {{ this.IsActiveFormat(v.value) }}\"\n                        (click)=\"this.setFormat($event, v.value, false);\"></div>\n\n                        <!--es v.value: F_4X3|80_x_60|80|60|200|\"-->\n                        <div class=\"riga-input {{ this.EnableFormat(v.value) == false ? 'disabled' : 'formatOK' }} {{ this.IsActiveFormat(v.value) }}\"\n                          (click)=\"this.setFormat($event, v.value, true);\"\n                          id=\"{{ v.value.split('|')[0] + '|' + v.value.split('|')[1] }}\"\n                          title=\"{{ this.EnableFormat(v.value) == false ? 'Immagine troppo piccola per questo formato' : null }}\">\n\n                          <i class=\"fa fa-info-circle\" ></i>\n                          <div class=\"float-left\">\n                              {{ v.value.split('|')[1].replace('_x_', ' x ') }}\n                          </div>\n                          <div class=\"float-right\">\n                            <i class=\"barrato\">{{ v.value.split('|')[5].indexOf('O') != -1\n                              ? (v.value.split('|')[5] | euroCurrency)\n                              : null }}</i>\n                            <u>{{ v.value.split('|')[4] | euroCurrency }}</u>\n                          </div>\n                        </div>\n\n                    </div>\n\n                    <div class=\"anteprima\">\n                      <div class=\"btn btn-default\" (click)=\"this.GoPersonalized($event, 'pagecrop')\">\n                         Anteprima <i class=\"margin-l-small fa fa-camera\" ></i>\n                      </div>\n                    </div>\n\n                </div>\n              </div>\n\n\n          </div>\n\n\n\n      </div>\n  </div>\n</div>\n"

/***/ },

/***/ 603:
/***/ function(module, exports) {

module.exports = "<div [hidden]=\"!hasPackage\" class=\"hidden-xs float-right h1\">\n  <div class=\"as-text\">\n    <span class=\"h5\">LEGEND:</span>\n    <span class=\"as-value package\">value = package version</span>\n    <span class=\"as-value\">value = custom version</span>\n  </div>\n</div>\n\n\n<div *ngIf=\"this.errors\" class=\"alert alert-danger\">{{errors}}</div>\n\n\n<form>\n  <div class=\"row\">\n\n    <div [class.hidden]=\"g.hidden\" class=\"page\" *ngFor=\"let g of this.validParams\">\n\n      <div [hidden]=\"!g.image\" class=\"col-md-6 col-lg-5 pull-right\">\n\n        <div [hidden]=\"!p.image\" *ngFor=\"let p of g.params\">\n          <label>Example of {{p.name | translate | async}}</label>\n          <div class=\"param-image thumbnail\">\n            <img *ngIf=\"p.image\" [src]=\"getParamImage(p.name)\" />\n          </div>\n        </div>\n\n      </div>\n\n      <config-control *ngFor=\"let p of g.params\" [model]=\"this.model\" [param]=\"p\"\n      (valueChange)=\"paramChanged(p, $event)\"></config-control>\n\n    </div>\n  </div>\n</form>\n"

/***/ },

/***/ 604:
/***/ function(module, exports) {

module.exports = "<div class=\"well padding-v-large\">\n  <h1 class=\"margin-b-large block\">Acquisto Campionario completato</h1>\n\n  <h2 class=\"margin-b-large block\">Grazie per aver effettuato il tuo acquisto<br /> A breve riceverai una e-mail di conferma</h2>\n\n  <img class=\"img-responsive margin-v-large\" src=\"/Content/images/configurator/logo.png\" alt=\"topcolor logo\" width=\"50%\">\n\n\n\n\n\n</div>\n"

/***/ },

/***/ 605:
/***/ function(module, exports) {

module.exports = "<h1>Carrello</h1>\n<p>Visualizza i prodotti nel carrello ed inserisci i tuoi dati per chiudere l'ordine.</p>\n\n\n<div class=\"col-sm-12 \">\n  <table id=\"cartTable\" class=\"table table-hover\">\n    <thead>\n      <tr>\n        <th class=\"hidden-xs\">Prodotto</th>\n        <th></th>\n        <th>Quantità</th>\n        <th class=\"text-center hidden-xs\">Prezzo</th>\n        <th class=\"text-center\">Totale</th>\n        <th> </th>\n      </tr>\n    </thead>\n    <tbody *ngIf=\"this.cartService.cart.cartProducts\">\n\n      <tr *ngFor=\"let cli of this.cartService.cart.cartProducts\" style=\"vertical-align: center !important;\">\n\n        <td class=\"col-sm-8 col-md-3 hidden-xs\">\n          <img src=\"{{ cli.photoResized ? cli.photoResized : null }}\" class=\"full-width img-thumbnail {{ cli.rounded ? 'img-circle' : null }} inline margin-r-small\"\n            alt=\"{{ !cli.photoResized ? '...Ritaglio non caricato...' : null }}\" width=\"150\" />\n        </td>\n\n        <td class=\"col-sm-7 col-md-3\">\n          <i>{{ cli.idRow }}) </i> - {{ cli.productName}}\n          <br /><br />\n\n          <div *ngIf=\"cli.params\">\n            Formato: <b>{{ this.configApi.getParamValue(cli.params, 'Formato').selectedValue.toString().split('_').join('') }}</b>\n          </div>\n\n          <div *ngFor=\"let param of this.getListParam(cli)\">\n            {{ param.selectedValue === 'NONE' ? (param.name | translate | async) + ': ' : null }}\n            <b class=\"mini-tag\">{{ param.selectedValue | translate | async }}</b><br />\n          </div>\n        </td>\n\n        <td class=\"col-sm-1 col-md-1\" style=\"text-align: center\">\n\n          <input #thisInput type=\"number\" min=\"1\" max=\"100\" step=\"1\" class=\"form-control full-width\" [(ngModel)]=\"cli.quantity\" (ngModelChange)=\"this.utilities.validateCart($event, cli.idRow)\"\n            (blur)=\"this.utilities.refreshValue(thisInput, cli.quantity)\">\n\n          <!--<inputrefreshcomponent [quantity]=\"cli.quantity\" [idRow]=\"cli.idRow\" (onUserChange)=\"userEvt($event)\" ></inputrefreshcomponent>-->\n        </td>\n        <td class=\"col-sm-2 col-md-2 text-center hidden-xs\">\n          <!--<strong>{{ cli.price | euroCurrency }}<br>\n            {{ cli.additionalPrice > 0 ? \"+ \" : null }}\n            {{ cli.additionalPrice > 0 ? ( cli.additionalPrice | euroCurrency) : null }}\n            </strong>-->\n          <strong>{{ (cli.price + cli.additionalPrice) | euroCurrency }}</strong>\n        </td>\n        <td class=\"col-sm-1 col-md-1 text-center\"><strong>{{cli.totalPrice() | euroCurrency}}</strong></td>\n        <td class=\"col-sm-1 col-md-1\">\n          <button type=\"button\" class=\"btn btn-danger\" (click)=\"removeCartProduct(cli.idRow)\">\n                <span class=\"glyphicon glyphicon-remove\"></span>\n            </button>\n        </td>\n      </tr>\n    </tbody>\n  </table>\n</div>\n\n<div class=\"col-sm-12 text-right margin-b-medium\">\n  Totale <strong class=\"h3\">{{ this.cartService.cart.currentCartProduct.totalPrice() | euroCurrency }}</strong>\n</div>\n\n<div class=\"col-sm-6\">\n  <button class=\"btn btn-default full-width\" type=\"button\" (click)=\"addNewProduct()\">\n    <span class=\"glyphicon glyphicon-shopping-cart\"></span>\n    Aggiungi Prodotto\n  </button>\n</div>\n<div class=\"col-sm-6\">\n  <button type=\"button\" class=\"btn btn-success full-width\" [routerLink]=\"['/checkout']\">\n    Checkout <i class=\"fa fa-angle-right big\"></i>\n  </button>\n</div>\n"

/***/ },

/***/ 606:
/***/ function(module, exports) {

module.exports = "<h1>Acquista Campionario</h1>\r\n<p>Inserisci i tuoi dati per completare la richiesta</p>\r\n\r\n\r\n\r\n\r\n<div class=\"alert alert-info\" data-toggle=\"modal\" data-target=\"#mdLoginBox\">\r\n  <p>Sei già registrato? <b>Clicca quì per eseguire il Login</b></p>\r\n</div>\r\n\r\n\r\n<div class=\"row\">\r\n  <form (ngSubmit)=\"frmShipmentSubmit(frmShipment)\" #frmShipment=\"ngForm\">\r\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(1)\">\r\n      <div class=\"form-step-header\">1) Dati di Spedizione</div>\r\n    </div>\r\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 1\">\r\n      <div class=\"form-group col-md-6\">\r\n        <label for=\"name\">Nome</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"name\" [(ngModel)]=\"this.cartService.cart.customer.Name\" maxlength=\"50\" required>\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"surname\">Cognome</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"surname\" [(ngModel)]=\"this.cartService.cart.customer.Surname\" maxlength=\"50\"\r\n          required>\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"email\">Email</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"customerEmail\" [(ngModel)]=\"this.cartService.cart.customer.Email\" maxlength=\"50\"\r\n          required>\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"phone\">Telefono</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"phone\" [(ngModel)]=\"this.cartService.cart.customer.Phone\" maxlength=\"20\" required>\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"state\">Nazione</label>\r\n\r\n        <select class=\"form-control\" name=\"state\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.Country\" (ngModelChange)=\"onChange($event)\">\r\n          <option value=\"IT\">Italia</option>\r\n          <option *ngFor=\"let ce of this.config.deliveryPricesEXT\" value=\"{{ce.nation}}\">{{ce.nation}}</option>\r\n        </select>\r\n\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"province\">Provincia</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"province\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.District\" maxlength=\"100\"\r\n          required>\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"city\">Città</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"city\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.City\" maxlength=\"100\"\r\n          required>\r\n      </div>\r\n      <div class=\"form-group  col-md-6\">\r\n        <label for=\"cap\">Cap</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"cap\" maxlength=\"100\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.PostalCode\"\r\n          required>\r\n      </div>\r\n      <div class=\"form-group  col-xs-12\">\r\n        <label for=\"address\">Indirizzo</label>\r\n        <input type=\"text\" class=\"form-control\" name=\"street\" maxlength=\"255\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.Street\"\r\n          required>\r\n      </div>\r\n      <div class=\"col-xs-12 margin-t-small\">\r\n        <button type=\"submit\" class=\"btn btn-success\">Continua (2 - dati di fatturazione)</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n\r\n  <form (ngSubmit)=\"frmInvoiceSubmit(frmInvoice)\" #frmInvoice=\"ngForm\">\r\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(2)\">\r\n      <div class=\"form-step-header\">2) Dati di Fatturazione</div>\r\n    </div>\r\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 2\">\r\n\r\n      <div class=\"col-xs-12\">\r\n        <div class=\"form-group col-md-6\">\r\n          <label for=\"name\">Nome</label>\r\n          <input type=\"text\" class=\"form-control\" name=\"billingName\" [(ngModel)]=\"this.cartService.cart.billing.Name\" maxlength=\"50\">\r\n        </div>\r\n        <div class=\"form-group  col-md-6\">\r\n          <label for=\"surname\">Cognome</label>\r\n          <input type=\"text\" class=\"form-control\" name=\"billingSurname\" [(ngModel)]=\"this.cartService.cart.billing.Surname\" maxlength=\"50\">\r\n        </div>\r\n\r\n        <div class=\"form-group  col-md-6\">\r\n          <label for=\"surname\">Codice Fiscale</label>\r\n          <input type=\"text\" class=\"form-control\" name=\"billingTaxCode\" [(ngModel)]=\"this.cartService.cart.billing.TaxCode\" maxlength=\"50\" uppercase>\r\n        </div>\r\n        <div class=\"form-group  col-md-6\">\r\n          <label for=\"surname\">P.IVA</label>\r\n          <input type=\"text\" class=\"form-control\" name=\"billingVatNumber\" [(ngModel)]=\"this.cartService.cart.billing.VatNumber\" maxlength=\"50\" uppercase>\r\n        </div>\r\n\r\n        <div class=\"form-group  col-md-6\">\r\n          <label for=\"surname\">Codice SDI</label>\r\n          <input type=\"text\" class=\"form-control\" name=\"billingCodeSDI\" [(ngModel)]=\"this.cartService.cart.billing.CodeSDI\" maxlength=\"50\" uppercase>\r\n        </div>\r\n        <div class=\"form-group  col-md-6\">\r\n          <label for=\"surname\">PEC</label>\r\n          <input type=\"text\" class=\"form-control\" name=\"billingPEC\" [(ngModel)]=\"this.cartService.cart.billing.PEC\" maxlength=\"50\" uppercase>\r\n        </div>\r\n\r\n      </div>\r\n      <div class=\"col-xs-12 margin-t-small\">\r\n        <button type=\"submit\" class=\"btn btn-success\">Continua (3 - tipo pagamento)</button>\r\n      </div>\r\n    </div>\r\n\r\n  </form>\r\n\r\n\r\n\r\n  <form (ngSubmit)=\"frmPaymentTypeSubmit(frmPaymentType)\" #frmPaymentType=\"ngForm\">\r\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(4)\">\r\n      <div class=\"form-step-header\">3) Tipo Pagamento</div>\r\n    </div>\r\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 3\">\r\n      <div class=\"form-group col-md-6\">\r\n        <label for=\"name\">Tipo di Pagamento</label>\r\n        <select class=\"form-control\" required name=\"state\" [(ngModel)]=\"this.selPaymentType\">\r\n          <option *ngFor=\"let po of this.config.paymentOptionsCampionario\" [ngValue]=\"po.key\">\r\n            {{po.name}}\r\n          </option>\r\n        </select>\r\n      </div>\r\n\r\n      <div class=\"form-group col-xs-12\">\r\n        <div class=\"well col-xs-12\">\r\n          Dati per Bonifico Bancario:\r\n          <br />\r\n          <br />TOPCOLOR DREAM SRL\r\n          <br />Banca C.R. Asti ag. Buccinasco\r\n          <br />IBAN IT81F0608532650000000022152\r\n          <br />BIC/SWIFT CASRIT22\r\n          <br /><br /><b>È indispensabile inviare conferma via email all'indirizzo <a href=\"mailto:shop@topcolor.it\">shop@topcolor.it</a> dell'avvenuto pagamento con data di emissione del bonifico e CRO.</b>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12 margin-t-small\">\r\n        <button type=\"submit\" class=\"btn btn-success\">Continua (4 -PAGAMENTO)</button>\r\n      </div>\r\n    </div>\r\n  </form>\r\n\r\n  <form (ngSubmit)=\"this.frmEndCampionarioSubmit(frmEndCampionario)\" #frmEndCampionario=\"ngForm\">\r\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : '' }}\" (click)=\"changeStep(5)\">\r\n      <div class=\"form-step-header\">4) PAGAMENTO</div>\r\n    </div>\r\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 4\">\r\n      <div class=\"form-group col-md-6\">\r\n\r\n        <br /><br />\r\n        <b class=\"h2\">Campionario Topcolor<br />\r\n        Tot. {{ this.config.campionarioPrice | euroCurrency }}</b>\r\n        <br /><br />\r\n\r\n        <div id=\"braintree-container\"></div>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12\">\r\n        <button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" data-target=\"#mdCloseCampionario\">Acquista il Campionario</button>\r\n      </div>\r\n    </div>\r\n\r\n    <button id=\"ConfirmCampionarioHidden\" type=\"submit\" class=\"hidden\">Conferma Acquisto</button>\r\n\r\n\r\n\r\n\r\n\r\n  </form>\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n</div>\r\n"

/***/ },

/***/ 607:
/***/ function(module, exports) {

module.exports = "<h1>Checkout</h1>\n<p>Inserisci i tuoi dati per completare l'ordine</p>\n\n\n\n<div class=\"alert alert-info istopcolor\" data-toggle=\"modal\" data-target=\"#mdLoginBox\">\n  <p>Sei già registrato? <b>Clicca quì per eseguire il Login</b></p>\n</div>\n\n\n\n\n<div class=\"row\">\n  <form (ngSubmit)=\"frmShipmentSubmit(frmShipment)\" #frmShipment=\"ngForm\">\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(1)\">\n      <div class=\"form-step-header\">1) Dati principali</div>\n    </div>\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 1\">\n      <div class=\"form-group col-md-6\">\n        <label for=\"name\">Nome</label>\n        <input type=\"text\" class=\"form-control\" name=\"name\" [(ngModel)]=\"this.cartService.cart.customer.Name\" maxlength=\"50\" required>\n      </div>\n      <div class=\"form-group  col-md-6\">\n        <label for=\"surname\">Cognome</label>\n        <input type=\"text\" class=\"form-control\" name=\"surname\" [(ngModel)]=\"this.cartService.cart.customer.Surname\" maxlength=\"50\"\n          required>\n      </div>\n      <div class=\"form-group  col-md-6\">\n        <label for=\"email\">Email</label>\n        <input type=\"text\" class=\"form-control\" name=\"customerEmail\" [(ngModel)]=\"this.cartService.cart.customer.Email\" maxlength=\"50\"\n          (change)=\"emailChanged()\" required>\n      </div>\n      <div class=\"form-group  col-md-6\">\n        <label for=\"phone\">Telefono</label>\n        <input type=\"text\" class=\"form-control\" name=\"phone\" [(ngModel)]=\"this.cartService.cart.customer.Phone\" maxlength=\"20\" required>\n      </div>\n\n      <div class=\"form-group col-xs-12\">\n        <div class=\"alert alert-info float-left full-width\">\n\n          <div class=\"form-group col-md-6\">\n            <p>Hai un codice sconto? Inseriscilo quì:</p>\n            <!--<input type=\"text\" class=\"form-control\" name=\"couponLabel\" maxlength=\"255\" [(ngModel)]=\"this.cartService.cart.couponLabel\">-->\n            <input #couponField type=\"text\" class=\"form-control\" name=\"surname\" id=\"txtCodeCouponLabel\" maxlength=\"50\">\n          </div>\n          <div class=\"form-group col-md-6\">\n            <p>Codice sconto attualmente applicato: <b *ngIf=\"this.cartService.cart.couponLabel\">{{this.cartService.cart.couponLabel}}</b></p>\n            <button type=\"button\" class=\"btn btn-success full-width\" (click)=\"this.applyCoupon(couponField)\">Calcola</button>\n          </div>\n\n        </div>\n      </div>\n\n      <div class=\"col-xs-12\">\n        <button type=\"submit\" class=\"btn btn-success\">Continua (2 - dati di Spedizione)</button>\n      </div>\n    </div>\n  </form>\n\n\n  <form (ngSubmit)=\"frmShipmentTypeSubmit(frmInvoice)\" #frmShipmentType=\"ngForm\">\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(2)\">\n        <div class=\"form-step-header\">2) Dati di Spedizione</div>\n    </div>\n\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 2\">\n\n\n      <form #frmShipmentType=\"ngForm\">\n            <div class=\"form-group col-md-6\">\n              <label for=\"name\">Tipo Spedizione</label>\n\n              <select class=\"form-control\" required name=\"state\" [(ngModel)]=\"this.selDeliveryOptionId\" (ngModelChange)=\"onShipmentChange($event)\">\n                <option *ngFor=\"let de of this.config.deliveryOptions\" [ngValue]=\"de.id\">\n                  {{de.name}}\n                </option>\n              </select>\n            </div>\n        </form>\n\n        <div class=\"clear\"></div>\n\n        <div *ngIf=\"this.cartService.cart.SelDeliveryOption.id === 1\">\n          <div class=\"form-group col-md-6\">\n            <label for=\"state\">Nazione</label>\n            <select class=\"form-control\" name=\"state\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.Country\" (ngModelChange)=\"onShipmentChange($event)\">\n              <option value=\"IT\">Italia</option>\n              <option *ngFor=\"let ce of this.config.deliveryPricesEXT\" value=\"{{ce.nation}}\">{{ce.nation}}</option>\n            </select>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"province\">Provincia</label>\n            <input type=\"text\" class=\"form-control\" name=\"province\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.District\" maxlength=\"100\"\n              required>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"city\">Città</label>\n            <input type=\"text\" class=\"form-control\" name=\"city\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.City\" maxlength=\"100\"\n              required>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"cap\">Cap</label>\n            <input type=\"text\" class=\"form-control\" name=\"cap\" maxlength=\"100\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.PostalCode\"\n              required>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"address\">Indirizzo</label>\n            <input type=\"text\" class=\"form-control\" name=\"street\" maxlength=\"255\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.Street\"\n              required>\n          </div>\n          <div class=\"form-group col-md-6\">\n            <label for=\"address\">presso (c/o)</label>\n            <input type=\"text\" class=\"form-control\" name=\"street\" maxlength=\"255\" [(ngModel)]=\"this.cartService.cart.shipmentAddress.Extended\">\n          </div>\n        </div>\n\n\n        <div class=\"col-xs-12 margin-t-small\">\n          <button type=\"submit\" class=\"btn btn-success\">Continua (3 - Dati di Fatturazione)</button>\n        </div>\n      </div>\n\n  </form>\n\n\n\n  <form (ngSubmit)=\"frmInvoiceSubmit(frmInvoice)\" #frmInvoice=\"ngForm\">\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(3)\">\n      <div class=\"form-step-header\">3) Dati di Fatturazione</div>\n    </div>\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 3\">\n      <div class=\"col-xs-12\">\n        <div class=\"form-group col-md-6\">\n          <label for=\"name\">Nome</label>\n          <input type=\"text\" class=\"form-control\" name=\"billingName\" [(ngModel)]=\"this.cartService.cart.billing.Name\" maxlength=\"50\">\n        </div>\n        <div class=\"form-group  col-md-6\">\n          <label for=\"surname\">Cognome</label>\n          <input type=\"text\" class=\"form-control\" name=\"billingSurname\" [(ngModel)]=\"this.cartService.cart.billing.Surname\" maxlength=\"50\">\n        </div>\n\n        <div class=\"form-group  col-md-6\">\n          <label for=\"surname\">Codice Fiscale</label>\n          <!-- <input type=\"text\" class=\"form-control\" name=\"billingTaxCode\" [(ngModel)]=\"this.cartService.cart.billing.TaxCode\" maxlength=\"50\"> -->\n          <input type=\"text\" class=\"form-control\" name=\"billingTaxCode\"\n            [(ngModel)]=\"this.cartService.cart.billing.TaxCode\"\n            oninvalid=\"setCustomValidity('Attenzione! Formato non valido')\"\n            onchange=\"try{setCustomValidity('')}catch(e){}\"\n            pattern=\"^[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$\">\n        </div>\n\n        <div class=\"form-group  col-md-6\">\n          <label for=\"surname\">P.IVA</label>\n          <!-- <input type=\"text\" class=\"form-control\" name=\"billingVatNumber\" [(ngModel)]=\"this.cartService.cart.billing.VatNumber\" maxlength=\"50\"> -->\n          <input type=\"text\" class=\"form-control\" name=\"billingVatNumber\"\n            [(ngModel)]=\"this.cartService.cart.billing.VatNumber\"\n            oninvalid=\"setCustomValidity('Attenzione! Formato non valido')\"\n            onchange=\"try{setCustomValidity('')}catch(e){}\"\n            pattern=\"^[0-9]{11}$\">\n        </div>\n\n        <div class=\"form-group  col-md-6\">\n          <label for=\"surname\">Codice SDI</label>\n          <input type=\"text\" class=\"form-control\" name=\"billingCodeSDI\" [(ngModel)]=\"this.cartService.cart.billing.CodeSDI\" maxlength=\"50\" uppercase>\n        </div>\n        <div class=\"form-group  col-md-6\">\n          <label for=\"surname\">PEC</label>\n          <input type=\"text\" class=\"form-control\" name=\"billingPEC\" [(ngModel)]=\"this.cartService.cart.billing.PEC\" maxlength=\"50\" uppercase>\n        </div>\n\n      </div>\n      <div class=\"col-xs-12 margin-t-small\">\n        <button type=\"submit\" class=\"btn btn-success\">Continua (4 - tipo spedizione)</button>\n      </div>\n    </div>\n\n  </form>\n\n\n\n  <form (ngSubmit)=\"frmPaymentTypeSubmit(frmPaymentType)\" #frmPaymentType=\"ngForm\">\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : 'not-allowed' }}\" (click)=\"changeStep(4)\">\n      <div class=\"form-step-header\">4) Tipo Pagamento</div>\n    </div>\n    <div class=\"step-content col-xs-12\" *ngIf=\"this.cartService.cart.checkoutStepIndex === 4\">\n      <div class=\"form-group col-md-6\">\n        <label for=\"name\">Tipo di Pagamento</label>\n        <select class=\"form-control\" required name=\"state\" [(ngModel)]=\"this.selPaymentType\">\n          <option *ngFor=\"let po of this.config.paymentOptions\" [ngValue]=\"po.key\">\n            {{po.name}}\n          </option>\n        </select>\n      </div>\n\n      <div class=\"form-group col-xs-12\">\n        <div class=\"well col-xs-12\">\n          Dati per Bonifico Bancario:\n          <br />\n          <br />TOPCOLOR DREAM SRL\n          <br />Banca C.R. Asti ag. Buccinasco\n          <br />IBAN IT81F0608532650000000022152\n          <br />BIC/SWIFT CASRIT22\n          <br /><br /><b>È indispensabile inviare conferma via email all'indirizzo <a href=\"mailto:shop@topcolor.it\">shop@topcolor.it</a> dell'avvenuto pagamento con data di emissione del bonifico e CRO.</b>\n        </div>\n      </div>\n\n      <div class=\"col-xs-12 margin-t-small\">\n        <button type=\"submit\" class=\"btn btn-success\">Continua (5 - PAGAMENTO)</button>\n      </div>\n    </div>\n  </form>\n\n  <form id=\"frmEndOrder\" (ngSubmit)=\"this.frmEndOrderSubmit(frmEndOrder)\" #frmEndOrder=\"ngForm\">\n    <div class=\"col-xs-12 {{ this.isEnabled() ? 'pointer' : '' }}\" (click)=\"changeStep(5)\">\n      <div class=\"form-step-header\">5) PAGAMENTO</div>\n    </div>\n    <div class=\"step-content col-xs-12\" [class.hidden]=\"this.cartService.cart.checkoutStepIndex !== 5\">\n      <div class=\"form-group col-md-6\">\n\n        <div class=\"bigger\">\n          <b>{{ this.cartService.cart.totalPriceProducts | euroCurrency }}</b> prodotti\n\n          <span *ngIf=\"this.cartService.cart.delivPrice > 0\">\n            + <b>{{ this.cartService.cart.delivPrice | euroCurrency }}</b> di S.S. in <i>{{ this.cartService.cart.shipmentAddress.Country }}</i>\n          </span>\n        </div>\n\n        <br /><br />\n        <b class=\"h2\">\n          Tot.\n          <span class=\"{{this.cartService.cart.couponLabel ? 'line-through small' : null}}\">\n            {{ this.cartService.cart.totalALLPriceStatic | euroCurrency }}</span>\n          <span *ngIf=\"this.cartService.cart.couponLabel\" class=\"h2\">\n            {{this.cartService.cart.TOTALCartORDER | euroCurrency}}</span>\n        </b>\n        <br /><br />\n\n        <div #braintreeContainer id=\"braintree-container\"></div>\n      </div>\n\n      <div class=\"col-xs-12 margin-t-small\">\n        <button [hidden]=\"!enabledConfirmOrder\" type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" data-target=\"#mdCloseOrder\">Concludi l'Ordine </button>\n      </div>\n\n    </div>\n\n    <button id=\"ConfirmOrderHidden\" type=\"submit\" class=\"hidden\">Conferma Ordine</button>\n\n\n    <!--<div class=\"modal fade\" id=\"mdCloseOrder\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"ConcludiLabel\">\n      <div class=\"modal-dialog \" role=\"document\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <h4 class=\"modal-title\" id=\"ConcludiLabel\">Concludi l'Ordine</h4>\n          </div>\n          <div class=\"modal-body\">\n            <p>Siete sicuri di voler confermare l'ordine corrente?</p>\n          </div>\n          <div class=\"modal-footer\">\n            <button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Annulla</button>\n            <button id=\"ConfirmOrder\" type=\"submit\" class=\"btn btn-success\">Conferma Ordine</button>\n          </div>\n        </div>\n      </div>\n    </div>-->\n\n\n\n  </form>\n</div>\n"

/***/ },

/***/ 608:
/***/ function(module, exports) {

module.exports = "\n\n<div *ngIf='this.isImageCatalog'>\n  <h1>Caricamento Immagine...</h1>\n  <h2>Load image...</h2>\n</div>\n\n<div *ngIf='!this.isImageCatalog'>\n  <h1>Caricamento Prodotto...</h1>\n  <h2>Load product...</h2>\n</div>\n\n<i class=\"fa fa-circle-o-notch fa-spin fa-fw\" style=\"font-size: 100px; color: #509e2f; margin: 14px 0;\"></i>\n\n<!-- <div *ngFor=\"let prod of this.config.products\">\n      {{ this.prod.id }} - {{ this.prod.name }}<br>\n</div> -->\n"

/***/ },

/***/ 609:
/***/ function(module, exports) {

module.exports = "<div class=\"well padding-v-large\">\n  <h1 class=\"margin-b-large block\">Ordine completato</h1>\n\n  <h2 class=\"margin-b-large block\">Grazie per aver effettuato il tuo ordine<br /> A breve riceverai una e-mail di conferma</h2>\n\n  <img class=\"img-responsive margin-v-large\" src=\"/Content/images/configurator/logo{{ this.config.isModeZodio ? '-zodio' : null }}.png\" alt=\"topcolor logo\" />\n  <!--{{ this.OldTotalCart }}<br> {{ this.OldTotalCart > 0 }}-->\n\n\n\n\n  <!--<div *ngIf=\"this.OldTotalCart > 0\">-->\n  <!--</div>-->\n\n</div>\n"

/***/ },

/***/ 610:
/***/ function(module, exports) {

module.exports = "<h1 class=\"visible-xs visible-sm\">Ritaglia</h1>\n<div>\n\n  <div class=\"row margin-b-small\">\n\n    <div class=\"col-xs-6 col-sm-3\">\n      <div class=\"input-group margin-bottom-sm\">\n        <span class=\"input-group-addon\">\n        <i class=\"fa fa-arrows-h fa-fw\"></i>\n      </span>\n        <input class=\"form-control\" placeholder=\"Larghezza\" type=\"text\" value=\"{{ this.session.cropWidth }}\" disabled=\"true\">\n      </div>\n    </div>\n\n    <div class=\"col-xs-6 col-sm-3\">\n      <div class=\"input-group margin-bottom-sm\">\n        <span class=\"input-group-addon\">\n        <i class=\"fa fa-arrows-v fa-fw\"></i>\n      </span>\n        <input class=\"form-control\" placeholder=\"Altezza\" type=\"text\" value=\"{{ this.session.cropHeight }}\" disabled=\"true\">\n      </div>\n    </div>\n\n  </div>\n\n\n  <!-- min-width:300px; min-height: 300px; -->\n  <div class=\"img-cropper img-thumbnail\" style=\"position:relative; float:left;\">\n    <div id=\"loader\" class=\"{{ this.visibleLoader ? null : 'hidden' }}\">\n      <!--<img src=\"/Content/images/configurator/logo.png\" />-->\n      <span class=\"text\">caricamento in corso...</span>\n      <i class=\"fa fa-circle-o-notch fa-spin fa-fw\"></i>\n    </div>\n    <img-cropper #cropper [image]=\"data1\" [settings]=\"cropperSettings1\" (onCrop)=\"cropped($event)\"></img-cropper>\n  </div>\n\n\n  <span class=\"result hidden\">\n    <img class=\"img-thumbnail img-responsive {{ this.cartService.cart.currentCartProduct.rounded ? 'img-circle' : null}}\" [src]=\"data1.image\" />\n  </span>\n\n  <div class=\"clear\"></div>\n  <div class=\"row margin-t-small\">\n    <div class=\"col-sm-6\">\n      <!--<a class=\"btn btn-default full-width\"  [routerLink]=\"['/preview']\">-->\n      <a class=\"btn btn-success full-width {{ this.visibleLoader ? 'disabled' : null }}\" (click)=\"confirmCropped()\">\n        Conferma ritaglio <i class=\"margin-l-small fa fa-check-square-o\" ></i>\n      </a>\n    </div>\n  </div>\n\n</div>\n"

/***/ },

/***/ 611:
/***/ function(module, exports) {

module.exports = "<h1>Anteprima</h1>\n<p>Visualizza l'anteprima ambientata del prodotto configurato. <i>L'anteprima è indicativa</i></p>\n\n<similFancy [imgSrc]=\"this.cartService.cart.currentCartProduct.photoResized\"\n[imgRounded]=\"this.cartService.cart.currentCartProduct.rounded\" [nameId]=\"'preview'\"></similFancy>\n\n<div class=\"clear\"></div>\n\n<div class=\"row margin-t-small\">\n  <div class=\"col-sm-6\">\n    <a class=\"btn btn-default full-width\" [routerLink]=\"['/pagecrop']\">\n      Personalizza <i class=\"margin-l-small fa fa-pencil-square-o\"></i>\n    </a>\n  </div>\n\n  <div class=\"col-sm-6\">\n    <a class=\"btn btn-default full-width\" [routerLink]=\"['/cart']\">\n      Vai al Carrello <i class=\"margin-l-small fa fa-shopping-cart\" ></i>\n    </a>\n  </div>\n</div>\n"

/***/ },

/***/ 612:
/***/ function(module, exports) {

module.exports = "<h1 class=\"visible-xs visible-sm\">Formato</h1>\n\n<configurator [productConfig]=\"this.session.productConfig\" [tables]=\"'NavbarFormato'\">\n  <div style=\"position:fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: #fff;\">\n    <i class=\"fa fa-cog fa-spin fa-4x fa-fw\" style=\"position: absolute; top: 50%; left: 50%; width: 70px; margin-top: 10px; margin-left: -35px;\"></i>\n  </div>\n</configurator>\n\n\n\n\n"

/***/ },

/***/ 613:
/***/ function(module, exports) {

module.exports = "<h1 class=\"visible-xs visible-sm\">Seleziona prodotto:</h1>\n<ul class=\"nav nav-tabs smaller\">\n  <li *ngFor=\"let categ of this.session.modelsVisible\" class=\"{{categ.id == this.session.productConfig.idModel ? 'active' : ''}}\">\n    <a data-toggle=\"tab\" href=\"#{{categ.url}}\">\n      {{categ.name}}\n    </a>\n  </li>\n</ul>\n\n<div class=\"tab-content\">\n  <div *ngFor=\"let categ of this.session.modelsVisible\" id=\"{{categ.url}}\"\n    class=\"tab-pane fade in {{categ.id == this.session.productConfig.idModel ? 'active' : ''}}\">\n\n    <div class=\"row\">\n      <div class=\"col-sm-{{(categ.id == 4 || categ.id == 5) ? '4' : '6'}}\n      box-product {{ this.session.productConfig.name == product.name ? 'active' : null }}\"\n      *ngFor=\"let product of this.config.getProductFromIdCateg(categ.id);\"\n        (click)=\"product.preFilters ? null : this.session.setProduct(product)\">\n\n          <img class=\"margin-v-medium img-responsive inline\" src=\"/Content/images/configurator/menu/id/{{product.id}}.png\">\n          <p class=\"text\">{{product.name}}</p>\n\n          <div *ngFor=\"let f of product.preFilters\">\n            <div *ngIf=\"f.values.length > 1\">\n              <div *ngFor=\"let v of f.values\">\n                  <button class=\"btn-link {{ (this.session.productConfig.name == product.name) ?\n                   this.session.getParamValue(f.key, this.session.params, '') == v ? 'active' : null\n                   : null }}\" type=\"button\" [value]=\"v\" (click)=\"this.session.setProduct(product, f.key, v)\">\n                        {{v | translate | async}}\n                 </button>\n              </div>\n           </div>\n          </div>\n\n      </div>\n    </div>\n\n  </div>\n</div>\n"

/***/ },

/***/ 614:
/***/ function(module, exports) {

module.exports = "<div id=\"{{this.nameId}}\" class=\"{{!this.imgSrc ? 'hidden': null}} similfancy\">\n  <div class=\"ImgThumb hidden\">\n    <img src=\"{{ this.imgSrc }}\" class=\"img-thumbnail {{ this.imgRounded ? 'img-circle' : null }}\" />\n  </div>\n\n  <a (click)=\"clickShowImg($event)\" class='linkPrevImg fancyClose'>\n    <img #imgSimilFancy src=\"{{ this.imgSrc }}\" class=\"previewImg img-thumbnail {{ this.imgRounded ? 'img-circle' : null }} {{ !this.imgSrc ? 'hidden' : null }}\"\n    />\n  </a>\n\n\n  <div id=\"loader\" class=\"{{ this.visibleLoader ? null : 'hidden' }}\">\n    <!--<img src=\"/Content/images/configurator/logo.png\" />-->\n    <span class=\"text\">caricamento in corso...</span>\n    <i class=\"fa fa-circle-o-notch fa-spin fa-fw\"></i>\n  </div>\n\n</div>\n"

/***/ },

/***/ 615:
/***/ function(module, exports) {

module.exports = "<h1 class=\"visible-xs visible-sm\">{{this.parameter | translate | async}}</h1>\n\n<form (ngSubmit)=\"onSubmit()\">\n  <div class=\"row\">\n\n    <configurator [productConfig]=\"this.cartService.cart.currentCartProduct.config\"  [tables]=\"this.table\">\n      <div style=\"position:fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: #fff;\">\n        <i class=\"fa fa-cog fa-spin fa-4x fa-fw\" style=\"position: absolute; top: 50%; left: 50%; width: 70px; margin-top: 10px; margin-left: -35px;\"></i>\n      </div>\n    </configurator>\n\n  </div>\n\n</form>\n"

/***/ },

/***/ 616:
/***/ function(module, exports) {

module.exports = "<script src=\"bower_components/plupload/js/plupload.full.min.js\"></script>\n<script src=\"bower_components/angular-plupload/dist/angular-plupload.min.js\"></script>\n\n\n<div class=\"row\">\n\n  <div class=\"col-sm-12\">\n\n    <h1>Carica la tua foto</h1>\n    <p>\n      <!-- Carica una foto dal tuo dispositivo per poterla stampare sui nostri prodotti. -->\n      Formati file: <b>JPG</b> e <b>TIFF</b><br />\n      Formato minimo: <b>0,4 megapixel</b>, Dimensione file massime: <b>500 MB</b>\n    </p>\n\n\n    <input type=\"file\" class=\"hidden\" (change)=\"fileChange(fuImage)\" #fuImage />\n\n\n    <div id=\"photoEditBar\" class=\"row\">\n\n      <div class=\"col-sm-4\">\n        <a class=\"btn btn-default full-width\" (click)=\"fuImage.click()\">\n          Upload Image\n          <i class=\"fa fa-upload margin-l-small\"></i>\n          </a>\n      </div>\n\n      <div *ngIf='this.cartService.cart.currentCartProduct'>\n        <div class=\"col-sm-4\" *ngIf='this.cartService.cart.currentCartProduct.photoOriginal'>\n          <a class=\"btn btn-success full-width\" routerLink=\"/slide-parameter/Formato\" routerLinkActive=\"active\">\n            Seleziona Formato\n          </a>\n        </div>\n      </div>\n\n      <div class=\"col-sm-4\">\n        <a class=\"btn btn-default full-width\" href=\"{{this.config.urlHost}}catalogo-immagini\">\n          Catalogo Immagini\n        </a>\n      </div>\n\n\n\n    </div>\n  </div>\n\n  <div class=\"col-sm-12\">\n      <!-- min-width:300px; min-height: 300px; -->\n    <div *ngIf='this.cartService.cart.currentCartProduct' style=\"position:relative; float:left; overflow:hidden;\">\n      <div id=\"loader\" class=\"{{ this.visibleLoader ? null : 'hidden' }}\">\n        <!--<img src=\"/Content/images/configurator/logo.png\" />-->\n        <span class=\"text\">caricamento in corso...</span>\n        <i class=\"fa fa-circle-o-notch fa-spin fa-fw\"></i>\n      </div>\n      <similFancy [imgSrc]=\"this.cartService.cart.currentCartProduct.photoOriginal\" [imgRounded]=\"false\" [nameId]=\"'upload'\"></similFancy>\n    </div>\n  </div>\n\n  <div class=\"clear\"></div>\n  <div class=\"col-sm-12\" *ngIf='this.cartService.cart.currentCartProduct.photoOriginal'>\n    <b>Risoluzione foto: {{ this.cartService.cart.currentCartProduct.naturalWidth }}px x {{ this.cartService.cart.currentCartProduct.naturalHeight }}px\n      ( Adatta fino al formato: {{  (this.cartService.cart.currentCartProduct.naturalWidth / this.config.RappRisoluzMin).toFixed()  }}cm x\n      {{ (this.cartService.cart.currentCartProduct.naturalHeight / this.config.RappRisoluzMin).toFixed() }}cm )</b>\n  </div>\n\n</div>\n"

/***/ },

/***/ 65:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__ = __webpack_require__(203);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgControl; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 *  A base class that all control directive extend.
  * It binds a {@link FormControl} object to a DOM element.
  * *
  * Used internally by Angular forms.
  * *
 * @abstract
 */
var NgControl = (function (_super) {
    __extends(NgControl, _super);
    function NgControl() {
        _super.apply(this, arguments);
        /** @internal */
        this._parent = null;
        this.name = null;
        this.valueAccessor = null;
        /** @internal */
        this._rawValidators = [];
        /** @internal */
        this._rawAsyncValidators = [];
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    /**
     * @abstract
     * @param {?} newValue
     * @return {?}
     */
    NgControl.prototype.viewToModelUpdate = function (newValue) { };
    return NgControl;
}(__WEBPACK_IMPORTED_MODULE_0__abstract_control_directive__["a" /* AbstractControlDirective */]));
function NgControl_tsickle_Closure_declarations() {
    /** @type {?} */
    NgControl.prototype._parent;
    /** @type {?} */
    NgControl.prototype.name;
    /** @type {?} */
    NgControl.prototype.valueAccessor;
    /** @type {?} */
    NgControl.prototype._rawValidators;
    /** @type {?} */
    NgControl.prototype._rawAsyncValidators;
}
//# sourceMappingURL=ng_control.js.map

/***/ },

/***/ 74:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return EventEmitter; });
/* unused harmony reexport Observable */
/* unused harmony reexport Subject */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};



/**
 *  Use by directives and components to emit custom Events.
  * *
  * ### Examples
  * *
  * In the following example, `Zippy` alternatively emits `open` and `close` events when its
  * title gets clicked:
  * *
  * ```
  * selector: 'zippy',
  * template: `
  * <div class="zippy">
  * <div (click)="toggle()">Toggle</div>
  * <div [hidden]="!visible">
  * <ng-content></ng-content>
  * </div>
  * </div>`})
  * export class Zippy {
  * visible: boolean = true;
  * @Output() open: EventEmitter<any> = new EventEmitter();
  * @Output() close: EventEmitter<any> = new EventEmitter();
  * *
  * toggle() {
  * this.visible = !this.visible;
  * if (this.visible) {
  * this.open.emit(null);
  * } else {
  * this.close.emit(null);
  * }
  * }
  * }
  * ```
  * *
  * The events payload can be accessed by the parameter `$event` on the components output event
  * handler:
  * *
  * ```
  * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
  * ```
  * *
  * Uses Rx.Observable but provides an adapter to make it work as specified here:
  * https://github.com/jhusain/observable-spec
  * *
  * Once a reference implementation of the spec is available, switch to it.
 */
var EventEmitter = (function (_super) {
    __extends(EventEmitter, _super);
    /**
     *  Creates an instance of [EventEmitter], which depending on [isAsync],
      * delivers events synchronously or asynchronously.
     * @param {?=} isAsync
     */
    function EventEmitter(isAsync) {
        if (isAsync === void 0) { isAsync = false; }
        _super.call(this);
        this.__isAsync = isAsync;
    }
    /**
     * @param {?=} value
     * @return {?}
     */
    EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
    /**
     * @param {?=} generatorOrNext
     * @param {?=} error
     * @param {?=} complete
     * @return {?}
     */
    EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
        var /** @type {?} */ schedulerFn;
        var /** @type {?} */ errorFn = function (err) { return null; };
        var /** @type {?} */ completeFn = function () { return null; };
        if (generatorOrNext && typeof generatorOrNext === 'object') {
            schedulerFn = this.__isAsync ? function (value) {
                setTimeout(function () { return generatorOrNext.next(value); });
            } : function (value) { generatorOrNext.next(value); };
            if (generatorOrNext.error) {
                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
                    function (err) { generatorOrNext.error(err); };
            }
            if (generatorOrNext.complete) {
                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
                    function () { generatorOrNext.complete(); };
            }
        }
        else {
            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
                function (value) { generatorOrNext(value); };
            if (error) {
                errorFn =
                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
            }
            if (complete) {
                completeFn =
                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
            }
        }
        return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
    };
    return EventEmitter;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subject__["Subject"]));
function EventEmitter_tsickle_Closure_declarations() {
    /** @type {?} */
    EventEmitter.prototype.__isAsync;
}
//# sourceMappingURL=async.js.map

/***/ },

/***/ 75:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export scheduleMicroTask */
/* unused harmony export global */
/* unused harmony export getTypeNameForDebugging */
/* harmony export (immutable) */ exports["c"] = isPresent;
/* harmony export (immutable) */ exports["f"] = isBlank;
/* unused harmony export isStrictStringMap */
/* unused harmony export isDate */
/* unused harmony export stringify */
/* unused harmony export NumberWrapper */
/* harmony export (immutable) */ exports["e"] = looseIdentical;
/* harmony export (immutable) */ exports["a"] = isJsObject;
/* unused harmony export print */
/* unused harmony export warn */
/* unused harmony export setValueOnPath */
/* harmony export (immutable) */ exports["b"] = getSymbolIterator;
/* harmony export (immutable) */ exports["d"] = isPrimitive;
/* unused harmony export escapeRegExp */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var /** @type {?} */ globalScope;
if (typeof window === 'undefined') {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
        // TODO: Replace any with WorkerGlobalScope from lib.webworker.d.ts #3492
        globalScope = (self);
    }
    else {
        globalScope = (global);
    }
}
else {
    globalScope = (window);
}
/**
 * @param {?} fn
 * @return {?}
 */
function scheduleMicroTask(fn) {
    Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
}
// Need to declare a new variable for global here since TypeScript
// exports the original value of the symbol.
var /** @type {?} */ _global = globalScope;

/**
 * @param {?} type
 * @return {?}
 */
function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
// TODO: remove calls to assert in production environment
// Note: Can't just export this and import in in other files
// as `assert` is a reserved keyword in Dart
_global.assert = function assert(condition) {
    // TODO: to be fixed properly via #2830, noop for now
};
/**
 * @param {?} obj
 * @return {?}
 */
function isPresent(obj) {
    return obj != null;
}
/**
 * @param {?} obj
 * @return {?}
 */
function isBlank(obj) {
    return obj == null;
}
var /** @type {?} */ STRING_MAP_PROTO = Object.getPrototypeOf({});
/**
 * @param {?} obj
 * @return {?}
 */
function isStrictStringMap(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
}
/**
 * @param {?} obj
 * @return {?}
 */
function isDate(obj) {
    return obj instanceof Date && !isNaN(obj.valueOf());
}
/**
 * @param {?} token
 * @return {?}
 */
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (token == null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return "" + token.overriddenName;
    }
    if (token.name) {
        return "" + token.name;
    }
    var /** @type {?} */ res = token.toString();
    var /** @type {?} */ newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
var NumberWrapper = (function () {
    function NumberWrapper() {
    }
    /**
     * @param {?} text
     * @return {?}
     */
    NumberWrapper.parseIntAutoRadix = function (text) {
        var /** @type {?} */ result = parseInt(text);
        if (isNaN(result)) {
            throw new Error('Invalid integer literal when parsing ' + text);
        }
        return result;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NumberWrapper.isNumeric = function (value) { return !isNaN(value - parseFloat(value)); };
    return NumberWrapper;
}());
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function looseIdentical(a, b) {
    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
/**
 * @param {?} o
 * @return {?}
 */
function isJsObject(o) {
    return o !== null && (typeof o === 'function' || typeof o === 'object');
}
/**
 * @param {?} obj
 * @return {?}
 */
function print(obj) {
    // tslint:disable-next-line:no-console
    console.log(obj);
}
/**
 * @param {?} obj
 * @return {?}
 */
function warn(obj) {
    console.warn(obj);
}
/**
 * @param {?} global
 * @param {?} path
 * @param {?} value
 * @return {?}
 */
function setValueOnPath(global, path, value) {
    var /** @type {?} */ parts = path.split('.');
    var /** @type {?} */ obj = global;
    while (parts.length > 1) {
        var /** @type {?} */ name_1 = parts.shift();
        if (obj.hasOwnProperty(name_1) && obj[name_1] != null) {
            obj = obj[name_1];
        }
        else {
            obj = obj[name_1] = {};
        }
    }
    if (obj === undefined || obj === null) {
        obj = {};
    }
    obj[parts.shift()] = value;
}
var /** @type {?} */ _symbolIterator = null;
/**
 * @return {?}
 */
function getSymbolIterator() {
    if (!_symbolIterator) {
        if (((globalScope)).Symbol && Symbol.iterator) {
            _symbolIterator = Symbol.iterator;
        }
        else {
            // es6-shim specific logic
            var /** @type {?} */ keys = Object.getOwnPropertyNames(Map.prototype);
            for (var /** @type {?} */ i = 0; i < keys.length; ++i) {
                var /** @type {?} */ key = keys[i];
                if (key !== 'entries' && key !== 'size' &&
                    ((Map)).prototype[key] === Map.prototype['entries']) {
                    _symbolIterator = key;
                }
            }
        }
    }
    return _symbolIterator;
}
/**
 * @param {?} obj
 * @return {?}
 */
function isPrimitive(obj) {
    return !isJsObject(obj);
}
/**
 * @param {?} s
 * @return {?}
 */
function escapeRegExp(s) {
    return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
//# sourceMappingURL=lang.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ },

/***/ 78:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var http_1 = __webpack_require__(59);
var Observable_1 = __webpack_require__(1);
var config_service_1 = __webpack_require__(10);
var ConfiguratorApiService = (function () {
    function ConfiguratorApiService(config, http) {
        this.config = config;
        this.http = http;
    }
    ConfiguratorApiService.prototype.getParams = function (xml) {
        var _this = this;
        return this.http.get(this.config.apiUrl + "/parser/get/" + xml)
            .map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    ConfiguratorApiService.prototype.getParamValue = function (parameters, key) {
        if (!parameters) {
            return null;
        }
        return parameters.find(function (r) { return r.name === key; });
    };
    ConfiguratorApiService.prototype.load = function (model, oldParams) {
        var _this = this;
        return this.http.post(this.config.apiUrl + '/parser/load', {
            model: model,
            oldParams: oldParams ? oldParams.map(function (p) { return { key: p.name, value: p.selectedValue }; }) : null,
            headers: this.getHeaders()
        }).map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    ConfiguratorApiService.prototype.update = function (model, oldParams, name, value, stayInPackage) {
        ////console.log(this.config.apiUrl + '/parser/update - ' + model);
        var _this = this;
        return this.http.post(this.config.apiUrl + '/parser/update', {
            model: model,
            oldParams: oldParams.map(function (p) { return { key: p.name, value: p.selectedValue }; }),
            newParam: { key: name, value: value },
            stayInPackage: stayInPackage,
            headers: this.getHeaders()
        }).map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    ConfiguratorApiService.prototype.multiupdate = function (model, oldParams, newParams, stayInPackage) {
        ////console.log(this.config.apiUrl + '/parser/multiupdate - ' + model);
        var _this = this;
        return this.http.post(this.config.apiUrl + '/parser/multiupdate', {
            model: model,
            oldParams: oldParams.map(function (p) { return { key: p.name, value: p.selectedValue }; }),
            newParams: newParams,
            stayInPackage: stayInPackage,
            headers: this.getHeaders()
        }).map(function (res) { return _this.mapResponse(res); })
            .catch(function (err) { return _this.handleError(err); });
    };
    ConfiguratorApiService.prototype.getHeaders = function () {
        var headers = new http_1.Headers();
        headers.append('Accept', 'application/json');
        return headers;
    };
    ConfiguratorApiService.prototype.mapResponse = function (res) {
        if (!res.ok) {
            this.handleError(res);
        }
        else {
            return res.json();
        }
    };
    ConfiguratorApiService.prototype.handleError = function (error) {
        var errMsg;
        if (!!error._body) {
            var errJson = JSON.parse(error._body);
            errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
        }
        else {
            errMsg = (error.message) ? error.message :
                error.status ? error.status + " - " + error.statusText : 'Server error';
        }
        console.error(errMsg); // log to console instead
        return Observable_1.Observable.throw(errMsg);
    };
    ConfiguratorApiService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [config_service_1.ConfigService, http_1.Http])
    ], ConfiguratorApiService);
    return ConfiguratorApiService;
}());
exports.ConfiguratorApiService = ConfiguratorApiService;


/***/ },

/***/ 79:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var config_service_1 = __webpack_require__(10);
var ScrollService = (function () {
    function ScrollService(config) {
        this.config = config;
        this.scrollLeftFormat = 0;
        this.scrollTopFormat = 0;
    }
    ScrollService.prototype.scrollCenterBoxFormat = function (format) {
        var that = this;
        setTimeout(function () {
            var WidthSlide = document.getElementsByClassName('slide')[0].clientWidth - 10;
            var ThisBoxFormat = document.getElementById(format.split('|')[0]);
            if (ThisBoxFormat != null) {
                var scrollLeft = (ThisBoxFormat.offsetLeft - (WidthSlide / 2) + (ThisBoxFormat.offsetWidth / 2));
                var DivExtraLarge = document.getElementById('extra-large');
                var WidthExtraLarge = -DivExtraLarge.clientWidth;
                var limits = -(WidthExtraLarge + WidthSlide);
                if (scrollLeft < 0) {
                    scrollLeft = 0;
                }
                else if (scrollLeft > limits) {
                    scrollLeft = limits;
                }
                that.scrollLeftFormat = -scrollLeft;
            }
        }, 100);
    };
    ScrollService.prototype.scrollVERTICALCenterBoxFormat = function (format) {
        var that = this;
        setTimeout(function () {
            var VerticalSlide = document.getElementsByClassName('slide')[0].clientHeight - 10;
            var ThisBoxFormat = document.getElementById(format.split('|')[0]);
            if (ThisBoxFormat != null) {
                var scrollTop = (ThisBoxFormat.offsetTop - (VerticalSlide / 2) + (ThisBoxFormat.offsetHeight / 2));
                var DivExtraLarge = document.getElementById('extra-large');
                var HeightExtraLarge = -DivExtraLarge.clientHeight;
                var limits = -(HeightExtraLarge + VerticalSlide);
                if (scrollTop < 0) {
                    scrollTop = 0;
                }
                else if (scrollTop > limits) {
                    scrollTop = limits;
                }
                that.scrollTopFormat = scrollTop;
            }
        }, 100);
    };
    ScrollService.prototype.ResetScrollLeft = function (selectFormat) {
        ////console.log('ResetScrollLeft');
        var that = this;
        setTimeout(function () {
            var BoxSelected = document.getElementById(selectFormat);
            if (BoxSelected != null && (BoxSelected.className.indexOf('formatOK') > -1)) {
            }
            else {
                that.scrollLeftFormat = 0;
                setTimeout(function () {
                    that.simulatedClick(document.getElementsByClassName('riga-input hidden formatOK')[0]);
                }, 300);
            }
        }, 600);
    };
    ScrollService.prototype.simulatedClick = function (element) {
        //console.log('simulatedClick');
        if (element != null) {
            var d = document.createEvent('MouseEvents'), c = document.createEvent('MouseEvents'), p = document.createEvent('MouseEvents');
            d.initMouseEvent('mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            c.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            p.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            element.dispatchEvent(d);
            element.dispatchEvent(c);
            element.dispatchEvent(p);
        }
    };
    ScrollService.prototype.scrollLeft = function () {
        var WidthColumn = document.getElementsByClassName('boxFormat')[0].clientWidth;
        var newValueLeft = this.scrollLeftFormat + WidthColumn;
        var timeanimation = 0;
        if (newValueLeft + 100 > 0) {
            this.scrollLeftFormat = 30;
            newValueLeft = 0;
            timeanimation = 150;
        }
        else { }
        var that = this;
        setTimeout(function () {
            that.scrollLeftFormat = newValueLeft;
        }, timeanimation);
    };
    ScrollService.prototype.scrollRight = function () {
        var WidthColumn = document.getElementsByClassName('boxFormat')[0].clientWidth;
        var newValueLeft = this.scrollLeftFormat - WidthColumn;
        var WidthExtraLarge = -document.getElementById('extra-large').clientWidth;
        var WidthSlide = document.getElementsByClassName('slide')[0].clientWidth - 10;
        var limits = (WidthExtraLarge + WidthSlide);
        var timeanimation = 0;
        if (newValueLeft - 100 < limits) {
            this.scrollLeftFormat = limits - 30;
            newValueLeft = limits;
            timeanimation = 150;
        }
        var that = this;
        setTimeout(function () {
            that.scrollLeftFormat = newValueLeft;
        }, timeanimation);
    };
    ScrollService = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [config_service_1.ConfigService])
    ], ScrollService);
    return ScrollService;
}());
exports.ScrollService = ScrollService;


/***/ },

/***/ 888:
/***/ function(module, exports, __webpack_require__) {

"use strict";
"use strict";
var core_1 = __webpack_require__(0);
var platform_browser_dynamic_1 = __webpack_require__(168);
var app_module_1 = __webpack_require__(399);
// depending on the env mode, enable prod mode or add debugging modules
if (true) {
    core_1.enableProdMode();
}
function main() {
    return platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule).then(function (MODULE_REF) { if (false) {
        module["hot"]["accept"]();
        if (MODULE_REF.instance["hmrOnInit"]) {
            module["hot"]["data"] && MODULE_REF.instance["hmrOnInit"](module["hot"]["data"]);
        }
        if (MODULE_REF.instance["hmrOnStatus"]) {
            module["hot"]["apply"](function (status) { MODULE_REF.instance["hmrOnStatus"](status); });
        }
        if (MODULE_REF.instance["hmrOnCheck"]) {
            module["hot"]["check"](function (err, outdatedModules) { MODULE_REF.instance["hmrOnCheck"](err, outdatedModules); });
        }
        if (MODULE_REF.instance["hmrOnDecline"]) {
            module["hot"]["decline"](function (dependencies) { MODULE_REF.instance["hmrOnDecline"](dependencies); });
        }
        module["hot"]["dispose"](function (store) { MODULE_REF.instance["hmrOnDestroy"] && MODULE_REF.instance["hmrOnDestroy"](store); MODULE_REF.destroy(); MODULE_REF.instance["hmrAfterDestroy"] && MODULE_REF.instance["hmrAfterDestroy"](store); });
    } return MODULE_REF; });
}
exports.main = main;
if (document.readyState === 'complete') {
    main();
}
else {
    document.addEventListener('DOMContentLoaded', main);
}


/***/ },

/***/ 96:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared__ = __webpack_require__(53);
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return AbstractFormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};


/**
 *  This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
  * *
 */
var AbstractFormGroupDirective = (function (_super) {
    __extends(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        _super.apply(this, arguments);
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType();
        this.formDirective.addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         *  Get the {@link FormGroup} backing this binding.
         * @return {?}
         */
        get: function () { return this.formDirective.getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         *  Get the path to this control group.
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["a" /* controlPath */])(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         *  Get the {@link Form} to which this group belongs.
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["b" /* composeValidators */])(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared__["c" /* composeAsyncValidators */])(this._asyncValidators); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_0__control_container__["a" /* ControlContainer */]));
function AbstractFormGroupDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    AbstractFormGroupDirective.prototype._parent;
    /** @type {?} */
    AbstractFormGroupDirective.prototype._validators;
    /** @type {?} */
    AbstractFormGroupDirective.prototype._asyncValidators;
}
//# sourceMappingURL=abstract_form_group_directive.js.map

/***/ },

/***/ 97:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__model__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared__ = __webpack_require__(53);
/* unused harmony export formDirectiveProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return NgForm; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};






var /** @type {?} */ formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgForm; })
};
var /** @type {?} */ resolvedPromise = Promise.resolve(null);
/**
 *  to track aggregate form value and validation status.
  * *
  * *
  * As soon as you import the `FormsModule`, this directive becomes active by default on
  * all `<form>` tags.  You don't need to add a special selector.
  * *
  * You can export the directive into a local template variable using `ngForm` as the key
  * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
  * {@link FormGroup} instance are duplicated on the directive itself, so a reference to it
  * will give you access to the aggregate value and validity status of the form, as well as
  * user interaction properties like `dirty` and `touched`.
  * *
  * To register child controls with the form, you'll want to use {@link NgModel} with a
  * `name` attribute.  You can also use {@link NgModelGroup} if you'd like to create
  * sub-groups within the form.
  * *
  * You can listen to the directive's `ngSubmit` event to be notified when the user has
  * triggered a form submission. The `ngSubmit` event will be emitted with the original form
  * submission event.
  * *
  * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * * **NgModule**: `FormsModule`
  * *
  * @stable
 */
var NgForm = (function (_super) {
    __extends(NgForm, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgForm(validators, asyncValidators) {
        _super.call(this);
        this._submitted = false;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
        this.form =
            new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */]({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["b" /* composeValidators */])(validators), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["c" /* composeAsyncValidators */])(asyncValidators));
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        /**
         * @return {?}
         */
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            dir._control = (container.registerControl(dir.name, dir.control));
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["d" /* setUpControl */])(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new __WEBPACK_IMPORTED_MODULE_2__model__["a" /* FormGroup */]({});
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__shared__["e" /* setUpFormContainer */])(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = (_this.form.get(dir.path));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? (this.form.get(path)) : this.form;
    };
    NgForm.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    outputs: ['ngSubmit'],
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    NgForm.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    return NgForm;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */]));
function NgForm_tsickle_Closure_declarations() {
    /** @type {?} */
    NgForm.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    NgForm.ctorParameters;
    /** @type {?} */
    NgForm.prototype._submitted;
    /** @type {?} */
    NgForm.prototype.form;
    /** @type {?} */
    NgForm.prototype.ngSubmit;
}
//# sourceMappingURL=ng_form.js.map

/***/ },

/***/ 98:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ng_control__ = __webpack_require__(65);
/* unused harmony export RADIO_VALUE_ACCESSOR */
/* harmony export (binding) */ __webpack_require__.d(exports, "b", function() { return RadioControlRegistry; });
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return RadioControlValueAccessor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var /** @type {?} */ RADIO_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_1__control_value_accessor__["a" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 *  Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    RadioControlRegistry.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    RadioControlRegistry.ctorParameters = function () { return []; };
    return RadioControlRegistry;
}());
function RadioControlRegistry_tsickle_Closure_declarations() {
    /** @type {?} */
    RadioControlRegistry.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RadioControlRegistry.ctorParameters;
    /** @type {?} */
    RadioControlRegistry.prototype._accessors;
}
/**
 *  *
  * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
  * to keep the view synced with the {@link FormControl} model.
  * *
  * *
  * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
  * value accessor will be active on any radio control that has a form directive. You do
  * **not** need to add a special selector to activate it.
  * *
  * ### How to use radio buttons with form directives
  * *
  * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
  * in the same group have the same `name` attribute.  Radio buttons with different `name`
  * attributes do not affect each other.
  * *
  * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
  * *
  * When using radio buttons in a reactive form, radio buttons in the same group should have the
  * same `formControlName`. You can also add a `name` attribute, but it's optional.
  * *
  * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
  * *
  * * **npm package**: `@angular/forms`
  * *
  * @stable
 */
var RadioControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _registry
     * @param {?} _injector
     */
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(__WEBPACK_IMPORTED_MODULE_2__ng_control__["a" /* NgControl */]);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    RadioControlValueAccessor.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                    host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                    providers: [RADIO_VALUE_ACCESSOR]
                },] },
    ];
    /** @nocollapse */
    RadioControlValueAccessor.ctorParameters = function () { return [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
        { type: RadioControlRegistry, },
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    ]; };
    RadioControlValueAccessor.propDecorators = {
        'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return RadioControlValueAccessor;
}());
function RadioControlValueAccessor_tsickle_Closure_declarations() {
    /** @type {?} */
    RadioControlValueAccessor.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    RadioControlValueAccessor.ctorParameters;
    /** @type {?} */
    RadioControlValueAccessor.propDecorators;
    /** @type {?} */
    RadioControlValueAccessor.prototype._state;
    /** @type {?} */
    RadioControlValueAccessor.prototype._control;
    /** @type {?} */
    RadioControlValueAccessor.prototype._fn;
    /** @type {?} */
    RadioControlValueAccessor.prototype.onChange;
    /** @type {?} */
    RadioControlValueAccessor.prototype.onTouched;
    /** @type {?} */
    RadioControlValueAccessor.prototype.name;
    /** @type {?} */
    RadioControlValueAccessor.prototype.formControlName;
    /** @type {?} */
    RadioControlValueAccessor.prototype.value;
    /** @type {?} */
    RadioControlValueAccessor.prototype._renderer;
    /** @type {?} */
    RadioControlValueAccessor.prototype._elementRef;
    /** @type {?} */
    RadioControlValueAccessor.prototype._registry;
    /** @type {?} */
    RadioControlValueAccessor.prototype._injector;
}
//# sourceMappingURL=radio_control_value_accessor.js.map

/***/ },

/***/ 99:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__facade_async__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__facade_collection__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validators__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__control_container__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__reactive_errors__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared__ = __webpack_require__(53);
/* unused harmony export formDirectiveProvider */
/* harmony export (binding) */ __webpack_require__.d(exports, "a", function() { return FormGroupDirective; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};







var /** @type {?} */ formDirectiveProvider = {
    provide: __WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 *  *
  * *
  * This directive accepts an existing {@link FormGroup} instance. It will then use this
  * {@link FormGroup} instance to match any child {@link FormControl}, {@link FormGroup},
  * and {@link FormArray} instances to child {@link FormControlName}, {@link FormGroupName},
  * and {@link FormArrayName} directives.
  * *
  * **Set value**: You can set the form's initial value when instantiating the
  * {@link FormGroup}, or you can set it programmatically later using the {@link FormGroup}'s
  * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue} methods.
  * *
  * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
  * to the {@link FormGroup}'s {@link AbstractControl.valueChanges} event.  You can also listen to
  * its {@link AbstractControl.statusChanges} event to be notified when the validation status is
  * re-calculated.
  * *
  * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
  * triggered a form submission. The `ngSubmit` event will be emitted with the original form
  * submission event.
  * *
  * ### Example
  * *
  * In this example, we create form controls for first name and last name.
  * *
  * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
  * *
  * **npm package**: `@angular/forms`
  * *
  * **NgModule**: {@link ReactiveFormsModule}
  * *
  * @stable
 */
var FormGroupDirective = (function (_super) {
    __extends(FormGroupDirective, _super);
    /**
     * @param {?} _validators
     * @param {?} _asyncValidators
     */
    function FormGroupDirective(_validators, _asyncValidators) {
        _super.call(this);
        this._validators = _validators;
        this._asyncValidators = _asyncValidators;
        this._submitted = false;
        this.directives = [];
        this.form = null;
        this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_1__facade_async__["a" /* EventEmitter */]();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = function (dir) { __WEBPACK_IMPORTED_MODULE_2__facade_collection__["b" /* ListWrapper */].remove(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["e" /* setUpFormContainer */])(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var /** @type {?} */ ctrl = (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["h" /* cleanUpControl */])(dir._control, dir);
                if (newCtrl)
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["d" /* setUpControl */])(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = function () {
        var /** @type {?} */ sync = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["b" /* composeValidators */])(this._validators);
        this.form.validator = __WEBPACK_IMPORTED_MODULE_3__validators__["a" /* Validators */].compose([this.form.validator, sync]);
        var /** @type {?} */ async = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__shared__["c" /* composeAsyncValidators */])(this._asyncValidators);
        this.form.asyncValidator = __WEBPACK_IMPORTED_MODULE_3__validators__["a" /* Validators */].composeAsync([this.form.asyncValidator, async]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            __WEBPACK_IMPORTED_MODULE_5__reactive_errors__["a" /* ReactiveErrors */].missingFormException();
        }
    };
    FormGroupDirective.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                    selector: '[formGroup]',
                    providers: [formDirectiveProvider],
                    host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                    exportAs: 'ngForm'
                },] },
    ];
    /** @nocollapse */
    FormGroupDirective.ctorParameters = function () { return [
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["b" /* NG_VALIDATORS */],] },] },
        { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_3__validators__["c" /* NG_ASYNC_VALIDATORS */],] },] },
    ]; };
    FormGroupDirective.propDecorators = {
        'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroup',] },],
        'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return FormGroupDirective;
}(__WEBPACK_IMPORTED_MODULE_4__control_container__["a" /* ControlContainer */]));
function FormGroupDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    FormGroupDirective.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    FormGroupDirective.ctorParameters;
    /** @type {?} */
    FormGroupDirective.propDecorators;
    /** @type {?} */
    FormGroupDirective.prototype._submitted;
    /** @type {?} */
    FormGroupDirective.prototype._oldForm;
    /** @type {?} */
    FormGroupDirective.prototype.directives;
    /** @type {?} */
    FormGroupDirective.prototype.form;
    /** @type {?} */
    FormGroupDirective.prototype.ngSubmit;
    /** @type {?} */
    FormGroupDirective.prototype._validators;
    /** @type {?} */
    FormGroupDirective.prototype._asyncValidators;
}
//# sourceMappingURL=form_group_directive.js.map

/***/ }

},[888]);


// WEBPACK FOOTER //
// js/app.js